// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6.04 5.99%27%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23bec5cf;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EAsset 1%3C/title%3E%3Cg id=%27Layer_2%27 data-name=%27Layer 2%27%3E%3Cg id=%27Layer_1-2%27 data-name=%27Layer 1%27%3E%3Crect class=%27cls-1%27 x=%271.01%27 y=%273.99%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 y=%274.99%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%273.02%27 y=%272%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%272.01%27 y=%272.99%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%275.04%27 width=%271.01%27 height=%271%27/%3E%3Crect class=%27cls-1%27 x=%274.03%27 y=%271%27 width=%271.01%27 height=%271%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%2711%27 viewBox=%270 0 10 11%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M8.70383 0.5L5 4.20383L1.29617 0.5L0 1.79617L3.70386 5.5L0 9.20383L1.29617 10.5L5 6.79614L8.70383 10.5L10 9.20383L6.29617 5.5L10 1.79617L8.70383 0.5Z%27 fill=%27%238695A8%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278.07%27 height=%274.74%27 viewBox=%270 0 8.07 4.74%27%3E%3Cpolyline points=%277.57 0.5 4.04 4.04 0.5 0.5%27 fill=%27none%27 stroke=%27%236d7884%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278.07%27 height=%274.74%27 viewBox=%270 0 8.07 4.74%27%3E%3Cpolyline points=%277.57 0.5 4.04 4.04 0.5 0.5%27 fill=%27none%27 stroke=%27%23DB3434%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278.07%27 height=%274.74%27 viewBox=%270 0 8.07 4.74%27%3E%3Cpolyline points=%277.57 0.5 4.04 4.04 0.5 0.5%27 fill=%27none%27 stroke=%27%233CA854%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Ctitle%3E_%3C/title%3E%3Cpath fill=%27%23db3434%27 d=%27M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM12,4a8,8,0,1,0,8,8A8,8,0,0,0,12,4ZM11,6h2v7H11V6Zm1,11.25A1.25,1.25,0,1,1,13.25,16,1.25,1.25,0,0,1,12,17.25Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27100%27 height=%2719%27 viewBox=%270 0 100 19%27 %3E%3Cpath d=%27M0,3.5c12.5,0,12.5,12,25,12s12.5-12,25-12,12.5,12,25,12,12.5-12,25-12%27 fill=%27none%27 stroke=%27%23d2d7dd%27 stroke-miterlimit=%2710%27 stroke-width=%276%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --vl-theme-primary-color: #ffe615;
  --vl-theme-primary-color-60: rgb(100%, 94.1176470588%, 44.9411764706%);
  --vl-theme-primary-color-70: rgb(100%, 93.137254902%, 35.7647058824%);
  --vl-theme-primary-color-rgba-30: rgba(255, 230, 21, 0.3);
  --vl-theme-fg-color: #333332;
  --vl-theme-fg-color-60: rgb(52%, 52%, 51.7647058824%);
  --vl-theme-fg-color-70: rgb(44%, 44%, 43.7254901961%);
}
.vl-vi::before, .vl-vi::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: inline-block;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-180deg::before {
  display: inline-block;
  transform: rotate(180deg);
  vertical-align: middle;
}
.vl-vi-u-xs::before {
  font-size: 0.8rem;
}
.vl-vi-u-s::before {
  font-size: 1.3rem;
}
.vl-vi-u-m::before {
  font-size: 1.7rem;
}
.vl-vi-u-l::before {
  font-size: 2rem;
}
.vl-vi-u-xl::before {
  font-size: 2.2rem;
}
.vl-vi-u-90deg::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi-u-180deg::before {
  display: inline-block;
  transform: rotate(180deg);
}
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
strong {
  font-weight: 500;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
button {
  background: transparent;
}
img {
  max-width: 100%;
}
button::-moz-focus-inner {
  border: 0;
}
:-moz-submit-invalid {
  box-shadow: none;
}
:-moz-ui-invalid {
  box-shadow: none;
}
* {
  box-sizing: border-box;
}
*::before, *::after {
  box-sizing: inherit;
}
html {
  min-height: 100%;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 62.5%;
}
body {
  width: 100%;
  min-height: 100%;
  background: #fff;
  color: #333332;
  font-size: 1.8rem;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: none;
}
@media screen and (max-width: 767px) {
body {
    font-size: 1.6rem;
    line-height: 1.33;
}
}
body::before {
  display: none;
  content: "large";
}
@media screen and (max-width: 1023px) {
body::before {
    content: "medium";
}
}
@media screen and (min-width: 767px) {
body::before {
    content: "medium-up";
}
}
@media screen and (max-width: 767px) {
body::before {
    content: "small";
}
}
@media screen and (max-width: 500px) {
body::before {
    content: "xsmall";
}
}
@media screen and (min-width: 1600px) {
body::before {
    content: "xlarge";
}
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Light.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Regular.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Medium.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/sans/FlandersArtSans-Bold.woff2") format("woff2"), url("/font/flanders/sans/FlandersArtSans-Bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Light.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Light.woff") format("woff");
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Regular.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Regular.woff") format("woff");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Medium.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Medium.woff") format("woff");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Sans";
  src: url("/font/flanders/italic/FlandersArtSans-Bold.woff2") format("woff2"), url("/font/flanders/italic/FlandersArtSans-Bold.woff") format("woff");
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Light.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Regular.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Regular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Medium.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Flanders Art Serif";
  src: url("/font/flanders/serif/FlandersArtSerif-Bold.woff2") format("woff2"), url("/font/flanders/serif/FlandersArtSerif-Bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "vlaanderen-icon";
  src: url("/font/iconfont/vlaanderen-icon.woff2") format("woff2"), url("/font/iconfont/vlaanderen-icon.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
.vl-vi-add::before {
  content: "\\f101";
}
.vl-vi-add--after::after {
  content: "\\f101";
}
.vl-vi-addressbook::before {
  content: "\\f102";
}
.vl-vi-addressbook--after::after {
  content: "\\f102";
}
.vl-vi-airplane::before {
  content: "\\f103";
}
.vl-vi-airplane--after::after {
  content: "\\f103";
}
.vl-vi-alarm-silent::before {
  content: "\\f104";
}
.vl-vi-alarm-silent--after::after {
  content: "\\f104";
}
.vl-vi-alarm::before {
  content: "\\f105";
}
.vl-vi-alarm--after::after {
  content: "\\f105";
}
.vl-vi-alert-circle-filled::before {
  content: "\\f106";
}
.vl-vi-alert-circle-filled--after::after {
  content: "\\f106";
}
.vl-vi-alert-circle::before {
  content: "\\f107";
}
.vl-vi-alert-circle--after::after {
  content: "\\f107";
}
.vl-vi-alert-small::before {
  content: "\\f108";
}
.vl-vi-alert-small--after::after {
  content: "\\f108";
}
.vl-vi-alert-triangle-filled::before {
  content: "\\f109";
}
.vl-vi-alert-triangle-filled--after::after {
  content: "\\f109";
}
.vl-vi-alert-triangle::before {
  content: "\\f10a";
}
.vl-vi-alert-triangle--after::after {
  content: "\\f10a";
}
.vl-vi-align-center::before {
  content: "\\f10b";
}
.vl-vi-align-center--after::after {
  content: "\\f10b";
}
.vl-vi-align-justify::before {
  content: "\\f10c";
}
.vl-vi-align-justify--after::after {
  content: "\\f10c";
}
.vl-vi-align-left::before {
  content: "\\f10d";
}
.vl-vi-align-left--after::after {
  content: "\\f10d";
}
.vl-vi-align-right::before {
  content: "\\f10e";
}
.vl-vi-align-right--after::after {
  content: "\\f10e";
}
.vl-vi-area::before {
  content: "\\f10f";
}
.vl-vi-area--after::after {
  content: "\\f10f";
}
.vl-vi-arrange-1-to-9::before {
  content: "\\f110";
}
.vl-vi-arrange-1-to-9--after::after {
  content: "\\f110";
}
.vl-vi-arrange-9-to-1::before {
  content: "\\f111";
}
.vl-vi-arrange-9-to-1--after::after {
  content: "\\f111";
}
.vl-vi-arrange-a-to-z::before {
  content: "\\f112";
}
.vl-vi-arrange-a-to-z--after::after {
  content: "\\f112";
}
.vl-vi-arrange-amount-large-to-small::before {
  content: "\\f113";
}
.vl-vi-arrange-amount-large-to-small--after::after {
  content: "\\f113";
}
.vl-vi-arrange-amount-small-to-large::before {
  content: "\\f114";
}
.vl-vi-arrange-amount-small-to-large--after::after {
  content: "\\f114";
}
.vl-vi-arrange-z-to-a::before {
  content: "\\f115";
}
.vl-vi-arrange-z-to-a--after::after {
  content: "\\f115";
}
.vl-vi-arrow-bottom::before {
  content: "\\f116";
}
.vl-vi-arrow-bottom--after::after {
  content: "\\f116";
}
.vl-vi-arrow-down-fat::before {
  content: "\\f117";
}
.vl-vi-arrow-down-fat--after::after {
  content: "\\f117";
}
.vl-vi-arrow-down-thin::before {
  content: "\\f118";
}
.vl-vi-arrow-down-thin--after::after {
  content: "\\f118";
}
.vl-vi-arrow-down::before {
  content: "\\f119";
}
.vl-vi-arrow-down--after::after {
  content: "\\f119";
}
.vl-vi-arrow-freemove::before {
  content: "\\f11a";
}
.vl-vi-arrow-freemove--after::after {
  content: "\\f11a";
}
.vl-vi-arrow-left-fat::before {
  content: "\\f11b";
}
.vl-vi-arrow-left-fat--after::after {
  content: "\\f11b";
}
.vl-vi-arrow-left-thin::before {
  content: "\\f11c";
}
.vl-vi-arrow-left-thin--after::after {
  content: "\\f11c";
}
.vl-vi-arrow-left::before {
  content: "\\f11d";
}
.vl-vi-arrow-left--after::after {
  content: "\\f11d";
}
.vl-vi-arrow-right-fat::before {
  content: "\\f11e";
}
.vl-vi-arrow-right-fat--after::after {
  content: "\\f11e";
}
.vl-vi-arrow-right-thin::before {
  content: "\\f11f";
}
.vl-vi-arrow-right-thin--after::after {
  content: "\\f11f";
}
.vl-vi-arrow-right::before {
  content: "\\f120";
}
.vl-vi-arrow-right--after::after {
  content: "\\f120";
}
.vl-vi-arrow-thin::before {
  content: "\\f121";
}
.vl-vi-arrow-thin--after::after {
  content: "\\f121";
}
.vl-vi-arrow-up-fat::before {
  content: "\\f122";
}
.vl-vi-arrow-up-fat--after::after {
  content: "\\f122";
}
.vl-vi-arrow-up-thin::before {
  content: "\\f123";
}
.vl-vi-arrow-up-thin--after::after {
  content: "\\f123";
}
.vl-vi-arrow-up::before {
  content: "\\f124";
}
.vl-vi-arrow-up--after::after {
  content: "\\f124";
}
.vl-vi-arrow::before {
  content: "\\f125";
}
.vl-vi-arrow--after::after {
  content: "\\f125";
}
.vl-vi-asterisk::before {
  content: "\\f126";
}
.vl-vi-asterisk--after::after {
  content: "\\f126";
}
.vl-vi-audio-description::before {
  content: "\\f127";
}
.vl-vi-audio-description--after::after {
  content: "\\f127";
}
.vl-vi-back::before {
  content: "\\f128";
}
.vl-vi-back--after::after {
  content: "\\f128";
}
.vl-vi-ban::before {
  content: "\\f129";
}
.vl-vi-ban--after::after {
  content: "\\f129";
}
.vl-vi-banking-bill-euro::before {
  content: "\\f12a";
}
.vl-vi-banking-bill-euro--after::after {
  content: "\\f12a";
}
.vl-vi-battery-charging::before {
  content: "\\f12b";
}
.vl-vi-battery-charging--after::after {
  content: "\\f12b";
}
.vl-vi-bell::before {
  content: "\\f12c";
}
.vl-vi-bell--after::after {
  content: "\\f12c";
}
.vl-vi-bike-closed-criterium::before {
  content: "\\f12d";
}
.vl-vi-bike-closed-criterium--after::after {
  content: "\\f12d";
}
.vl-vi-bike-open-criterium::before {
  content: "\\f12e";
}
.vl-vi-bike-open-criterium--after::after {
  content: "\\f12e";
}
.vl-vi-bike::before {
  content: "\\f12f";
}
.vl-vi-bike--after::after {
  content: "\\f12f";
}
.vl-vi-bin::before {
  content: "\\f130";
}
.vl-vi-bin--after::after {
  content: "\\f130";
}
.vl-vi-binoculars::before {
  content: "\\f131";
}
.vl-vi-binoculars--after::after {
  content: "\\f131";
}
.vl-vi-boat-ship::before {
  content: "\\f132";
}
.vl-vi-boat-ship--after::after {
  content: "\\f132";
}
.vl-vi-bold::before {
  content: "\\f133";
}
.vl-vi-bold--after::after {
  content: "\\f133";
}
.vl-vi-book::before {
  content: "\\f134";
}
.vl-vi-book--after::after {
  content: "\\f134";
}
.vl-vi-bookmark-alt-1::before {
  content: "\\f135";
}
.vl-vi-bookmark-alt-1--after::after {
  content: "\\f135";
}
.vl-vi-bookmark-alt-2::before {
  content: "\\f136";
}
.vl-vi-bookmark-alt-2--after::after {
  content: "\\f136";
}
.vl-vi-bookmark::before {
  content: "\\f137";
}
.vl-vi-bookmark--after::after {
  content: "\\f137";
}
.vl-vi-breadcrumb-separator::before {
  content: "\\f138";
}
.vl-vi-breadcrumb-separator--after::after {
  content: "\\f138";
}
.vl-vi-briefcase::before {
  content: "\\f139";
}
.vl-vi-briefcase--after::after {
  content: "\\f139";
}
.vl-vi-building-2::before {
  content: "\\f13a";
}
.vl-vi-building-2--after::after {
  content: "\\f13a";
}
.vl-vi-building-big::before {
  content: "\\f13b";
}
.vl-vi-building-big--after::after {
  content: "\\f13b";
}
.vl-vi-building::before {
  content: "\\f13c";
}
.vl-vi-building--after::after {
  content: "\\f13c";
}
.vl-vi-bullet::before {
  content: "\\f13d";
}
.vl-vi-bullet--after::after {
  content: "\\f13d";
}
.vl-vi-burger-alt::before {
  content: "\\f13e";
}
.vl-vi-burger-alt--after::after {
  content: "\\f13e";
}
.vl-vi-burger::before {
  content: "\\f13f";
}
.vl-vi-burger--after::after {
  content: "\\f13f";
}
.vl-vi-burgerprofiel::before {
  content: "\\f140";
}
.vl-vi-burgerprofiel--after::after {
  content: "\\f140";
}
.vl-vi-bus::before {
  content: "\\f141";
}
.vl-vi-bus--after::after {
  content: "\\f141";
}
.vl-vi-business-graph-bar::before {
  content: "\\f142";
}
.vl-vi-business-graph-bar--after::after {
  content: "\\f142";
}
.vl-vi-business-graph-pie::before {
  content: "\\f143";
}
.vl-vi-business-graph-pie--after::after {
  content: "\\f143";
}
.vl-vi-cabinet::before {
  content: "\\f144";
}
.vl-vi-cabinet--after::after {
  content: "\\f144";
}
.vl-vi-cake::before {
  content: "\\f145";
}
.vl-vi-cake--after::after {
  content: "\\f145";
}
.vl-vi-calculator::before {
  content: "\\f146";
}
.vl-vi-calculator--after::after {
  content: "\\f146";
}
.vl-vi-calendar-add::before {
  content: "\\f147";
}
.vl-vi-calendar-add--after::after {
  content: "\\f147";
}
.vl-vi-calendar-check::before {
  content: "\\f148";
}
.vl-vi-calendar-check--after::after {
  content: "\\f148";
}
.vl-vi-calendar-subtract::before {
  content: "\\f149";
}
.vl-vi-calendar-subtract--after::after {
  content: "\\f149";
}
.vl-vi-calendar::before {
  content: "\\f14a";
}
.vl-vi-calendar--after::after {
  content: "\\f14a";
}
.vl-vi-calendar_check::before {
  content: "\\f14b";
}
.vl-vi-calendar_check--after::after {
  content: "\\f14b";
}
.vl-vi-calendar_date::before {
  content: "\\f14c";
}
.vl-vi-calendar_date--after::after {
  content: "\\f14c";
}
.vl-vi-camera::before {
  content: "\\f14d";
}
.vl-vi-camera--after::after {
  content: "\\f14d";
}
.vl-vi-car-wheel::before {
  content: "\\f14e";
}
.vl-vi-car-wheel--after::after {
  content: "\\f14e";
}
.vl-vi-car::before {
  content: "\\f14f";
}
.vl-vi-car--after::after {
  content: "\\f14f";
}
.vl-vi-chat-bubble-square-alert::before {
  content: "\\f150";
}
.vl-vi-chat-bubble-square-alert--after::after {
  content: "\\f150";
}
.vl-vi-chat-bubble-square-alt::before {
  content: "\\f151";
}
.vl-vi-chat-bubble-square-alt--after::after {
  content: "\\f151";
}
.vl-vi-chat-bubble-square::before {
  content: "\\f152";
}
.vl-vi-chat-bubble-square--after::after {
  content: "\\f152";
}
.vl-vi-chat-help::before {
  content: "\\f153";
}
.vl-vi-chat-help--after::after {
  content: "\\f153";
}
.vl-vi-chat::before {
  content: "\\f154";
}
.vl-vi-chat--after::after {
  content: "\\f154";
}
.vl-vi-check-circle::before {
  content: "\\f155";
}
.vl-vi-check-circle--after::after {
  content: "\\f155";
}
.vl-vi-check-filled::before {
  content: "\\f156";
}
.vl-vi-check-filled--after::after {
  content: "\\f156";
}
.vl-vi-check-naked::before {
  content: "\\f157";
}
.vl-vi-check-naked--after::after {
  content: "\\f157";
}
.vl-vi-check-small::before {
  content: "\\f158";
}
.vl-vi-check-small--after::after {
  content: "\\f158";
}
.vl-vi-check-thin::before {
  content: "\\f159";
}
.vl-vi-check-thin--after::after {
  content: "\\f159";
}
.vl-vi-check::before {
  content: "\\f15a";
}
.vl-vi-check--after::after {
  content: "\\f15a";
}
.vl-vi-child::before {
  content: "\\f15b";
}
.vl-vi-child--after::after {
  content: "\\f15b";
}
.vl-vi-clock::before {
  content: "\\f15c";
}
.vl-vi-clock--after::after {
  content: "\\f15c";
}
.vl-vi-close-filled::before {
  content: "\\f15d";
}
.vl-vi-close-filled--after::after {
  content: "\\f15d";
}
.vl-vi-close-light::before {
  content: "\\f15e";
}
.vl-vi-close-light--after::after {
  content: "\\f15e";
}
.vl-vi-close-naked::before {
  content: "\\f15f";
}
.vl-vi-close-naked--after::after {
  content: "\\f15f";
}
.vl-vi-close::before {
  content: "\\f160";
}
.vl-vi-close--after::after {
  content: "\\f160";
}
.vl-vi-cloud-download::before {
  content: "\\f161";
}
.vl-vi-cloud-download--after::after {
  content: "\\f161";
}
.vl-vi-cloud-upload::before {
  content: "\\f162";
}
.vl-vi-cloud-upload--after::after {
  content: "\\f162";
}
.vl-vi-cloud::before {
  content: "\\f163";
}
.vl-vi-cloud--after::after {
  content: "\\f163";
}
.vl-vi-code-branch::before {
  content: "\\f164";
}
.vl-vi-code-branch--after::after {
  content: "\\f164";
}
.vl-vi-coffee-cup::before {
  content: "\\f165";
}
.vl-vi-coffee-cup--after::after {
  content: "\\f165";
}
.vl-vi-cog::before {
  content: "\\f166";
}
.vl-vi-cog--after::after {
  content: "\\f166";
}
.vl-vi-coin-stack::before {
  content: "\\f167";
}
.vl-vi-coin-stack--after::after {
  content: "\\f167";
}
.vl-vi-compass::before {
  content: "\\f168";
}
.vl-vi-compass--after::after {
  content: "\\f168";
}
.vl-vi-computer-screen::before {
  content: "\\f169";
}
.vl-vi-computer-screen--after::after {
  content: "\\f169";
}
.vl-vi-confluence::before {
  content: "\\f16a";
}
.vl-vi-confluence--after::after {
  content: "\\f16a";
}
.vl-vi-construction-crane::before {
  content: "\\f16b";
}
.vl-vi-construction-crane--after::after {
  content: "\\f16b";
}
.vl-vi-construction-shack::before {
  content: "\\f16c";
}
.vl-vi-construction-shack--after::after {
  content: "\\f16c";
}
.vl-vi-contactbook::before {
  content: "\\f16d";
}
.vl-vi-contactbook--after::after {
  content: "\\f16d";
}
.vl-vi-contacts::before {
  content: "\\f16e";
}
.vl-vi-contacts--after::after {
  content: "\\f16e";
}
.vl-vi-content-book-favorite-star::before {
  content: "\\f16f";
}
.vl-vi-content-book-favorite-star--after::after {
  content: "\\f16f";
}
.vl-vi-content-book::before {
  content: "\\f170";
}
.vl-vi-content-book--after::after {
  content: "\\f170";
}
.vl-vi-content-box::before {
  content: "\\f171";
}
.vl-vi-content-box--after::after {
  content: "\\f171";
}
.vl-vi-content-filter::before {
  content: "\\f172";
}
.vl-vi-content-filter--after::after {
  content: "\\f172";
}
.vl-vi-content-layers-hide::before {
  content: "\\f173";
}
.vl-vi-content-layers-hide--after::after {
  content: "\\f173";
}
.vl-vi-content-layers-show::before {
  content: "\\f174";
}
.vl-vi-content-layers-show--after::after {
  content: "\\f174";
}
.vl-vi-content-note::before {
  content: "\\f175";
}
.vl-vi-content-note--after::after {
  content: "\\f175";
}
.vl-vi-content-view-column::before {
  content: "\\f176";
}
.vl-vi-content-view-column--after::after {
  content: "\\f176";
}
.vl-vi-content-view-module::before {
  content: "\\f177";
}
.vl-vi-content-view-module--after::after {
  content: "\\f177";
}
.vl-vi-contract::before {
  content: "\\f178";
}
.vl-vi-contract--after::after {
  content: "\\f178";
}
.vl-vi-control-cross-over::before {
  content: "\\f179";
}
.vl-vi-control-cross-over--after::after {
  content: "\\f179";
}
.vl-vi-copy-paste::before {
  content: "\\f17a";
}
.vl-vi-copy-paste--after::after {
  content: "\\f17a";
}
.vl-vi-copyright::before {
  content: "\\f17b";
}
.vl-vi-copyright--after::after {
  content: "\\f17b";
}
.vl-vi-credit-card::before {
  content: "\\f17c";
}
.vl-vi-credit-card--after::after {
  content: "\\f17c";
}
.vl-vi-crop::before {
  content: "\\f17d";
}
.vl-vi-crop--after::after {
  content: "\\f17d";
}
.vl-vi-cross-thin::before {
  content: "\\f17e";
}
.vl-vi-cross-thin--after::after {
  content: "\\f17e";
}
.vl-vi-cross::before {
  content: "\\f17f";
}
.vl-vi-cross--after::after {
  content: "\\f17f";
}
.vl-vi-cursor-arrow-big::before {
  content: "\\f180";
}
.vl-vi-cursor-arrow-big--after::after {
  content: "\\f180";
}
.vl-vi-cursor-arrow-small::before {
  content: "\\f181";
}
.vl-vi-cursor-arrow-small--after::after {
  content: "\\f181";
}
.vl-vi-cursor-finger-down::before {
  content: "\\f182";
}
.vl-vi-cursor-finger-down--after::after {
  content: "\\f182";
}
.vl-vi-cursor-finger-left::before {
  content: "\\f183";
}
.vl-vi-cursor-finger-left--after::after {
  content: "\\f183";
}
.vl-vi-cursor-finger-right::before {
  content: "\\f184";
}
.vl-vi-cursor-finger-right--after::after {
  content: "\\f184";
}
.vl-vi-cursor-finger-up::before {
  content: "\\f185";
}
.vl-vi-cursor-finger-up--after::after {
  content: "\\f185";
}
.vl-vi-cursor-hand::before {
  content: "\\f186";
}
.vl-vi-cursor-hand--after::after {
  content: "\\f186";
}
.vl-vi-cursor-hold::before {
  content: "\\f187";
}
.vl-vi-cursor-hold--after::after {
  content: "\\f187";
}
.vl-vi-dashboard::before {
  content: "\\f188";
}
.vl-vi-dashboard--after::after {
  content: "\\f188";
}
.vl-vi-data-download::before {
  content: "\\f189";
}
.vl-vi-data-download--after::after {
  content: "\\f189";
}
.vl-vi-data-transfer::before {
  content: "\\f18a";
}
.vl-vi-data-transfer--after::after {
  content: "\\f18a";
}
.vl-vi-data-upload::before {
  content: "\\f18b";
}
.vl-vi-data-upload--after::after {
  content: "\\f18b";
}
.vl-vi-demonstration::before {
  content: "\\f18c";
}
.vl-vi-demonstration--after::after {
  content: "\\f18c";
}
.vl-vi-diagram::before {
  content: "\\f18d";
}
.vl-vi-diagram--after::after {
  content: "\\f18d";
}
.vl-vi-direction-sign::before {
  content: "\\f18e";
}
.vl-vi-direction-sign--after::after {
  content: "\\f18e";
}
.vl-vi-document-small::before {
  content: "\\f18f";
}
.vl-vi-document-small--after::after {
  content: "\\f18f";
}
.vl-vi-document::before {
  content: "\\f190";
}
.vl-vi-document--after::after {
  content: "\\f190";
}
.vl-vi-double-arrow::before {
  content: "\\f191";
}
.vl-vi-double-arrow--after::after {
  content: "\\f191";
}
.vl-vi-download-harddisk::before {
  content: "\\f192";
}
.vl-vi-download-harddisk--after::after {
  content: "\\f192";
}
.vl-vi-drawer-down::before {
  content: "\\f193";
}
.vl-vi-drawer-down--after::after {
  content: "\\f193";
}
.vl-vi-drawer::before {
  content: "\\f194";
}
.vl-vi-drawer--after::after {
  content: "\\f194";
}
.vl-vi-drink-bottle::before {
  content: "\\f195";
}
.vl-vi-drink-bottle--after::after {
  content: "\\f195";
}
.vl-vi-eco-throw-trash::before {
  content: "\\f196";
}
.vl-vi-eco-throw-trash--after::after {
  content: "\\f196";
}
.vl-vi-edit::before {
  content: "\\f197";
}
.vl-vi-edit--after::after {
  content: "\\f197";
}
.vl-vi-eloket::before {
  content: "\\f198";
}
.vl-vi-eloket--after::after {
  content: "\\f198";
}
.vl-vi-email-read::before {
  content: "\\f199";
}
.vl-vi-email-read--after::after {
  content: "\\f199";
}
.vl-vi-email::before {
  content: "\\f19a";
}
.vl-vi-email--after::after {
  content: "\\f19a";
}
.vl-vi-enlarge::before {
  content: "\\f19b";
}
.vl-vi-enlarge--after::after {
  content: "\\f19b";
}
.vl-vi-envelope::before {
  content: "\\f19c";
}
.vl-vi-envelope--after::after {
  content: "\\f19c";
}
.vl-vi-expand-horizontal-alt::before {
  content: "\\f19d";
}
.vl-vi-expand-horizontal-alt--after::after {
  content: "\\f19d";
}
.vl-vi-expand-horizontal::before {
  content: "\\f19e";
}
.vl-vi-expand-horizontal--after::after {
  content: "\\f19e";
}
.vl-vi-expand-vertical::before {
  content: "\\f19f";
}
.vl-vi-expand-vertical--after::after {
  content: "\\f19f";
}
.vl-vi-expand::before {
  content: "\\f1a0";
}
.vl-vi-expand--after::after {
  content: "\\f1a0";
}
.vl-vi-external::before {
  content: "\\f1a1";
}
.vl-vi-external--after::after {
  content: "\\f1a1";
}
.vl-vi-face-id::before {
  content: "\\f1a2";
}
.vl-vi-face-id--after::after {
  content: "\\f1a2";
}
.vl-vi-facebook::before {
  content: "\\f1a3";
}
.vl-vi-facebook--after::after {
  content: "\\f1a3";
}
.vl-vi-faq::before {
  content: "\\f1a4";
}
.vl-vi-faq--after::after {
  content: "\\f1a4";
}
.vl-vi-fastback::before {
  content: "\\f1a5";
}
.vl-vi-fastback--after::after {
  content: "\\f1a5";
}
.vl-vi-fastforward::before {
  content: "\\f1a6";
}
.vl-vi-fastforward--after::after {
  content: "\\f1a6";
}
.vl-vi-fax::before {
  content: "\\f1a7";
}
.vl-vi-fax--after::after {
  content: "\\f1a7";
}
.vl-vi-field::before {
  content: "\\f1a8";
}
.vl-vi-field--after::after {
  content: "\\f1a8";
}
.vl-vi-file-audio::before {
  content: "\\f1a9";
}
.vl-vi-file-audio--after::after {
  content: "\\f1a9";
}
.vl-vi-file-copy::before {
  content: "\\f1aa";
}
.vl-vi-file-copy--after::after {
  content: "\\f1aa";
}
.vl-vi-file-download::before {
  content: "\\f1ab";
}
.vl-vi-file-download--after::after {
  content: "\\f1ab";
}
.vl-vi-file-edit::before {
  content: "\\f1ac";
}
.vl-vi-file-edit--after::after {
  content: "\\f1ac";
}
.vl-vi-file-image::before {
  content: "\\f1ad";
}
.vl-vi-file-image--after::after {
  content: "\\f1ad";
}
.vl-vi-file-new::before {
  content: "\\f1ae";
}
.vl-vi-file-new--after::after {
  content: "\\f1ae";
}
.vl-vi-file-office-doc::before {
  content: "\\f1af";
}
.vl-vi-file-office-doc--after::after {
  content: "\\f1af";
}
.vl-vi-file-office-pdf::before {
  content: "\\f1b0";
}
.vl-vi-file-office-pdf--after::after {
  content: "\\f1b0";
}
.vl-vi-file-office-ppt::before {
  content: "\\f1b1";
}
.vl-vi-file-office-ppt--after::after {
  content: "\\f1b1";
}
.vl-vi-file-office-xls::before {
  content: "\\f1b2";
}
.vl-vi-file-office-xls--after::after {
  content: "\\f1b2";
}
.vl-vi-file-swap::before {
  content: "\\f1b3";
}
.vl-vi-file-swap--after::after {
  content: "\\f1b3";
}
.vl-vi-file-tasks-check::before {
  content: "\\f1b4";
}
.vl-vi-file-tasks-check--after::after {
  content: "\\f1b4";
}
.vl-vi-file-upload::before {
  content: "\\f1b5";
}
.vl-vi-file-upload--after::after {
  content: "\\f1b5";
}
.vl-vi-file-video::before {
  content: "\\f1b6";
}
.vl-vi-file-video--after::after {
  content: "\\f1b6";
}
.vl-vi-file-zipped-new::before {
  content: "\\f1b7";
}
.vl-vi-file-zipped-new--after::after {
  content: "\\f1b7";
}
.vl-vi-file-zipped-vice::before {
  content: "\\f1b8";
}
.vl-vi-file-zipped-vice--after::after {
  content: "\\f1b8";
}
.vl-vi-file::before {
  content: "\\f1b9";
}
.vl-vi-file--after::after {
  content: "\\f1b9";
}
.vl-vi-files-coding::before {
  content: "\\f1ba";
}
.vl-vi-files-coding--after::after {
  content: "\\f1ba";
}
.vl-vi-film::before {
  content: "\\f1bb";
}
.vl-vi-film--after::after {
  content: "\\f1bb";
}
.vl-vi-fingerprint::before {
  content: "\\f1bc";
}
.vl-vi-fingerprint--after::after {
  content: "\\f1bc";
}
.vl-vi-flickr::before {
  content: "\\f1bd";
}
.vl-vi-flickr--after::after {
  content: "\\f1bd";
}
.vl-vi-focus::before {
  content: "\\f1be";
}
.vl-vi-focus--after::after {
  content: "\\f1be";
}
.vl-vi-folder::before {
  content: "\\f1bf";
}
.vl-vi-folder--after::after {
  content: "\\f1bf";
}
.vl-vi-font::before {
  content: "\\f1c0";
}
.vl-vi-font--after::after {
  content: "\\f1c0";
}
.vl-vi-food-apple::before {
  content: "\\f1c1";
}
.vl-vi-food-apple--after::after {
  content: "\\f1c1";
}
.vl-vi-food-grain::before {
  content: "\\f1c2";
}
.vl-vi-food-grain--after::after {
  content: "\\f1c2";
}
.vl-vi-gender-female-male::before {
  content: "\\f1c3";
}
.vl-vi-gender-female-male--after::after {
  content: "\\f1c3";
}
.vl-vi-gender-female::before {
  content: "\\f1c4";
}
.vl-vi-gender-female--after::after {
  content: "\\f1c4";
}
.vl-vi-gender-male::before {
  content: "\\f1c5";
}
.vl-vi-gender-male--after::after {
  content: "\\f1c5";
}
.vl-vi-gender-transgender::before {
  content: "\\f1c6";
}
.vl-vi-gender-transgender--after::after {
  content: "\\f1c6";
}
.vl-vi-globe-alt::before {
  content: "\\f1c7";
}
.vl-vi-globe-alt--after::after {
  content: "\\f1c7";
}
.vl-vi-globe::before {
  content: "\\f1c8";
}
.vl-vi-globe--after::after {
  content: "\\f1c8";
}
.vl-vi-googleplus::before {
  content: "\\f1c9";
}
.vl-vi-googleplus--after::after {
  content: "\\f1c9";
}
.vl-vi-graduate::before {
  content: "\\f1ca";
}
.vl-vi-graduate--after::after {
  content: "\\f1ca";
}
.vl-vi-graduation-hat::before {
  content: "\\f1cb";
}
.vl-vi-graduation-hat--after::after {
  content: "\\f1cb";
}
.vl-vi-hammer-anvil::before {
  content: "\\f1cc";
}
.vl-vi-hammer-anvil--after::after {
  content: "\\f1cc";
}
.vl-vi-hammer::before {
  content: "\\f1cd";
}
.vl-vi-hammer--after::after {
  content: "\\f1cd";
}
.vl-vi-hand-hint::before {
  content: "\\f1ce";
}
.vl-vi-hand-hint--after::after {
  content: "\\f1ce";
}
.vl-vi-harddisk::before {
  content: "\\f1cf";
}
.vl-vi-harddisk--after::after {
  content: "\\f1cf";
}
.vl-vi-headphone::before {
  content: "\\f1d0";
}
.vl-vi-headphone--after::after {
  content: "\\f1d0";
}
.vl-vi-health-first-aid-kit::before {
  content: "\\f1d1";
}
.vl-vi-health-first-aid-kit--after::after {
  content: "\\f1d1";
}
.vl-vi-health-heart-pulse::before {
  content: "\\f1d2";
}
.vl-vi-health-heart-pulse--after::after {
  content: "\\f1d2";
}
.vl-vi-health-hospital::before {
  content: "\\f1d3";
}
.vl-vi-health-hospital--after::after {
  content: "\\f1d3";
}
.vl-vi-hide::before {
  content: "\\f1d4";
}
.vl-vi-hide--after::after {
  content: "\\f1d4";
}
.vl-vi-hierarchy::before {
  content: "\\f1d5";
}
.vl-vi-hierarchy--after::after {
  content: "\\f1d5";
}
.vl-vi-hotel-bath-shower::before {
  content: "\\f1d6";
}
.vl-vi-hotel-bath-shower--after::after {
  content: "\\f1d6";
}
.vl-vi-hotel-bed::before {
  content: "\\f1d7";
}
.vl-vi-hotel-bed--after::after {
  content: "\\f1d7";
}
.vl-vi-hotel-fire-alarm::before {
  content: "\\f1d8";
}
.vl-vi-hotel-fire-alarm--after::after {
  content: "\\f1d8";
}
.vl-vi-hotel-shower::before {
  content: "\\f1d9";
}
.vl-vi-hotel-shower--after::after {
  content: "\\f1d9";
}
.vl-vi-hourglass::before {
  content: "\\f1da";
}
.vl-vi-hourglass--after::after {
  content: "\\f1da";
}
.vl-vi-id-card::before {
  content: "\\f1db";
}
.vl-vi-id-card--after::after {
  content: "\\f1db";
}
.vl-vi-id::before {
  content: "\\f1dc";
}
.vl-vi-id--after::after {
  content: "\\f1dc";
}
.vl-vi-images-copy::before {
  content: "\\f1dd";
}
.vl-vi-images-copy--after::after {
  content: "\\f1dd";
}
.vl-vi-images::before {
  content: "\\f1de";
}
.vl-vi-images--after::after {
  content: "\\f1de";
}
.vl-vi-inbox::before {
  content: "\\f1df";
}
.vl-vi-inbox--after::after {
  content: "\\f1df";
}
.vl-vi-indent-left::before {
  content: "\\f1e0";
}
.vl-vi-indent-left--after::after {
  content: "\\f1e0";
}
.vl-vi-indent-right::before {
  content: "\\f1e1";
}
.vl-vi-indent-right--after::after {
  content: "\\f1e1";
}
.vl-vi-info-circle::before {
  content: "\\f1e2";
}
.vl-vi-info-circle--after::after {
  content: "\\f1e2";
}
.vl-vi-info-filled::before {
  content: "\\f1e3";
}
.vl-vi-info-filled--after::after {
  content: "\\f1e3";
}
.vl-vi-info-naked::before {
  content: "\\f1e4";
}
.vl-vi-info-naked--after::after {
  content: "\\f1e4";
}
.vl-vi-info::before {
  content: "\\f1e5";
}
.vl-vi-info--after::after {
  content: "\\f1e5";
}
.vl-vi-instagram::before {
  content: "\\f1e6";
}
.vl-vi-instagram--after::after {
  content: "\\f1e6";
}
.vl-vi-ironing::before {
  content: "\\f1e7";
}
.vl-vi-ironing--after::after {
  content: "\\f1e7";
}
.vl-vi-italic::before {
  content: "\\f1e8";
}
.vl-vi-italic--after::after {
  content: "\\f1e8";
}
.vl-vi-jira::before {
  content: "\\f1e9";
}
.vl-vi-jira--after::after {
  content: "\\f1e9";
}
.vl-vi-key::before {
  content: "\\f1ea";
}
.vl-vi-key--after::after {
  content: "\\f1ea";
}
.vl-vi-keyboard::before {
  content: "\\f1eb";
}
.vl-vi-keyboard--after::after {
  content: "\\f1eb";
}
.vl-vi-laptop::before {
  content: "\\f1ec";
}
.vl-vi-laptop--after::after {
  content: "\\f1ec";
}
.vl-vi-leisure-ticket::before {
  content: "\\f1ed";
}
.vl-vi-leisure-ticket--after::after {
  content: "\\f1ed";
}
.vl-vi-lightbulb::before {
  content: "\\f1ee";
}
.vl-vi-lightbulb--after::after {
  content: "\\f1ee";
}
.vl-vi-link-broken::before {
  content: "\\f1ef";
}
.vl-vi-link-broken--after::after {
  content: "\\f1ef";
}
.vl-vi-link::before {
  content: "\\f1f0";
}
.vl-vi-link--after::after {
  content: "\\f1f0";
}
.vl-vi-linkedin::before {
  content: "\\f1f1";
}
.vl-vi-linkedin--after::after {
  content: "\\f1f1";
}
.vl-vi-list-add::before {
  content: "\\f1f2";
}
.vl-vi-list-add--after::after {
  content: "\\f1f2";
}
.vl-vi-list-bullets-alt::before {
  content: "\\f1f3";
}
.vl-vi-list-bullets-alt--after::after {
  content: "\\f1f3";
}
.vl-vi-list-bullets::before {
  content: "\\f1f4";
}
.vl-vi-list-bullets--after::after {
  content: "\\f1f4";
}
.vl-vi-list-numbers::before {
  content: "\\f1f5";
}
.vl-vi-list-numbers--after::after {
  content: "\\f1f5";
}
.vl-vi-list::before {
  content: "\\f1f6";
}
.vl-vi-list--after::after {
  content: "\\f1f6";
}
.vl-vi-loader::before {
  content: "\\f1f7";
}
.vl-vi-loader--after::after {
  content: "\\f1f7";
}
.vl-vi-location-direction-arrow::before {
  content: "\\f1f8";
}
.vl-vi-location-direction-arrow--after::after {
  content: "\\f1f8";
}
.vl-vi-location-gps::before {
  content: "\\f1f9";
}
.vl-vi-location-gps--after::after {
  content: "\\f1f9";
}
.vl-vi-location-map::before {
  content: "\\f1fa";
}
.vl-vi-location-map--after::after {
  content: "\\f1fa";
}
.vl-vi-location::before {
  content: "\\f1fb";
}
.vl-vi-location--after::after {
  content: "\\f1fb";
}
.vl-vi-lock-unlock::before {
  content: "\\f1fc";
}
.vl-vi-lock-unlock--after::after {
  content: "\\f1fc";
}
.vl-vi-lock::before {
  content: "\\f1fd";
}
.vl-vi-lock--after::after {
  content: "\\f1fd";
}
.vl-vi-login::before {
  content: "\\f1fe";
}
.vl-vi-login--after::after {
  content: "\\f1fe";
}
.vl-vi-logout::before {
  content: "\\f1ff";
}
.vl-vi-logout--after::after {
  content: "\\f1ff";
}
.vl-vi-long-arrow::before {
  content: "\\f200";
}
.vl-vi-long-arrow--after::after {
  content: "\\f200";
}
.vl-vi-magic-wand::before {
  content: "\\f201";
}
.vl-vi-magic-wand--after::after {
  content: "\\f201";
}
.vl-vi-magnifier::before {
  content: "\\f202";
}
.vl-vi-magnifier--after::after {
  content: "\\f202";
}
.vl-vi-mail::before {
  content: "\\f203";
}
.vl-vi-mail--after::after {
  content: "\\f203";
}
.vl-vi-market::before {
  content: "\\f204";
}
.vl-vi-market--after::after {
  content: "\\f204";
}
.vl-vi-menu::before {
  content: "\\f205";
}
.vl-vi-menu--after::after {
  content: "\\f205";
}
.vl-vi-messenger::before {
  content: "\\f206";
}
.vl-vi-messenger--after::after {
  content: "\\f206";
}
.vl-vi-microphone-off::before {
  content: "\\f207";
}
.vl-vi-microphone-off--after::after {
  content: "\\f207";
}
.vl-vi-microphone::before {
  content: "\\f208";
}
.vl-vi-microphone--after::after {
  content: "\\f208";
}
.vl-vi-milk-carton::before {
  content: "\\f209";
}
.vl-vi-milk-carton--after::after {
  content: "\\f209";
}
.vl-vi-minus-circle::before {
  content: "\\f20a";
}
.vl-vi-minus-circle--after::after {
  content: "\\f20a";
}
.vl-vi-minus::before {
  content: "\\f20b";
}
.vl-vi-minus--after::after {
  content: "\\f20b";
}
.vl-vi-mobile-phone::before {
  content: "\\f20c";
}
.vl-vi-mobile-phone--after::after {
  content: "\\f20c";
}
.vl-vi-money-note::before {
  content: "\\f20d";
}
.vl-vi-money-note--after::after {
  content: "\\f20d";
}
.vl-vi-move-down::before {
  content: "\\f20e";
}
.vl-vi-move-down--after::after {
  content: "\\f20e";
}
.vl-vi-move-left-right::before {
  content: "\\f20f";
}
.vl-vi-move-left-right--after::after {
  content: "\\f20f";
}
.vl-vi-move-up::before {
  content: "\\f210";
}
.vl-vi-move-up--after::after {
  content: "\\f210";
}
.vl-vi-moving-elevator::before {
  content: "\\f211";
}
.vl-vi-moving-elevator--after::after {
  content: "\\f211";
}
.vl-vi-music-note::before {
  content: "\\f212";
}
.vl-vi-music-note--after::after {
  content: "\\f212";
}
.vl-vi-nature-leaf::before {
  content: "\\f213";
}
.vl-vi-nature-leaf--after::after {
  content: "\\f213";
}
.vl-vi-nature-tree::before {
  content: "\\f214";
}
.vl-vi-nature-tree--after::after {
  content: "\\f214";
}
.vl-vi-nav-down-double::before {
  content: "\\f215";
}
.vl-vi-nav-down-double--after::after {
  content: "\\f215";
}
.vl-vi-nav-down-light::before {
  content: "\\f216";
}
.vl-vi-nav-down-light--after::after {
  content: "\\f216";
}
.vl-vi-nav-down::before {
  content: "\\f217";
}
.vl-vi-nav-down--after::after {
  content: "\\f217";
}
.vl-vi-nav-left-double::before {
  content: "\\f218";
}
.vl-vi-nav-left-double--after::after {
  content: "\\f218";
}
.vl-vi-nav-left-light::before {
  content: "\\f219";
}
.vl-vi-nav-left-light--after::after {
  content: "\\f219";
}
.vl-vi-nav-left::before {
  content: "\\f21a";
}
.vl-vi-nav-left--after::after {
  content: "\\f21a";
}
.vl-vi-nav-right-double::before {
  content: "\\f21b";
}
.vl-vi-nav-right-double--after::after {
  content: "\\f21b";
}
.vl-vi-nav-right-light::before {
  content: "\\f21c";
}
.vl-vi-nav-right-light--after::after {
  content: "\\f21c";
}
.vl-vi-nav-right::before {
  content: "\\f21d";
}
.vl-vi-nav-right--after::after {
  content: "\\f21d";
}
.vl-vi-nav-show-more-horizontal::before {
  content: "\\f21e";
}
.vl-vi-nav-show-more-horizontal--after::after {
  content: "\\f21e";
}
.vl-vi-nav-show-more-vertical::before {
  content: "\\f21f";
}
.vl-vi-nav-show-more-vertical--after::after {
  content: "\\f21f";
}
.vl-vi-nav-up-double::before {
  content: "\\f220";
}
.vl-vi-nav-up-double--after::after {
  content: "\\f220";
}
.vl-vi-nav-up-light::before {
  content: "\\f221";
}
.vl-vi-nav-up-light--after::after {
  content: "\\f221";
}
.vl-vi-nav-up::before {
  content: "\\f222";
}
.vl-vi-nav-up--after::after {
  content: "\\f222";
}
.vl-vi-news::before {
  content: "\\f223";
}
.vl-vi-news--after::after {
  content: "\\f223";
}
.vl-vi-newsletter::before {
  content: "\\f224";
}
.vl-vi-newsletter--after::after {
  content: "\\f224";
}
.vl-vi-newspaper::before {
  content: "\\f225";
}
.vl-vi-newspaper--after::after {
  content: "\\f225";
}
.vl-vi-next::before {
  content: "\\f226";
}
.vl-vi-next--after::after {
  content: "\\f226";
}
.vl-vi-organization-network::before {
  content: "\\f227";
}
.vl-vi-organization-network--after::after {
  content: "\\f227";
}
.vl-vi-other-annoyances-alt::before {
  content: "\\f228";
}
.vl-vi-other-annoyances-alt--after::after {
  content: "\\f228";
}
.vl-vi-other-annoyances::before {
  content: "\\f229";
}
.vl-vi-other-annoyances--after::after {
  content: "\\f229";
}
.vl-vi-paint-brush::before {
  content: "\\f22a";
}
.vl-vi-paint-brush--after::after {
  content: "\\f22a";
}
.vl-vi-paper::before {
  content: "\\f22b";
}
.vl-vi-paper--after::after {
  content: "\\f22b";
}
.vl-vi-paperclip::before {
  content: "\\f22c";
}
.vl-vi-paperclip--after::after {
  content: "\\f22c";
}
.vl-vi-paperplane::before {
  content: "\\f22d";
}
.vl-vi-paperplane--after::after {
  content: "\\f22d";
}
.vl-vi-paragraph::before {
  content: "\\f22e";
}
.vl-vi-paragraph--after::after {
  content: "\\f22e";
}
.vl-vi-pause::before {
  content: "\\f22f";
}
.vl-vi-pause--after::after {
  content: "\\f22f";
}
.vl-vi-pencil-ruler::before {
  content: "\\f230";
}
.vl-vi-pencil-ruler--after::after {
  content: "\\f230";
}
.vl-vi-pencil-write::before {
  content: "\\f231";
}
.vl-vi-pencil-write--after::after {
  content: "\\f231";
}
.vl-vi-pencil::before {
  content: "\\f232";
}
.vl-vi-pencil--after::after {
  content: "\\f232";
}
.vl-vi-pennants::before {
  content: "\\f233";
}
.vl-vi-pennants--after::after {
  content: "\\f233";
}
.vl-vi-phone-incoming::before {
  content: "\\f234";
}
.vl-vi-phone-incoming--after::after {
  content: "\\f234";
}
.vl-vi-phone-off::before {
  content: "\\f235";
}
.vl-vi-phone-off--after::after {
  content: "\\f235";
}
.vl-vi-phone-outgoing::before {
  content: "\\f236";
}
.vl-vi-phone-outgoing--after::after {
  content: "\\f236";
}
.vl-vi-phone-record::before {
  content: "\\f237";
}
.vl-vi-phone-record--after::after {
  content: "\\f237";
}
.vl-vi-phone-signal-low::before {
  content: "\\f238";
}
.vl-vi-phone-signal-low--after::after {
  content: "\\f238";
}
.vl-vi-phone-speaker::before {
  content: "\\f239";
}
.vl-vi-phone-speaker--after::after {
  content: "\\f239";
}
.vl-vi-phone::before {
  content: "\\f23a";
}
.vl-vi-phone--after::after {
  content: "\\f23a";
}
.vl-vi-pick-up::before {
  content: "\\f23b";
}
.vl-vi-pick-up--after::after {
  content: "\\f23b";
}
.vl-vi-pin-paper::before {
  content: "\\f23c";
}
.vl-vi-pin-paper--after::after {
  content: "\\f23c";
}
.vl-vi-pin::before {
  content: "\\f23d";
}
.vl-vi-pin--after::after {
  content: "\\f23d";
}
.vl-vi-pinterest::before {
  content: "\\f23e";
}
.vl-vi-pinterest--after::after {
  content: "\\f23e";
}
.vl-vi-places-factory::before {
  content: "\\f23f";
}
.vl-vi-places-factory--after::after {
  content: "\\f23f";
}
.vl-vi-places-home::before {
  content: "\\f240";
}
.vl-vi-places-home--after::after {
  content: "\\f240";
}
.vl-vi-play::before {
  content: "\\f241";
}
.vl-vi-play--after::after {
  content: "\\f241";
}
.vl-vi-playstreet::before {
  content: "\\f242";
}
.vl-vi-playstreet--after::after {
  content: "\\f242";
}
.vl-vi-plug::before {
  content: "\\f243";
}
.vl-vi-plug--after::after {
  content: "\\f243";
}
.vl-vi-plus-circle-filled::before {
  content: "\\f244";
}
.vl-vi-plus-circle-filled--after::after {
  content: "\\f244";
}
.vl-vi-plus-circle::before {
  content: "\\f245";
}
.vl-vi-plus-circle--after::after {
  content: "\\f245";
}
.vl-vi-plus-naked::before {
  content: "\\f246";
}
.vl-vi-plus-naked--after::after {
  content: "\\f246";
}
.vl-vi-plus::before {
  content: "\\f247";
}
.vl-vi-plus--after::after {
  content: "\\f247";
}
.vl-vi-power-button::before {
  content: "\\f248";
}
.vl-vi-power-button--after::after {
  content: "\\f248";
}
.vl-vi-printer-view::before {
  content: "\\f249";
}
.vl-vi-printer-view--after::after {
  content: "\\f249";
}
.vl-vi-printer::before {
  content: "\\f24a";
}
.vl-vi-printer--after::after {
  content: "\\f24a";
}
.vl-vi-profile-active::before {
  content: "\\f24b";
}
.vl-vi-profile-active--after::after {
  content: "\\f24b";
}
.vl-vi-programming-bug::before {
  content: "\\f24c";
}
.vl-vi-programming-bug--after::after {
  content: "\\f24c";
}
.vl-vi-programming-jigsaw::before {
  content: "\\f24d";
}
.vl-vi-programming-jigsaw--after::after {
  content: "\\f24d";
}
.vl-vi-publication::before {
  content: "\\f24e";
}
.vl-vi-publication--after::after {
  content: "\\f24e";
}
.vl-vi-question-mark-filled::before {
  content: "\\f24f";
}
.vl-vi-question-mark-filled--after::after {
  content: "\\f24f";
}
.vl-vi-question-mark-small::before {
  content: "\\f250";
}
.vl-vi-question-mark-small--after::after {
  content: "\\f250";
}
.vl-vi-question-mark::before {
  content: "\\f251";
}
.vl-vi-question-mark--after::after {
  content: "\\f251";
}
.vl-vi-question::before {
  content: "\\f252";
}
.vl-vi-question--after::after {
  content: "\\f252";
}
.vl-vi-recreation::before {
  content: "\\f253";
}
.vl-vi-recreation--after::after {
  content: "\\f253";
}
.vl-vi-reply-all::before {
  content: "\\f254";
}
.vl-vi-reply-all--after::after {
  content: "\\f254";
}
.vl-vi-reply::before {
  content: "\\f255";
}
.vl-vi-reply--after::after {
  content: "\\f255";
}
.vl-vi-rewards-certified-badge::before {
  content: "\\f256";
}
.vl-vi-rewards-certified-badge--after::after {
  content: "\\f256";
}
.vl-vi-rewards-gift::before {
  content: "\\f257";
}
.vl-vi-rewards-gift--after::after {
  content: "\\f257";
}
.vl-vi-road-block::before {
  content: "\\f258";
}
.vl-vi-road-block--after::after {
  content: "\\f258";
}
.vl-vi-road::before {
  content: "\\f259";
}
.vl-vi-road--after::after {
  content: "\\f259";
}
.vl-vi-romance-marriage-license::before {
  content: "\\f25a";
}
.vl-vi-romance-marriage-license--after::after {
  content: "\\f25a";
}
.vl-vi-ruler::before {
  content: "\\f25b";
}
.vl-vi-ruler--after::after {
  content: "\\f25b";
}
.vl-vi-safe::before {
  content: "\\f25c";
}
.vl-vi-safe--after::after {
  content: "\\f25c";
}
.vl-vi-save::before {
  content: "\\f25d";
}
.vl-vi-save--after::after {
  content: "\\f25d";
}
.vl-vi-scaffold::before {
  content: "\\f25e";
}
.vl-vi-scaffold--after::after {
  content: "\\f25e";
}
.vl-vi-scan::before {
  content: "\\f25f";
}
.vl-vi-scan--after::after {
  content: "\\f25f";
}
.vl-vi-scissors::before {
  content: "\\f260";
}
.vl-vi-scissors--after::after {
  content: "\\f260";
}
.vl-vi-search::before {
  content: "\\f261";
}
.vl-vi-search--after::after {
  content: "\\f261";
}
.vl-vi-server::before {
  content: "\\f262";
}
.vl-vi-server--after::after {
  content: "\\f262";
}
.vl-vi-settings::before {
  content: "\\f263";
}
.vl-vi-settings--after::after {
  content: "\\f263";
}
.vl-vi-share-megaphone::before {
  content: "\\f264";
}
.vl-vi-share-megaphone--after::after {
  content: "\\f264";
}
.vl-vi-share-rss-feed::before {
  content: "\\f265";
}
.vl-vi-share-rss-feed--after::after {
  content: "\\f265";
}
.vl-vi-share::before {
  content: "\\f266";
}
.vl-vi-share--after::after {
  content: "\\f266";
}
.vl-vi-shipping-truck::before {
  content: "\\f267";
}
.vl-vi-shipping-truck--after::after {
  content: "\\f267";
}
.vl-vi-shopping-basket-add::before {
  content: "\\f268";
}
.vl-vi-shopping-basket-add--after::after {
  content: "\\f268";
}
.vl-vi-shopping-basket-subtract::before {
  content: "\\f269";
}
.vl-vi-shopping-basket-subtract--after::after {
  content: "\\f269";
}
.vl-vi-shopping-basket::before {
  content: "\\f26a";
}
.vl-vi-shopping-basket--after::after {
  content: "\\f26a";
}
.vl-vi-shopping-cart::before {
  content: "\\f26b";
}
.vl-vi-shopping-cart--after::after {
  content: "\\f26b";
}
.vl-vi-shopping::before {
  content: "\\f26c";
}
.vl-vi-shopping--after::after {
  content: "\\f26c";
}
.vl-vi-shrink::before {
  content: "\\f26d";
}
.vl-vi-shrink--after::after {
  content: "\\f26d";
}
.vl-vi-sign-disable::before {
  content: "\\f26e";
}
.vl-vi-sign-disable--after::after {
  content: "\\f26e";
}
.vl-vi-sign-recycle::before {
  content: "\\f26f";
}
.vl-vi-sign-recycle--after::after {
  content: "\\f26f";
}
.vl-vi-sitemap::before {
  content: "\\f270";
}
.vl-vi-sitemap--after::after {
  content: "\\f270";
}
.vl-vi-skype::before {
  content: "\\f271";
}
.vl-vi-skype--after::after {
  content: "\\f271";
}
.vl-vi-smiley-poker-face::before {
  content: "\\f272";
}
.vl-vi-smiley-poker-face--after::after {
  content: "\\f272";
}
.vl-vi-smiley-smile::before {
  content: "\\f273";
}
.vl-vi-smiley-smile--after::after {
  content: "\\f273";
}
.vl-vi-snapchat::before {
  content: "\\f274";
}
.vl-vi-snapchat--after::after {
  content: "\\f274";
}
.vl-vi-snippet::before {
  content: "\\f275";
}
.vl-vi-snippet--after::after {
  content: "\\f275";
}
.vl-vi-sort::before {
  content: "\\f276";
}
.vl-vi-sort--after::after {
  content: "\\f276";
}
.vl-vi-speaker-volume-decrease::before {
  content: "\\f277";
}
.vl-vi-speaker-volume-decrease--after::after {
  content: "\\f277";
}
.vl-vi-speaker-volume-high::before {
  content: "\\f278";
}
.vl-vi-speaker-volume-high--after::after {
  content: "\\f278";
}
.vl-vi-speaker-volume-increase::before {
  content: "\\f279";
}
.vl-vi-speaker-volume-increase--after::after {
  content: "\\f279";
}
.vl-vi-speaker-volume-low::before {
  content: "\\f27a";
}
.vl-vi-speaker-volume-low--after::after {
  content: "\\f27a";
}
.vl-vi-speaker-volume-medium::before {
  content: "\\f27b";
}
.vl-vi-speaker-volume-medium--after::after {
  content: "\\f27b";
}
.vl-vi-speaker-volume-off::before {
  content: "\\f27c";
}
.vl-vi-speaker-volume-off--after::after {
  content: "\\f27c";
}
.vl-vi-sports-competition::before {
  content: "\\f27d";
}
.vl-vi-sports-competition--after::after {
  content: "\\f27d";
}
.vl-vi-spotify::before {
  content: "\\f27e";
}
.vl-vi-spotify--after::after {
  content: "\\f27e";
}
.vl-vi-stop::before {
  content: "\\f27f";
}
.vl-vi-stop--after::after {
  content: "\\f27f";
}
.vl-vi-subtract-filled::before {
  content: "\\f280";
}
.vl-vi-subtract-filled--after::after {
  content: "\\f280";
}
.vl-vi-subtract-naked::before {
  content: "\\f281";
}
.vl-vi-subtract-naked--after::after {
  content: "\\f281";
}
.vl-vi-subtract::before {
  content: "\\f282";
}
.vl-vi-subtract--after::after {
  content: "\\f282";
}
.vl-vi-subway::before {
  content: "\\f283";
}
.vl-vi-subway--after::after {
  content: "\\f283";
}
.vl-vi-suitcase::before {
  content: "\\f284";
}
.vl-vi-suitcase--after::after {
  content: "\\f284";
}
.vl-vi-switches::before {
  content: "\\f285";
}
.vl-vi-switches--after::after {
  content: "\\f285";
}
.vl-vi-symbol-wifi-check::before {
  content: "\\f286";
}
.vl-vi-symbol-wifi-check--after::after {
  content: "\\f286";
}
.vl-vi-symbol-wifi-close::before {
  content: "\\f287";
}
.vl-vi-symbol-wifi-close--after::after {
  content: "\\f287";
}
.vl-vi-symbol-wifi::before {
  content: "\\f288";
}
.vl-vi-symbol-wifi--after::after {
  content: "\\f288";
}
.vl-vi-synchronize-timeout::before {
  content: "\\f289";
}
.vl-vi-synchronize-timeout--after::after {
  content: "\\f289";
}
.vl-vi-synchronize::before {
  content: "\\f28a";
}
.vl-vi-synchronize--after::after {
  content: "\\f28a";
}
.vl-vi-t-shirt::before {
  content: "\\f28b";
}
.vl-vi-t-shirt--after::after {
  content: "\\f28b";
}
.vl-vi-tablet::before {
  content: "\\f28c";
}
.vl-vi-tablet--after::after {
  content: "\\f28c";
}
.vl-vi-tag-add::before {
  content: "\\f28d";
}
.vl-vi-tag-add--after::after {
  content: "\\f28d";
}
.vl-vi-tag-check::before {
  content: "\\f28e";
}
.vl-vi-tag-check--after::after {
  content: "\\f28e";
}
.vl-vi-tag-close::before {
  content: "\\f28f";
}
.vl-vi-tag-close--after::after {
  content: "\\f28f";
}
.vl-vi-tag-double::before {
  content: "\\f290";
}
.vl-vi-tag-double--after::after {
  content: "\\f290";
}
.vl-vi-tag-edit::before {
  content: "\\f291";
}
.vl-vi-tag-edit--after::after {
  content: "\\f291";
}
.vl-vi-tag-subtract::before {
  content: "\\f292";
}
.vl-vi-tag-subtract--after::after {
  content: "\\f292";
}
.vl-vi-tag-view::before {
  content: "\\f293";
}
.vl-vi-tag-view--after::after {
  content: "\\f293";
}
.vl-vi-tag::before {
  content: "\\f294";
}
.vl-vi-tag--after::after {
  content: "\\f294";
}
.vl-vi-taxi::before {
  content: "\\f295";
}
.vl-vi-taxi--after::after {
  content: "\\f295";
}
.vl-vi-television::before {
  content: "\\f296";
}
.vl-vi-television--after::after {
  content: "\\f296";
}
.vl-vi-terrace::before {
  content: "\\f297";
}
.vl-vi-terrace--after::after {
  content: "\\f297";
}
.vl-vi-text-cursor::before {
  content: "\\f298";
}
.vl-vi-text-cursor--after::after {
  content: "\\f298";
}
.vl-vi-text-eraser::before {
  content: "\\f299";
}
.vl-vi-text-eraser--after::after {
  content: "\\f299";
}
.vl-vi-text-redo::before {
  content: "\\f29a";
}
.vl-vi-text-redo--after::after {
  content: "\\f29a";
}
.vl-vi-text-undo::before {
  content: "\\f29b";
}
.vl-vi-text-undo--after::after {
  content: "\\f29b";
}
.vl-vi-timeline::before {
  content: "\\f29c";
}
.vl-vi-timeline--after::after {
  content: "\\f29c";
}
.vl-vi-tint::before {
  content: "\\f29d";
}
.vl-vi-tint--after::after {
  content: "\\f29d";
}
.vl-vi-train::before {
  content: "\\f29e";
}
.vl-vi-train--after::after {
  content: "\\f29e";
}
.vl-vi-trash::before {
  content: "\\f29f";
}
.vl-vi-trash--after::after {
  content: "\\f29f";
}
.vl-vi-trophy::before {
  content: "\\f2a0";
}
.vl-vi-trophy--after::after {
  content: "\\f2a0";
}
.vl-vi-twitter::before {
  content: "\\f2a1";
}
.vl-vi-twitter--after::after {
  content: "\\f2a1";
}
.vl-vi-underline::before {
  content: "\\f2a2";
}
.vl-vi-underline--after::after {
  content: "\\f2a2";
}
.vl-vi-university::before {
  content: "\\f2a3";
}
.vl-vi-university--after::after {
  content: "\\f2a3";
}
.vl-vi-up-down-arrows::before {
  content: "\\f2a4";
}
.vl-vi-up-down-arrows--after::after {
  content: "\\f2a4";
}
.vl-vi-upload-harddisk::before {
  content: "\\f2a5";
}
.vl-vi-upload-harddisk--after::after {
  content: "\\f2a5";
}
.vl-vi-usb::before {
  content: "\\f2a6";
}
.vl-vi-usb--after::after {
  content: "\\f2a6";
}
.vl-vi-user-alt::before {
  content: "\\f2a7";
}
.vl-vi-user-alt--after::after {
  content: "\\f2a7";
}
.vl-vi-user-box::before {
  content: "\\f2a8";
}
.vl-vi-user-box--after::after {
  content: "\\f2a8";
}
.vl-vi-user-download::before {
  content: "\\f2a9";
}
.vl-vi-user-download--after::after {
  content: "\\f2a9";
}
.vl-vi-user-email::before {
  content: "\\f2aa";
}
.vl-vi-user-email--after::after {
  content: "\\f2aa";
}
.vl-vi-user-female::before {
  content: "\\f2ab";
}
.vl-vi-user-female--after::after {
  content: "\\f2ab";
}
.vl-vi-user-group::before {
  content: "\\f2ac";
}
.vl-vi-user-group--after::after {
  content: "\\f2ac";
}
.vl-vi-user-male::before {
  content: "\\f2ad";
}
.vl-vi-user-male--after::after {
  content: "\\f2ad";
}
.vl-vi-user-reception::before {
  content: "\\f2ae";
}
.vl-vi-user-reception--after::after {
  content: "\\f2ae";
}
.vl-vi-user-redirect::before {
  content: "\\f2af";
}
.vl-vi-user-redirect--after::after {
  content: "\\f2af";
}
.vl-vi-user-remove::before {
  content: "\\f2b0";
}
.vl-vi-user-remove--after::after {
  content: "\\f2b0";
}
.vl-vi-user-setting::before {
  content: "\\f2b1";
}
.vl-vi-user-setting--after::after {
  content: "\\f2b1";
}
.vl-vi-user-signup::before {
  content: "\\f2b2";
}
.vl-vi-user-signup--after::after {
  content: "\\f2b2";
}
.vl-vi-user::before {
  content: "\\f2b3";
}
.vl-vi-user--after::after {
  content: "\\f2b3";
}
.vl-vi-vaccum-cleaner::before {
  content: "\\f2b4";
}
.vl-vi-vaccum-cleaner--after::after {
  content: "\\f2b4";
}
.vl-vi-video-subtitle::before {
  content: "\\f2b5";
}
.vl-vi-video-subtitle--after::after {
  content: "\\f2b5";
}
.vl-vi-view-add::before {
  content: "\\f2b6";
}
.vl-vi-view-add--after::after {
  content: "\\f2b6";
}
.vl-vi-view-hide::before {
  content: "\\f2b7";
}
.vl-vi-view-hide--after::after {
  content: "\\f2b7";
}
.vl-vi-vlaanderen::before {
  content: "\\f2b8";
}
.vl-vi-vlaanderen--after::after {
  content: "\\f2b8";
}
.vl-vi-vote-flag::before {
  content: "\\f2b9";
}
.vl-vi-vote-flag--after::after {
  content: "\\f2b9";
}
.vl-vi-vote-heart::before {
  content: "\\f2ba";
}
.vl-vi-vote-heart--after::after {
  content: "\\f2ba";
}
.vl-vi-vote-star-filled::before {
  content: "\\f2bb";
}
.vl-vi-vote-star-filled--after::after {
  content: "\\f2bb";
}
.vl-vi-vote-star::before {
  content: "\\f2bc";
}
.vl-vi-vote-star--after::after {
  content: "\\f2bc";
}
.vl-vi-vote-thumbs-down::before {
  content: "\\f2bd";
}
.vl-vi-vote-thumbs-down--after::after {
  content: "\\f2bd";
}
.vl-vi-vote-thumbs-up::before {
  content: "\\f2be";
}
.vl-vi-vote-thumbs-up--after::after {
  content: "\\f2be";
}
.vl-vi-voucher-check::before {
  content: "\\f2bf";
}
.vl-vi-voucher-check--after::after {
  content: "\\f2bf";
}
.vl-vi-voucher-download::before {
  content: "\\f2c0";
}
.vl-vi-voucher-download--after::after {
  content: "\\f2c0";
}
.vl-vi-voucher-scissors::before {
  content: "\\f2c1";
}
.vl-vi-voucher-scissors--after::after {
  content: "\\f2c1";
}
.vl-vi-vouchers-list::before {
  content: "\\f2c2";
}
.vl-vi-vouchers-list--after::after {
  content: "\\f2c2";
}
.vl-vi-wallet::before {
  content: "\\f2c3";
}
.vl-vi-wallet--after::after {
  content: "\\f2c3";
}
.vl-vi-warning::before {
  content: "\\f2c4";
}
.vl-vi-warning--after::after {
  content: "\\f2c4";
}
.vl-vi-whatsapp::before {
  content: "\\f2c5";
}
.vl-vi-whatsapp--after::after {
  content: "\\f2c5";
}
.vl-vi-whiskey-bottle-glass::before {
  content: "\\f2c6";
}
.vl-vi-whiskey-bottle-glass--after::after {
  content: "\\f2c6";
}
.vl-vi-window-forward::before {
  content: "\\f2c7";
}
.vl-vi-window-forward--after::after {
  content: "\\f2c7";
}
.vl-vi-wrench::before {
  content: "\\f2c8";
}
.vl-vi-wrench--after::after {
  content: "\\f2c8";
}
.vl-vi-www::before {
  content: "\\f2c9";
}
.vl-vi-www--after::after {
  content: "\\f2c9";
}
.vl-vi-youtube::before {
  content: "\\f2ca";
}
.vl-vi-youtube--after::after {
  content: "\\f2ca";
}
.vl-vi-zoom-in::before {
  content: "\\f2cb";
}
.vl-vi-zoom-in--after::after {
  content: "\\f2cb";
}
.vl-vi-zoom-out::before {
  content: "\\f2cc";
}
.vl-vi-zoom-out--after::after {
  content: "\\f2cc";
}
a {
  color: var(--vl-theme-action-color, #05c);
  text-decoration: underline;
  -webkit-text-decoration-skip: ink;
          text-decoration-skip-ink: auto;
}
a:hover, a:focus {
  text-decoration: none;
  color: var(--vl-theme-action-hover-color, #003bb0);
}
a:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
a:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
a:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
a:visited {
  color: #660599;
}
button {
  font-family: "Flanders Art Sans", sans-serif;
  cursor: pointer;
}
button:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
button:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
img.vl-image--error {
  overflow-wrap: break-word;
  padding: 10px;
  line-height: 1.25;
  font-size: 1.6rem;
  color: var(--vl-theme-fg-color);
  background-color: #f7f9fc;
}
sub {
  vertical-align: sub;
  font-size: 1.2rem;
}
sup {
  vertical-align: super;
  font-size: 1.2rem;
}
.vl-grid {
  position: relative;
  box-sizing: border-box;
  display: flex;
  margin-left: -3rem;
  flex-direction: row;
  flex: 0 1 auto;
  flex-wrap: wrap;
}
.vl-grid > * {
  box-sizing: border-box;
  padding-left: 3rem;
  position: relative;
}
.vl-grid--no-gutter {
  margin-left: 0;
}
.vl-grid--no-gutter > * {
  padding-left: 0;
}
.vl-grid--v-top {
  align-items: flex-start;
}
.vl-grid--v-center {
  align-items: center;
}
.vl-grid--v-bottom {
  align-items: flex-end;
}
.vl-grid--v-stretch {
  align-items: stretch;
}
.vl-grid--v-baseline {
  align-items: stretch;
}
.vl-grid--align-start {
  justify-content: flex-start;
}
.vl-grid--align-end {
  justify-content: flex-end;
}
.vl-grid--align-center {
  justify-content: center;
}
.vl-grid--align-space-between {
  justify-content: space-between;
}
.vl-grid--align-space-around {
  justify-content: space-around;
}
.vl-col--fit {
  flex: 1 0;
}
.vl-col--flex {
  display: flex;
}
.vl-col--1-12 {
  flex-basis: 8.3333333333%;
  max-width: 8.3333333333%;
  min-width: 8.3333333333%;
}
.vl-col--1-6, .vl-col--2-12 {
  flex-basis: 16.6666666667%;
  max-width: 16.6666666667%;
  min-width: 16.6666666667%;
}
.vl-col--1-4, .vl-col--3-12 {
  flex-basis: 25%;
  max-width: 25%;
  min-width: 25%;
}
.vl-col--1-3, .vl-col--2-6, .vl-col--4-12 {
  flex-basis: 33.3333333333%;
  max-width: 33.3333333333%;
  min-width: 33.3333333333%;
}
.vl-col--5-12 {
  flex-basis: 41.6666666667%;
  max-width: 41.6666666667%;
  min-width: 41.6666666667%;
}
.vl-col--1-2, .vl-col--2-4, .vl-col--3-6, .vl-col--6-12 {
  flex-basis: 50%;
  max-width: 50%;
  min-width: 50%;
}
.vl-col--7-12 {
  flex-basis: 58.3333333333%;
  max-width: 58.3333333333%;
  min-width: 58.3333333333%;
}
.vl-col--2-3, .vl-col--4-6, .vl-col--8-12 {
  flex-basis: 66.6666666667%;
  max-width: 66.6666666667%;
  min-width: 66.6666666667%;
}
.vl-col--3-4, .vl-col--9-12 {
  flex-basis: 75%;
  max-width: 75%;
  min-width: 75%;
}
.vl-col--5-6, .vl-col--10-12 {
  flex-basis: 83.3333333333%;
  max-width: 83.3333333333%;
  min-width: 83.3333333333%;
}
.vl-col--11-12 {
  flex-basis: 91.6666666667%;
  max-width: 91.6666666667%;
  min-width: 91.6666666667%;
}
.vl-col--1-1, .vl-col--2-2, .vl-col--3-3, .vl-col--4-4, .vl-col--6-6, .vl-col--12-12 {
  flex-basis: 100%;
  max-width: 100%;
  min-width: 100%;
}
.vl-grid--is-stacked {
  margin-top: -3rem;
}
.vl-grid--is-stacked > * {
  margin-top: 3rem;
}
.vl-push--reset {
  margin-left: 0;
}
.vl-push--1-12 {
  margin-left: 8.3333333333%;
}
.vl-push--1-6, .vl-push--2-12 {
  margin-left: 16.6666666667%;
}
.vl-push--1-4, .vl-push--3-12 {
  margin-left: 25%;
}
.vl-push--1-3, .vl-push--2-6, .vl-push--4-12 {
  margin-left: 33.3333333333%;
}
.vl-push--5-12 {
  margin-left: 41.6666666667%;
}
.vl-push--1-2, .vl-push--2-4, .vl-push--3-6, .vl-push--6-12 {
  margin-left: 50%;
}
.vl-push--7-12 {
  margin-left: 58.3333333333%;
}
.vl-push--2-3, .vl-push--4-6, .vl-push--8-12 {
  margin-left: 66.6666666667%;
}
.vl-push--3-4, .vl-push--9-12 {
  margin-left: 75%;
}
.vl-push--5-6, .vl-push--10-12 {
  margin-left: 83.3333333333%;
}
.vl-push--11-12 {
  margin-left: 91.6666666667%;
}
.vl-col--omega {
  margin-left: auto;
}
@media screen and (min-width: 1024px) {
.vl-grid {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -3rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > * {
    box-sizing: border-box;
    padding-left: 3rem;
    position: relative;
}
.vl-grid--no-gutter--l {
    margin-left: 0;
}
.vl-grid--no-gutter--l > * {
    padding-left: 0;
}
.vl-grid--v-top--l {
    align-items: flex-start;
}
.vl-grid--v-center--l {
    align-items: center;
}
.vl-grid--v-bottom--l {
    align-items: flex-end;
}
.vl-grid--v-stretch--l {
    align-items: stretch;
}
.vl-grid--v-baseline--l {
    align-items: stretch;
}
.vl-grid--align-start--l {
    justify-content: flex-start;
}
.vl-grid--align-end--l {
    justify-content: flex-end;
}
.vl-grid--align-center--l {
    justify-content: center;
}
.vl-grid--align-space-between--l {
    justify-content: space-between;
}
.vl-grid--align-space-around--l {
    justify-content: space-around;
}
.vl-col--fit--l {
    flex: 1 0;
}
.vl-col--flex--l {
    display: flex;
}
.vl-col--1-12--l {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--l, .vl-col--2-12--l {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--l, .vl-col--3-12--l {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--l, .vl-col--2-6--l, .vl-col--4-12--l {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--l {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--l, .vl-col--2-4--l, .vl-col--3-6--l, .vl-col--6-12--l {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--l {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--l, .vl-col--4-6--l, .vl-col--8-12--l {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--l, .vl-col--9-12--l {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--l, .vl-col--10-12--l {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--l {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--l, .vl-col--2-2--l, .vl-col--3-3--l, .vl-col--4-4--l, .vl-col--6-6--l, .vl-col--12-12--l {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked {
    margin-top: -3rem;
}
.vl-grid--is-stacked > * {
    margin-top: 3rem;
}
.vl-push--reset--l {
    margin-left: 0;
}
.vl-push--1-12--l {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--l, .vl-push--2-12--l {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--l, .vl-push--3-12--l {
    margin-left: 25%;
}
.vl-push--1-3--l, .vl-push--2-6--l, .vl-push--4-12--l {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--l {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--l, .vl-push--2-4--l, .vl-push--3-6--l, .vl-push--6-12--l {
    margin-left: 50%;
}
.vl-push--7-12--l {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--l, .vl-push--4-6--l, .vl-push--8-12--l {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--l, .vl-push--9-12--l {
    margin-left: 75%;
}
.vl-push--5-6--l, .vl-push--10-12--l {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--l {
    margin-left: 91.6666666667%;
}
.vl-col--omega--l {
    margin-left: auto;
}
}
@media screen and (min-width: 1601px) {
.vl-grid {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -3rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > * {
    box-sizing: border-box;
    padding-left: 3rem;
    position: relative;
}
.vl-grid--no-gutter--xl {
    margin-left: 0;
}
.vl-grid--no-gutter--xl > * {
    padding-left: 0;
}
.vl-grid--v-top--xl {
    align-items: flex-start;
}
.vl-grid--v-center--xl {
    align-items: center;
}
.vl-grid--v-bottom--xl {
    align-items: flex-end;
}
.vl-grid--v-stretch--xl {
    align-items: stretch;
}
.vl-grid--v-baseline--xl {
    align-items: stretch;
}
.vl-grid--align-start--xl {
    justify-content: flex-start;
}
.vl-grid--align-end--xl {
    justify-content: flex-end;
}
.vl-grid--align-center--xl {
    justify-content: center;
}
.vl-grid--align-space-between--xl {
    justify-content: space-between;
}
.vl-grid--align-space-around--xl {
    justify-content: space-around;
}
.vl-col--fit--xl {
    flex: 1 0;
}
.vl-col--flex--xl {
    display: flex;
}
.vl-col--1-12--xl {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--xl, .vl-col--2-12--xl {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--xl, .vl-col--3-12--xl {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--xl, .vl-col--2-6--xl, .vl-col--4-12--xl {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--xl {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--xl, .vl-col--2-4--xl, .vl-col--3-6--xl, .vl-col--6-12--xl {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--xl {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--xl, .vl-col--4-6--xl, .vl-col--8-12--xl {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--xl, .vl-col--9-12--xl {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--xl, .vl-col--10-12--xl {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--xl {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--xl, .vl-col--2-2--xl, .vl-col--3-3--xl, .vl-col--4-4--xl, .vl-col--6-6--xl, .vl-col--12-12--xl {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked {
    margin-top: -3rem;
}
.vl-grid--is-stacked > * {
    margin-top: 3rem;
}
.vl-push--reset--xl {
    margin-left: 0;
}
.vl-push--1-12--xl {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--xl, .vl-push--2-12--xl {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--xl, .vl-push--3-12--xl {
    margin-left: 25%;
}
.vl-push--1-3--xl, .vl-push--2-6--xl, .vl-push--4-12--xl {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--xl {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--xl, .vl-push--2-4--xl, .vl-push--3-6--xl, .vl-push--6-12--xl {
    margin-left: 50%;
}
.vl-push--7-12--xl {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--xl, .vl-push--4-6--xl, .vl-push--8-12--xl {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--xl, .vl-push--9-12--xl {
    margin-left: 75%;
}
.vl-push--5-6--xl, .vl-push--10-12--xl {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--xl {
    margin-left: 91.6666666667%;
}
.vl-col--omega--xl {
    margin-left: auto;
}
}
@media screen and (max-width: 1023px) {
.vl-grid {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -3rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > * {
    box-sizing: border-box;
    padding-left: 3rem;
    position: relative;
}
.vl-grid--no-gutter--m {
    margin-left: 0;
}
.vl-grid--no-gutter--m > * {
    padding-left: 0;
}
.vl-grid--v-top--m {
    align-items: flex-start;
}
.vl-grid--v-center--m {
    align-items: center;
}
.vl-grid--v-bottom--m {
    align-items: flex-end;
}
.vl-grid--v-stretch--m {
    align-items: stretch;
}
.vl-grid--v-baseline--m {
    align-items: stretch;
}
.vl-grid--align-start--m {
    justify-content: flex-start;
}
.vl-grid--align-end--m {
    justify-content: flex-end;
}
.vl-grid--align-center--m {
    justify-content: center;
}
.vl-grid--align-space-between--m {
    justify-content: space-between;
}
.vl-grid--align-space-around--m {
    justify-content: space-around;
}
.vl-col--fit--m {
    flex: 1 0;
}
.vl-col--flex--m {
    display: flex;
}
.vl-col--1-12--m {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--m, .vl-col--2-12--m {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--m, .vl-col--3-12--m {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--m, .vl-col--2-6--m, .vl-col--4-12--m {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--m {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--m, .vl-col--2-4--m, .vl-col--3-6--m, .vl-col--6-12--m {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--m {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--m, .vl-col--4-6--m, .vl-col--8-12--m {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--m, .vl-col--9-12--m {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--m, .vl-col--10-12--m {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--m {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--m, .vl-col--2-2--m, .vl-col--3-3--m, .vl-col--4-4--m, .vl-col--6-6--m, .vl-col--12-12--m {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked {
    margin-top: -3rem;
}
.vl-grid--is-stacked > * {
    margin-top: 3rem;
}
.vl-push--reset--m {
    margin-left: 0;
}
.vl-push--1-12--m {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--m, .vl-push--2-12--m {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--m, .vl-push--3-12--m {
    margin-left: 25%;
}
.vl-push--1-3--m, .vl-push--2-6--m, .vl-push--4-12--m {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--m {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--m, .vl-push--2-4--m, .vl-push--3-6--m, .vl-push--6-12--m {
    margin-left: 50%;
}
.vl-push--7-12--m {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--m, .vl-push--4-6--m, .vl-push--8-12--m {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--m, .vl-push--9-12--m {
    margin-left: 75%;
}
.vl-push--5-6--m, .vl-push--10-12--m {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--m {
    margin-left: 91.6666666667%;
}
.vl-col--omega--m {
    margin-left: auto;
}
}
@media screen and (max-width: 767px) {
.vl-grid {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -1.5rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > * {
    box-sizing: border-box;
    padding-left: 1.5rem;
    position: relative;
}
.vl-grid--no-gutter--s {
    margin-left: 0;
}
.vl-grid--no-gutter--s > * {
    padding-left: 0;
}
.vl-grid--v-top--s {
    align-items: flex-start;
}
.vl-grid--v-center--s {
    align-items: center;
}
.vl-grid--v-bottom--s {
    align-items: flex-end;
}
.vl-grid--v-stretch--s {
    align-items: stretch;
}
.vl-grid--v-baseline--s {
    align-items: stretch;
}
.vl-grid--align-start--s {
    justify-content: flex-start;
}
.vl-grid--align-end--s {
    justify-content: flex-end;
}
.vl-grid--align-center--s {
    justify-content: center;
}
.vl-grid--align-space-between--s {
    justify-content: space-between;
}
.vl-grid--align-space-around--s {
    justify-content: space-around;
}
.vl-col--fit--s {
    flex: 1 0;
}
.vl-col--flex--s {
    display: flex;
}
.vl-col--1-12--s {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--s, .vl-col--2-12--s {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--s, .vl-col--3-12--s {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--s, .vl-col--2-6--s, .vl-col--4-12--s {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--s {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--s, .vl-col--2-4--s, .vl-col--3-6--s, .vl-col--6-12--s {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--s {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--s, .vl-col--4-6--s, .vl-col--8-12--s {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--s, .vl-col--9-12--s {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--s, .vl-col--10-12--s {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--s {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--s, .vl-col--2-2--s, .vl-col--3-3--s, .vl-col--4-4--s, .vl-col--6-6--s, .vl-col--12-12--s {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked {
    margin-top: -1.5rem;
}
.vl-grid--is-stacked > * {
    margin-top: 1.5rem;
}
.vl-push--reset--s {
    margin-left: 0;
}
.vl-push--1-12--s {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--s, .vl-push--2-12--s {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--s, .vl-push--3-12--s {
    margin-left: 25%;
}
.vl-push--1-3--s, .vl-push--2-6--s, .vl-push--4-12--s {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--s {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--s, .vl-push--2-4--s, .vl-push--3-6--s, .vl-push--6-12--s {
    margin-left: 50%;
}
.vl-push--7-12--s {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--s, .vl-push--4-6--s, .vl-push--8-12--s {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--s, .vl-push--9-12--s {
    margin-left: 75%;
}
.vl-push--5-6--s, .vl-push--10-12--s {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--s {
    margin-left: 91.6666666667%;
}
.vl-col--omega--s {
    margin-left: auto;
}
}
@media screen and (max-width: 500px) {
.vl-grid {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -1.5rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-grid > * {
    box-sizing: border-box;
    padding-left: 1.5rem;
    position: relative;
}
.vl-grid--no-gutter--xs {
    margin-left: 0;
}
.vl-grid--no-gutter--xs > * {
    padding-left: 0;
}
.vl-grid--v-top--xs {
    align-items: flex-start;
}
.vl-grid--v-center--xs {
    align-items: center;
}
.vl-grid--v-bottom--xs {
    align-items: flex-end;
}
.vl-grid--v-stretch--xs {
    align-items: stretch;
}
.vl-grid--v-baseline--xs {
    align-items: stretch;
}
.vl-grid--align-start--xs {
    justify-content: flex-start;
}
.vl-grid--align-end--xs {
    justify-content: flex-end;
}
.vl-grid--align-center--xs {
    justify-content: center;
}
.vl-grid--align-space-between--xs {
    justify-content: space-between;
}
.vl-grid--align-space-around--xs {
    justify-content: space-around;
}
.vl-col--fit--xs {
    flex: 1 0;
}
.vl-col--flex--xs {
    display: flex;
}
.vl-col--1-12--xs {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-col--1-6--xs, .vl-col--2-12--xs {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-col--1-4--xs, .vl-col--3-12--xs {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-col--1-3--xs, .vl-col--2-6--xs, .vl-col--4-12--xs {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-col--5-12--xs {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-col--1-2--xs, .vl-col--2-4--xs, .vl-col--3-6--xs, .vl-col--6-12--xs {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-col--7-12--xs {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-col--2-3--xs, .vl-col--4-6--xs, .vl-col--8-12--xs {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-col--3-4--xs, .vl-col--9-12--xs {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-col--5-6--xs, .vl-col--10-12--xs {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-col--11-12--xs {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-col--1-1--xs, .vl-col--2-2--xs, .vl-col--3-3--xs, .vl-col--4-4--xs, .vl-col--6-6--xs, .vl-col--12-12--xs {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-grid--is-stacked {
    margin-top: -1.5rem;
}
.vl-grid--is-stacked > * {
    margin-top: 1.5rem;
}
.vl-push--reset--xs {
    margin-left: 0;
}
.vl-push--1-12--xs {
    margin-left: 8.3333333333%;
}
.vl-push--1-6--xs, .vl-push--2-12--xs {
    margin-left: 16.6666666667%;
}
.vl-push--1-4--xs, .vl-push--3-12--xs {
    margin-left: 25%;
}
.vl-push--1-3--xs, .vl-push--2-6--xs, .vl-push--4-12--xs {
    margin-left: 33.3333333333%;
}
.vl-push--5-12--xs {
    margin-left: 41.6666666667%;
}
.vl-push--1-2--xs, .vl-push--2-4--xs, .vl-push--3-6--xs, .vl-push--6-12--xs {
    margin-left: 50%;
}
.vl-push--7-12--xs {
    margin-left: 58.3333333333%;
}
.vl-push--2-3--xs, .vl-push--4-6--xs, .vl-push--8-12--xs {
    margin-left: 66.6666666667%;
}
.vl-push--3-4--xs, .vl-push--9-12--xs {
    margin-left: 75%;
}
.vl-push--5-6--xs, .vl-push--10-12--xs {
    margin-left: 83.3333333333%;
}
.vl-push--11-12--xs {
    margin-left: 91.6666666667%;
}
.vl-col--omega--xs {
    margin-left: auto;
}
}
@media screen and (min-width: 1280px) {
.vl-grid--wide {
    margin-left: calc(-4.1666666667% - 3rem);
    margin-right: -4.1666666667%;
}
}
.vl-form-grid {
  position: relative;
  box-sizing: border-box;
  display: flex;
  margin-left: -1.5rem;
  flex-direction: row;
  flex: 0 1 auto;
  flex-wrap: wrap;
}
.vl-form-grid > * {
  box-sizing: border-box;
  padding-left: 1.5rem;
  position: relative;
}
.vl-form-grid--no-gutter {
  margin-left: 0;
}
.vl-form-grid--no-gutter > * {
  padding-left: 0;
}
.vl-form-grid--v-top {
  align-items: flex-start;
}
.vl-form-grid--v-center {
  align-items: center;
}
.vl-form-grid--v-bottom {
  align-items: flex-end;
}
.vl-form-grid--v-stretch {
  align-items: stretch;
}
.vl-form-grid--v-baseline {
  align-items: stretch;
}
.vl-form-grid--align-start {
  justify-content: flex-start;
}
.vl-form-grid--align-end {
  justify-content: flex-end;
}
.vl-form-grid--align-center {
  justify-content: center;
}
.vl-form-grid--align-space-between {
  justify-content: space-between;
}
.vl-form-grid--align-space-around {
  justify-content: space-around;
}
.vl-form-col--fit {
  flex: 1 0;
}
.vl-form-col--flex {
  display: flex;
}
.vl-form-col--1-12 {
  flex-basis: 8.3333333333%;
  max-width: 8.3333333333%;
  min-width: 8.3333333333%;
}
.vl-form-col--1-6, .vl-form-col--2-12 {
  flex-basis: 16.6666666667%;
  max-width: 16.6666666667%;
  min-width: 16.6666666667%;
}
.vl-form-col--1-4, .vl-form-col--3-12 {
  flex-basis: 25%;
  max-width: 25%;
  min-width: 25%;
}
.vl-form-col--1-3, .vl-form-col--2-6, .vl-form-col--4-12 {
  flex-basis: 33.3333333333%;
  max-width: 33.3333333333%;
  min-width: 33.3333333333%;
}
.vl-form-col--5-12 {
  flex-basis: 41.6666666667%;
  max-width: 41.6666666667%;
  min-width: 41.6666666667%;
}
.vl-form-col--1-2, .vl-form-col--2-4, .vl-form-col--3-6, .vl-form-col--6-12 {
  flex-basis: 50%;
  max-width: 50%;
  min-width: 50%;
}
.vl-form-col--7-12 {
  flex-basis: 58.3333333333%;
  max-width: 58.3333333333%;
  min-width: 58.3333333333%;
}
.vl-form-col--2-3, .vl-form-col--4-6, .vl-form-col--8-12 {
  flex-basis: 66.6666666667%;
  max-width: 66.6666666667%;
  min-width: 66.6666666667%;
}
.vl-form-col--3-4, .vl-form-col--9-12 {
  flex-basis: 75%;
  max-width: 75%;
  min-width: 75%;
}
.vl-form-col--5-6, .vl-form-col--10-12 {
  flex-basis: 83.3333333333%;
  max-width: 83.3333333333%;
  min-width: 83.3333333333%;
}
.vl-form-col--11-12 {
  flex-basis: 91.6666666667%;
  max-width: 91.6666666667%;
  min-width: 91.6666666667%;
}
.vl-form-col--1-1, .vl-form-col--2-2, .vl-form-col--3-3, .vl-form-col--4-4, .vl-form-col--6-6, .vl-form-col--12-12 {
  flex-basis: 100%;
  max-width: 100%;
  min-width: 100%;
}
.vl-form-grid--is-stacked {
  margin-top: -1.5rem;
}
.vl-form-grid--is-stacked > * {
  margin-top: 1.5rem;
}
.vl-form-push--reset {
  margin-left: 0;
}
.vl-form-push--1-12 {
  margin-left: 8.3333333333%;
}
.vl-form-push--1-6, .vl-form-push--2-12 {
  margin-left: 16.6666666667%;
}
.vl-form-push--1-4, .vl-form-push--3-12 {
  margin-left: 25%;
}
.vl-form-push--1-3, .vl-form-push--2-6, .vl-form-push--4-12 {
  margin-left: 33.3333333333%;
}
.vl-form-push--5-12 {
  margin-left: 41.6666666667%;
}
.vl-form-push--1-2, .vl-form-push--2-4, .vl-form-push--3-6, .vl-form-push--6-12 {
  margin-left: 50%;
}
.vl-form-push--7-12 {
  margin-left: 58.3333333333%;
}
.vl-form-push--2-3, .vl-form-push--4-6, .vl-form-push--8-12 {
  margin-left: 66.6666666667%;
}
.vl-form-push--3-4, .vl-form-push--9-12 {
  margin-left: 75%;
}
.vl-form-push--5-6, .vl-form-push--10-12 {
  margin-left: 83.3333333333%;
}
.vl-form-push--11-12 {
  margin-left: 91.6666666667%;
}
.vl-form-col--omega {
  margin-left: auto;
}
@media screen and (max-width: 767px) {
.vl-form-grid {
    position: relative;
    box-sizing: border-box;
    display: flex;
    margin-left: -1.5rem;
    flex-direction: row;
    flex: 0 1 auto;
    flex-wrap: wrap;
}
.vl-form-grid > * {
    box-sizing: border-box;
    padding-left: 1.5rem;
    position: relative;
}
.vl-form-grid--no-gutter--s {
    margin-left: 0;
}
.vl-form-grid--no-gutter--s > * {
    padding-left: 0;
}
.vl-form-grid--v-top--s {
    align-items: flex-start;
}
.vl-form-grid--v-center--s {
    align-items: center;
}
.vl-form-grid--v-bottom--s {
    align-items: flex-end;
}
.vl-form-grid--v-stretch--s {
    align-items: stretch;
}
.vl-form-grid--v-baseline--s {
    align-items: stretch;
}
.vl-form-grid--align-start--s {
    justify-content: flex-start;
}
.vl-form-grid--align-end--s {
    justify-content: flex-end;
}
.vl-form-grid--align-center--s {
    justify-content: center;
}
.vl-form-grid--align-space-between--s {
    justify-content: space-between;
}
.vl-form-grid--align-space-around--s {
    justify-content: space-around;
}
.vl-form-col--fit--s {
    flex: 1 0;
}
.vl-form-col--flex--s {
    display: flex;
}
.vl-form-col--1-12--s {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    min-width: 8.3333333333%;
}
.vl-form-col--1-6--s, .vl-form-col--2-12--s {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
    min-width: 16.6666666667%;
}
.vl-form-col--1-4--s, .vl-form-col--3-12--s {
    flex-basis: 25%;
    max-width: 25%;
    min-width: 25%;
}
.vl-form-col--1-3--s, .vl-form-col--2-6--s, .vl-form-col--4-12--s {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    min-width: 33.3333333333%;
}
.vl-form-col--5-12--s {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    min-width: 41.6666666667%;
}
.vl-form-col--1-2--s, .vl-form-col--2-4--s, .vl-form-col--3-6--s, .vl-form-col--6-12--s {
    flex-basis: 50%;
    max-width: 50%;
    min-width: 50%;
}
.vl-form-col--7-12--s {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    min-width: 58.3333333333%;
}
.vl-form-col--2-3--s, .vl-form-col--4-6--s, .vl-form-col--8-12--s {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    min-width: 66.6666666667%;
}
.vl-form-col--3-4--s, .vl-form-col--9-12--s {
    flex-basis: 75%;
    max-width: 75%;
    min-width: 75%;
}
.vl-form-col--5-6--s, .vl-form-col--10-12--s {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
    min-width: 83.3333333333%;
}
.vl-form-col--11-12--s {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
    min-width: 91.6666666667%;
}
.vl-form-col--1-1--s, .vl-form-col--2-2--s, .vl-form-col--3-3--s, .vl-form-col--4-4--s, .vl-form-col--6-6--s, .vl-form-col--12-12--s {
    flex-basis: 100%;
    max-width: 100%;
    min-width: 100%;
}
.vl-form-grid--is-stacked {
    margin-top: -1.5rem;
}
.vl-form-grid--is-stacked > * {
    margin-top: 1.5rem;
}
.vl-form-push--reset--s {
    margin-left: 0;
}
.vl-form-push--1-12--s {
    margin-left: 8.3333333333%;
}
.vl-form-push--1-6--s, .vl-form-push--2-12--s {
    margin-left: 16.6666666667%;
}
.vl-form-push--1-4--s, .vl-form-push--3-12--s {
    margin-left: 25%;
}
.vl-form-push--1-3--s, .vl-form-push--2-6--s, .vl-form-push--4-12--s {
    margin-left: 33.3333333333%;
}
.vl-form-push--5-12--s {
    margin-left: 41.6666666667%;
}
.vl-form-push--1-2--s, .vl-form-push--2-4--s, .vl-form-push--3-6--s, .vl-form-push--6-12--s {
    margin-left: 50%;
}
.vl-form-push--7-12--s {
    margin-left: 58.3333333333%;
}
.vl-form-push--2-3--s, .vl-form-push--4-6--s, .vl-form-push--8-12--s {
    margin-left: 66.6666666667%;
}
.vl-form-push--3-4--s, .vl-form-push--9-12--s {
    margin-left: 75%;
}
.vl-form-push--5-6--s, .vl-form-push--10-12--s {
    margin-left: 83.3333333333%;
}
.vl-form-push--11-12--s {
    margin-left: 91.6666666667%;
}
.vl-form-col--omega--s {
    margin-left: auto;
}
}
@media screen and (min-width: 1280px) {
.vl-form-grid--wide {
    margin-left: calc(-4.1666666667% - 3rem);
    margin-right: -4.1666666667%;
}
}
.vl-grid--is-stacked-large {
  margin-bottom: -6rem;
}
@media screen and (max-width: 767px) {
.vl-grid--is-stacked-large {
    margin-bottom: -3rem;
}
}
.vl-grid--is-stacked-large > * {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-grid--is-stacked-large > * {
    margin-bottom: 3rem;
}
}
.vl-grid--is-stacked-small {
  margin-bottom: -1.5rem;
}
.vl-grid--is-stacked-small > * {
  margin-bottom: 1.5rem;
}
.vl-form-grid--is-stacked-large {
  margin-bottom: -3rem;
}
.vl-form-grid--is-stacked-large > * {
  margin-bottom: 3rem;
}
.vl-form-grid--is-stacked-small {
  margin-bottom: -1rem;
}
.vl-form-grid--is-stacked-small > * {
  margin-bottom: 1rem;
}
.vl-page {
  position: relative;
  width: 100%;
  background-color: #fff;
}
.vl-page .vl-main-content > .vl-region:last-child {
  padding-bottom: 10rem;
}
@media screen and (max-width: 767px) {
.vl-page .vl-main-content > .vl-region:last-child {
    padding-bottom: 7rem;
}
}
.vl-main-content {
  outline: none;
  position: relative;
}
.vl-region {
  margin: 0 auto;
  padding: 3rem 0 6rem;
}
@media screen and (max-width: 767px) {
.vl-region {
    padding: 3rem 0;
}
}
.vl-region:not(.vl-region--alt) + .vl-region:not(.vl-region--alt) {
  padding-top: 0;
}
.vl-region--alt {
  background-color: #f7f9fc;
}
.vl-region--overlap {
  background: linear-gradient(to bottom, transparent calc(50% - 30px), #f7f9fc calc(50% - 30px), #f7f9fc 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
}
.vl-region--overlap .vl-layout {
  border: 1px #cbd2da solid;
  padding-top: 50px;
  padding-bottom: 50px;
  background: #fff;
}
@media only screen and (max-width: 1295px) {
.vl-region--overlap .vl-layout {
    margin: 15px;
}
}
@media screen and (max-width: 1023px) {
.vl-region--overlap .vl-layout {
    padding-top: 20px;
    padding-bottom: 20px;
}
}
.vl-region--overlap + .vl-region--alt {
  padding-top: 0 !important;
}
.vl-region:not(.vl-region--alt) + .vl-region--alt,
.vl-region--alt + .vl-region:not(.vl-region--alt) {
  padding-top: 6rem;
}
@media screen and (max-width: 767px) {
.vl-region:not(.vl-region--alt) + .vl-region--alt,
  .vl-region--alt + .vl-region:not(.vl-region--alt) {
    padding-top: 3rem;
}
}
.vl-region:first-child {
  padding-top: 6rem;
}
@media screen and (max-width: 767px) {
.vl-region:first-child {
    padding-top: 2rem;
}
}
.vl-region--small {
  padding: 1.5rem 0;
}
@media screen and (max-width: 767px) {
.vl-region--small {
    padding: 2rem 0;
}
}
.vl-region--medium {
  padding: 3rem 0;
}
@media screen and (max-width: 767px) {
.vl-region--medium {
    padding: 2rem 0;
}
}
.vl-region--bordered + .vl-region--bordered {
  border-top: 1px solid #f7f9fc;
}
.vl-region--bordered + .vl-region--bordered.vl-region--alt {
  border-top-color: #fff;
}
.vl-region.vl-region--no-space {
  padding: 0;
}
.vl-region.vl-region--no-space-bottom {
  padding-bottom: 0;
}
.vl-region.vl-region--no-space-top {
  padding-top: 0;
}
.vl-layout {
  position: relative;
  margin: 0 auto;
  min-width: 1024px;
  max-width: 1280px;
  padding: 0 3rem;
}
@media screen and (max-width: 1023px) {
.vl-layout {
    width: auto;
    min-width: 768px;
    max-width: 1280px;
}
}
@media screen and (max-width: 767px) {
.vl-layout {
    width: auto;
    min-width: 0;
    padding: 0 1.5rem;
}
}
.js-vl-accordion {
  position: relative;
}
.js-vl-accordion--flex-reverse {
  display: flex;
  flex-direction: column-reverse;
}
.vl-accordion-list--bordered .vl-accordion-list__item {
  padding: 3rem 0;
  border-bottom: 1px solid #cbd2da;
  margin-bottom: 0;
}
@media screen and (max-width: 1023px) {
.vl-accordion-list--bordered .vl-accordion-list__item {
    padding: 2rem 0;
}
}
@media screen and (max-width: 767px) {
.vl-accordion-list--bordered .vl-accordion-list__item {
    padding: 1.5rem 0;
}
}
.vl-accordion-list--bordered .vl-accordion-list__item:first-child {
  border-top: 1px solid #cbd2da;
}
.vl-accordion-list__item {
  margin-bottom: 10px;
}
.vl-accordion-list__item .vl-accordion-list--bordered {
  margin-bottom: 0;
}
.vl-accordion__icon {
  flex: 0 0 22px;
  flex-shrink: 0;
  top: 5px;
  align-self: flex-start;
}
.vl-accordion__title {
  font-size: 20px;
}
@media screen and (max-width: 767px) {
.vl-accordion__title {
    font-size: 18px;
}
}
.vl-accordion__subtitle {
  margin-top: 5px;
  padding: 0 0 0 22px;
}
.vl-accordion__summary {
  position: relative;
}
.vl-accordion__summary:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-accordion__summary:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-accordion__summary:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-accordion__summary--no-toggle .vl-accordion__toggle {
  border: none;
  padding: 0px;
}
.vl-accordion__summary--no-toggle .vl-accordion__subtitle {
  padding: 0;
}
.vl-accordion__content {
  position: relative;
}
.js .vl-accordion__content {
  visibility: hidden;
  max-height: 0;
}
.js .js-vl-accordion--open > .vl-accordion__content {
  visibility: visible;
  max-height: none;
}
.vl-accordion__image-container .vl-image--full-width {
  margin-left: -2.2rem;
  width: calc(100% + 2.2rem * 2);
  max-width: calc(100% + 2.2rem * 2);
  margin-top: -2.2rem;
  margin-bottom: 2.2rem;
  max-height: 19rem;
  -o-object-fit: cover;
     object-fit: cover;
}
@media screen and (max-width: 767px) {
.vl-accordion__image-container .vl-image--full-width {
    margin-left: -1rem;
    width: calc(100% + 1rem * 2);
    max-width: calc(100% + 1rem * 2);
    margin-top: -1rem;
    margin-bottom: 1rem;
}
}
.vl-accordion__footer {
  min-height: 6px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
  background-size: 6px 6px;
  padding: 3rem 0;
}
@media screen and (max-width: 767px) {
.vl-accordion__footer {
    padding: 1.5rem 0;
}
}
.vl-accordion-list--bordered .vl-accordion__footer {
  padding-bottom: 0;
}
.vl-accordion__panel {
  padding: 2.2rem;
}
@media screen and (max-width: 500px) {
.vl-accordion__panel {
    padding: 1rem;
}
}
.vl-accordion__panel--xsmall {
  padding: 1rem;
}
.vl-accordion__panel--alt {
  margin-top: 1rem;
  background-color: #f7f9fc;
  padding-top: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-accordion__panel--alt {
    padding: 1rem;
}
}
.vl-accordion__panel--no-indent {
  padding-left: 0;
  padding-right: 0;
}
.vl-accordion__panel--overflow {
  overflow: auto;
}
.vl-accordion-list--bordered .vl-accordion__panel:not(.vl-accordion__panel--with-footer) {
  padding-bottom: 0;
}
.vl-action-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.vl-action-group a,
.vl-action-group button,
.vl-action-group .vl-button {
  margin-right: 1.4rem;
}
.vl-action-group a:last-child,
.vl-action-group button:last-child,
.vl-action-group .vl-button:last-child {
  margin-right: 0;
}
.vl-action-group--align-right {
  justify-content: flex-end;
}
.vl-action-group--align-center {
  justify-content: center;
}
.vl-action-group--space-between {
  justify-content: space-between;
}
.vl-action-group .vl-link, .vl-action-group .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-action-group .vl-icon, .vl-action-group .vl-sidebar-header__toggle {
  white-space: nowrap;
}
.vl-action-group--bordered > * {
  position: relative;
  margin: 0 1.6rem;
}
.vl-action-group--bordered > *:not(:last-child) {
  margin-right: 1.6rem;
}
.vl-action-group--bordered > *:last-child {
  border: 0;
}
.vl-action-group--bordered > *:first-child {
  margin-left: 0;
}
.vl-action-group--bordered > *:not(:last-child)::after {
  content: "";
  background-color: #cbd2da;
  height: 1.5rem;
  width: 0.1rem;
  right: -1.6rem;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
@media screen and (min-width: 1023px) {
.vl-action-group--collapse--l {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--l > *:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--l.vl-action-group--align-center, .vl-action-group--collapse--l.vl-action-group--align-right {
    align-items: center;
}
.vl-action-group--collapse--l.vl-action-group--align-center .vl-button, .vl-action-group--collapse--l.vl-action-group--align-right .vl-button {
    margin-right: 0;
}
.vl-action-group--collapse--l.vl-action-group--align-right {
    align-items: flex-end;
}
.vl-action-group--collapse--l .vl-link, .vl-action-group--collapse--l .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--l .vl-icon, .vl-action-group--collapse--l .vl-sidebar-header__toggle {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--l .vl-link:not(:last-child), .vl-action-group--collapse--l .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--l .vl-icon:not(:last-child), .vl-action-group--collapse--l .vl-sidebar-header__toggle:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--l .vl-link:not(:last-child)::after, .vl-action-group--collapse--l .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--l .vl-icon:not(:last-child)::after, .vl-action-group--collapse--l .vl-sidebar-header__toggle:not(:last-child)::after {
    display: none;
}
}
@media screen and (max-width: 1023px) {
.vl-action-group--collapse--m {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--m > *:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--m.vl-action-group--align-center, .vl-action-group--collapse--m.vl-action-group--align-right {
    align-items: center;
}
.vl-action-group--collapse--m.vl-action-group--align-center .vl-button, .vl-action-group--collapse--m.vl-action-group--align-right .vl-button {
    margin-right: 0;
}
.vl-action-group--collapse--m.vl-action-group--align-right {
    align-items: flex-end;
}
.vl-action-group--collapse--m .vl-link, .vl-action-group--collapse--m .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--m .vl-icon, .vl-action-group--collapse--m .vl-sidebar-header__toggle {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--m .vl-link:not(:last-child), .vl-action-group--collapse--m .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--m .vl-icon:not(:last-child), .vl-action-group--collapse--m .vl-sidebar-header__toggle:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--m .vl-link:not(:last-child)::after, .vl-action-group--collapse--m .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--m .vl-icon:not(:last-child)::after, .vl-action-group--collapse--m .vl-sidebar-header__toggle:not(:last-child)::after {
    display: none;
}
}
@media screen and (max-width: 767px) {
.vl-action-group--collapse--s {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--s > *:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--s.vl-action-group--align-center, .vl-action-group--collapse--s.vl-action-group--align-right {
    align-items: center;
}
.vl-action-group--collapse--s.vl-action-group--align-center .vl-button, .vl-action-group--collapse--s.vl-action-group--align-right .vl-button {
    margin-right: 0;
}
.vl-action-group--collapse--s.vl-action-group--align-right {
    align-items: flex-end;
}
.vl-action-group--collapse--s .vl-link, .vl-action-group--collapse--s .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--s .vl-icon, .vl-action-group--collapse--s .vl-sidebar-header__toggle {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--s .vl-link:not(:last-child), .vl-action-group--collapse--s .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--s .vl-icon:not(:last-child), .vl-action-group--collapse--s .vl-sidebar-header__toggle:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--s .vl-link:not(:last-child)::after, .vl-action-group--collapse--s .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--s .vl-icon:not(:last-child)::after, .vl-action-group--collapse--s .vl-sidebar-header__toggle:not(:last-child)::after {
    display: none;
}
}
@media screen and (max-width: 500px) {
.vl-action-group--collapse--xs {
    flex-direction: column;
    align-items: flex-start;
}
.vl-action-group--collapse--xs > *:not(:last-child) {
    margin-bottom: 1rem;
}
.vl-action-group--collapse--xs.vl-action-group--align-center, .vl-action-group--collapse--xs.vl-action-group--align-right {
    align-items: center;
}
.vl-action-group--collapse--xs.vl-action-group--align-center .vl-button, .vl-action-group--collapse--xs.vl-action-group--align-right .vl-button {
    margin-right: 0;
}
.vl-action-group--collapse--xs.vl-action-group--align-right {
    align-items: flex-end;
}
.vl-action-group--collapse--xs .vl-link, .vl-action-group--collapse--xs .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--xs .vl-icon, .vl-action-group--collapse--xs .vl-sidebar-header__toggle {
    border-right: 0;
    display: block;
    padding-right: 0;
    text-align: left;
    flex: 1 0 100%;
    margin: 0;
}
.vl-action-group--collapse--xs .vl-link:not(:last-child), .vl-action-group--collapse--xs .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child), .vl-sidebar-panel-list-item__button .vl-action-group--collapse--xs .vl-icon:not(:last-child), .vl-action-group--collapse--xs .vl-sidebar-header__toggle:not(:last-child) {
    margin-bottom: 0.5rem;
}
.vl-action-group--collapse--xs .vl-link:not(:last-child)::after, .vl-action-group--collapse--xs .vl-sidebar-panel-list-item__button .vl-icon:not(:last-child)::after, .vl-sidebar-panel-list-item__button .vl-action-group--collapse--xs .vl-icon:not(:last-child)::after, .vl-action-group--collapse--xs .vl-sidebar-header__toggle:not(:last-child)::after {
    display: none;
}
}
.vl-alert {
  display: flex;
  position: relative;
  background-color: #e8ebee;
  border: 0.1rem solid #cfd5dd;
  padding: 2.5rem 3rem;
  border-radius: 0.3rem;
}
@media screen and (max-width: 767px) {
.vl-alert {
    padding: 1.5rem;
}
}
.vl-alert__close {
  display: flex;
  position: absolute;
  border: 0;
  cursor: pointer;
  top: 0.9rem;
  right: 0.9rem;
  padding: 0.5rem;
  font-size: 1.6rem;
  overflow: hidden;
}
.vl-alert__close:hover, .vl-alert__close:focus {
  color: #003bb0;
}
.vl-alert__close > .vl-vi {
  display: inline-flex;
}
.vl-alert__content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}
@media screen and (max-width: 767px) {
.vl-alert__content-wrapper {
    flex-wrap: wrap;
}
}
.vl-alert__content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-basis: 100%;
}
@media screen and (max-width: 767px) {
.vl-alert__content {
    flex-basis: auto;
    flex-grow: 1;
}
}
.vl-alert__icon {
  flex: 0 0 auto;
  margin-right: 2.5rem;
  font-size: 2.4rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-alert__icon {
    margin-right: 1.5rem;
    font-size: 1.6rem;
    margin-top: 3px;
}
}
.vl-alert__title {
  font-size: 1.8rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.4rem;
  line-height: 1.44;
}
@media screen and (max-width: 767px) {
.vl-alert__title {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
.vl-alert__title {
  margin-bottom: 0.3rem;
}
.vl-alert__actions {
  margin-top: 1.5rem;
}
.vl-alert__message {
  color: #333332;
}
.vl-alert--cta::before {
  content: "";
  position: absolute;
  top: -0.1rem;
  left: -0.1rem;
  width: calc(100% + 0.2rem);
  height: 0.3rem;
  background: #05c;
}
.vl-alert--accent {
  background-color: rgba(var(--vl-theme-primary-color-rgb, 255, 230, 21), 0.1);
  border-color: rgba(var(--vl-theme-primary-color-rgb, 255, 230, 21), 0.3);
}
.vl-alert--accent .vl-alert__icon {
  color: #000;
}
.vl-alert--error {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-color: #edafb1;
}
.vl-alert--error .vl-alert__icon {
  color: #aa2729;
}
.vl-alert--warning {
  background-color: rgb(100%, 96.3137254902%, 90.3921568627%);
  border-color: rgb(100%, 85.2549019608%, 61.568627451%);
}
.vl-alert--warning .vl-alert__icon {
  color: #d07b06;
}
.vl-alert--success {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-color: rgb(60%, 84.7843137255%, 71.137254902%);
}
.vl-alert--success .vl-alert__icon {
  color: #007a37;
}
.vl-alert--info {
  background-color: #f7f9fc;
  border-color: #e8ebee;
}
.vl-alert--naked {
  background: transparent;
  padding: 0;
  border: 0;
  border-radius: 0;
}
.vl-alert--naked .vl-alert__icon {
  margin-right: 1.5rem;
}
.vl-alert--naked .vl-alert__content {
  display: block;
}
.vl-alert--naked .vl-alert__title {
  margin-bottom: 0;
}
.vl-alert--naked .vl-alert__title > * {
  display: inline;
}
.vl-alert--naked.vl-alert--error .vl-alert__icon {
  color: #d2373c;
}
.vl-alert--naked p {
  display: inline;
}
.vl-alert--small {
  font-size: 1.4rem;
  line-height: 1.2;
  padding: 1.5rem;
}
.vl-alert--small .vl-alert__title {
  font-size: 1.6rem;
}
.vl-alert--small .vl-alert__icon {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
  margin-right: 1.5rem;
}
.vl-alert--small .vl-alert__actions {
  margin-top: 1rem;
}
.vl-alert--large {
  padding: 5rem 5.5rem;
}
@media screen and (max-width: 767px) {
.vl-alert--large {
    padding: 1.5rem;
}
}
.vl-alert--large .vl-alert__title {
  font-size: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-alert--large .vl-alert__title {
    font-size: 2rem;
}
}
.vl-alert--center {
  align-items: center;
}
.vl-alert__image {
  width: 8rem;
  height: auto;
  margin-right: 4rem;
}
@media screen and (max-width: 767px) {
.vl-alert__image {
    width: 7rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
}
.vl-alert__image + .vl-alert__content {
    max-width: calc(100% - 8rem);
}
}
@media screen and (max-width: 500px) {
.vl-alert__image + .vl-alert__content {
    max-width: none;
}
}
.vl-annotation {
  color: #687483;
  font-weight: 400;
  font-size: inherit;
}
.vl-annotation--small {
  font-size: 0.65em;
}
.vl-annotation__list-item {
  display: list-item;
  list-style-type: disc;
  float: left;
  margin-left: 3rem;
}
.vl-annotation__list-item:first-of-type {
  margin-left: 0;
  list-style-type: none;
}
.vl-annotation__list-item--iconless {
  list-style-type: none;
  margin-left: 1rem;
}
.vl-badge {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 2.25rem;
  display: inline-block;
  border: 0;
  flex-shrink: 0;
  position: relative;
  background-color: #fff;
}
.vl-badge--initials {
  position: relative;
}
.vl-badge--initials span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  text-transform: uppercase;
  color: #333332;
  font-weight: 500;
  margin: 0 0.5px;
}
.vl-badge--initials.vl-badge--action span, .vl-badge--initials.vl-badge--success span, .vl-badge--initials.vl-badge--error span {
  color: #fff;
}
.vl-badge--bullet {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.4rem;
}
.vl-badge--bullet.vl-badge--icon .vl-vi {
  display: none;
}
.vl-badge--bullet.vl-badge--initials span {
  display: none;
}
.vl-badge--inline .vl-badge--bullet {
  margin-right: 10px;
}
@media screen and (max-width: 767px) {
.vl-badge--inline .vl-badge--bullet {
    margin-right: 7px;
}
}
.vl-badge--alt {
  background-color: #f7f9fc;
}
.vl-badge--white {
  background-color: #fff;
}
.vl-badge--accent {
  color: var(--vl-theme-accent-fg-color, var(--vl-theme-fg-color));
  background-color: var(--vl-theme-accent-color, var(--vl-theme-primary-color));
}
.vl-badge--accent ::before {
  color: var(--vl-theme-accent-fg-color);
}
.vl-badge--accent span {
  color: var(--vl-theme-accent-fg-color, #333332);
}
.vl-badge--action {
  color: var(--vl-theme-action-fg-color, #fff);
  background-color: var(--vl-theme-action-color, #05c);
}
.vl-badge--action span {
  color: var(--vl-theme-action-fg-color, #333332);
}
.vl-badge--success {
  color: #fff;
  background-color: #007a37;
}
.vl-badge--success span {
  color: #fff;
}
.vl-badge--error {
  color: #fff;
  background-color: #d2373c;
}
.vl-badge--error span {
  color: #fff;
}
.vl-badge--warning {
  background-color: #ffA10a;
}
.vl-badge--border {
  border: 1px solid #cbd2da;
}
.vl-badge--block {
  display: block;
}
.vl-badge__img {
  border-radius: 50%;
}
.vl-badge--icon {
  position: relative;
}
.vl-badge--icon.vl-badge--action .vl-badge__icon, .vl-badge--icon.vl-badge--success .vl-badge__icon, .vl-badge--icon.vl-badge--error .vl-badge__icon {
  color: #fff;
}
.vl-badge__icon {
  margin: -0.5px 0.5px;
}
.vl-badge--icon .vl-badge__icon, .vl-badge--icon .vl-badge__image-icon img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  color: #333332;
  fill: #333332;
}
.vl-badge img {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
.vl-badge img.vl-badge__icon {
  height: 70%;
}
.vl-badge--icon .vl-badge__image-icon img {
  height: 70%;
  width: 70%;
  -o-object-fit: contain;
     object-fit: contain;
  border-radius: 0;
}
.vl-badge.vl-badge--icon > .vl-vi {
  font-size: 1.8rem;
}
.vl-badge.vl-badge--icon .vl-badge__icon {
  line-height: 2.4rem;
  font-size: 2.4rem;
}
.vl-badge.vl-badge--initials span {
  font-size: 1.8rem;
}
.vl-badge--xxsmall, .vl-badge--medium .vl-badge__notification .vl-badge, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge, .vl-badge--small .vl-badge__notification .vl-badge, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge, .vl-badge--xsmall .vl-badge__notification .vl-badge, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge, .vl-badge--xxsmall .vl-badge__notification .vl-badge {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 0.8rem;
}
.vl-badge--xxsmall.vl-badge--icon > .vl-vi, .vl-badge--medium .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi, .vl-badge--small .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi, .vl-badge--xsmall .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi, .vl-badge--xxsmall .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi {
  font-size: 1rem;
}
.vl-badge--xxsmall.vl-badge--icon .vl-badge__icon, .vl-badge--medium .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon, .vl-badge--small .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon, .vl-badge--xsmall .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon, .vl-badge--xxsmall .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon {
  line-height: 0.8rem;
  font-size: 0.8rem;
}
.vl-badge--xxsmall.vl-badge--initials span, .vl-badge--medium .vl-badge__notification .vl-badge--initials.vl-badge span, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--initials.vl-badge span, .vl-badge--small .vl-badge__notification .vl-badge--initials.vl-badge span, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--initials.vl-badge span, .vl-badge--xsmall .vl-badge__notification .vl-badge--initials.vl-badge span, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge--initials.vl-badge span, .vl-badge--xxsmall .vl-badge__notification .vl-badge--initials.vl-badge span {
  font-size: 1rem;
}
.vl-badge--xxsmall .vl-badge__notification, .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification, .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification, .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification, .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xxsmall .vl-badge__notification--top, .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--top, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--top, .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--top, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--top, .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--top, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--top, .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--xxsmall .vl-badge__notification--right, .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--right, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--right, .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--right, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--right, .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--right, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--right, .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--xxsmall .vl-badge__notification--bottom, .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--bottom, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--bottom, .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--bottom, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--bottom, .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--bottom, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--bottom, .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xxsmall .vl-badge__notification--left, .vl-badge--medium .vl-badge__notification .vl-badge .vl-badge__notification--left, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--left, .vl-badge--small .vl-badge__notification .vl-badge .vl-badge__notification--left, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--left, .vl-badge--xsmall .vl-badge__notification .vl-badge .vl-badge__notification--left, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge .vl-badge__notification--left, .vl-badge--xxsmall .vl-badge__notification .vl-badge .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge--xsmall, .vl-badge--large .vl-badge__notification .vl-badge {
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
}
.vl-badge--xsmall.vl-badge--icon > .vl-vi, .vl-badge--large .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi {
  font-size: 1rem;
}
.vl-badge--xsmall.vl-badge--icon .vl-badge__icon, .vl-badge--large .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon {
  line-height: 1.2rem;
  font-size: 1.2rem;
}
.vl-badge--xsmall.vl-badge--initials span, .vl-badge--large .vl-badge__notification .vl-badge--initials.vl-badge span {
  font-size: 1rem;
}
.vl-badge--xsmall .vl-badge__notification, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xsmall .vl-badge__notification--top, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--xsmall .vl-badge__notification--right, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--xsmall .vl-badge__notification--bottom, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xsmall .vl-badge__notification--left, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge--small, .vl-badge--xlarge .vl-badge__notification .vl-badge {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 1.375rem;
}
.vl-badge--small.vl-badge--icon > .vl-vi, .vl-badge--xlarge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi {
  font-size: 1.4rem;
}
.vl-badge--small.vl-badge--icon .vl-badge__icon, .vl-badge--xlarge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon {
  line-height: 1.6rem;
  font-size: 1.6rem;
}
.vl-badge--small.vl-badge--initials span, .vl-badge--xlarge .vl-badge__notification .vl-badge--initials.vl-badge span {
  font-size: 1.4rem;
}
.vl-badge--small .vl-badge__notification, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--small .vl-badge__notification--top, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--small .vl-badge__notification--right, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--small .vl-badge__notification--bottom, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--small .vl-badge__notification--left, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge--medium, .vl-badge--xxlarge .vl-badge__notification .vl-badge {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 2.25rem;
}
.vl-badge--medium.vl-badge--icon > .vl-vi, .vl-badge--xxlarge .vl-badge__notification .vl-badge--icon.vl-badge > .vl-vi {
  font-size: 1.8rem;
}
.vl-badge--medium.vl-badge--icon .vl-badge__icon, .vl-badge--xxlarge .vl-badge__notification .vl-badge--icon.vl-badge .vl-badge__icon {
  line-height: 2.4rem;
  font-size: 2.4rem;
}
.vl-badge--medium.vl-badge--initials span, .vl-badge--xxlarge .vl-badge__notification .vl-badge--initials.vl-badge span {
  font-size: 1.8rem;
}
.vl-badge--medium .vl-badge__notification, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--medium .vl-badge__notification--top, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--medium .vl-badge__notification--right, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--medium .vl-badge__notification--bottom, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--medium .vl-badge__notification--left, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge--large {
  width: 5.75rem;
  height: 5.75rem;
  border-radius: 2.875rem;
}
.vl-badge--large.vl-badge--icon > .vl-vi {
  font-size: 2.2rem;
}
.vl-badge--large.vl-badge--icon .vl-badge__icon {
  line-height: 3.2rem;
  font-size: 3.2rem;
}
.vl-badge--large.vl-badge--initials span {
  font-size: 2.2rem;
}
.vl-badge--large .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--large .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--large .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--large .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--large .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge--xlarge {
  width: 10rem;
  height: 10rem;
  border-radius: 5rem;
}
.vl-badge--xlarge.vl-badge--icon > .vl-vi {
  font-size: 3.2rem;
}
.vl-badge--xlarge.vl-badge--icon .vl-badge__icon {
  line-height: 4.2rem;
  font-size: 4.2rem;
}
.vl-badge--xlarge.vl-badge--initials span {
  font-size: 3.2rem;
}
.vl-badge--xlarge .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xlarge .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--xlarge .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--xlarge .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xlarge .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge--xxlarge {
  width: 15rem;
  height: 15rem;
  border-radius: 7.5rem;
}
.vl-badge--xxlarge.vl-badge--icon > .vl-vi {
  font-size: 4.4rem;
}
.vl-badge--xxlarge.vl-badge--icon .vl-badge__icon {
  line-height: 6.3rem;
  font-size: 6.3rem;
}
.vl-badge--xxlarge.vl-badge--initials span {
  font-size: 4.4rem;
}
.vl-badge--xxlarge .vl-badge__notification {
  position: absolute;
  top: 0rem;
  right: -0.5rem;
  line-height: 1;
}
.vl-badge--xxlarge .vl-badge__notification--top {
  top: 0rem;
}
.vl-badge--xxlarge .vl-badge__notification--right {
  right: -0.5rem;
}
.vl-badge--xxlarge .vl-badge__notification--bottom {
  top: initial;
  bottom: 0rem;
}
.vl-badge--xxlarge .vl-badge__notification--left {
  right: initial;
  left: -0.5rem;
}
.vl-badge-container--condensed .vl-badge {
  margin-left: -1.625rem;
}
.vl-badge-container--condensed .vl-badge--xxsmall, .vl-badge-container--condensed .vl-badge--xxsmall .vl-badge__notification .vl-badge, .vl-badge--xxsmall .vl-badge__notification .vl-badge-container--condensed .vl-badge, .vl-badge-container--condensed .vl-badge--xsmall .vl-badge__notification .vl-badge, .vl-badge--xsmall .vl-badge__notification .vl-badge-container--condensed .vl-badge, .vl-badge-container--condensed .vl-badge--small .vl-badge__notification .vl-badge, .vl-badge--small .vl-badge__notification .vl-badge-container--condensed .vl-badge, .vl-badge-container--condensed .vl-badge--medium .vl-badge__notification .vl-badge, .vl-badge--medium .vl-badge__notification .vl-badge-container--condensed .vl-badge, .vl-badge-container--condensed .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge, .vl-badge--large .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge-container--condensed .vl-badge, .vl-badge-container--condensed .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge, .vl-badge--xlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge-container--condensed .vl-badge, .vl-badge-container--condensed .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge, .vl-badge--xxlarge .vl-badge__notification .vl-badge .vl-badge__notification .vl-badge-container--condensed .vl-badge {
  margin-left: -0.9rem;
}
.vl-badge-container--condensed .vl-badge--xsmall, .vl-badge-container--condensed .vl-badge--large .vl-badge__notification .vl-badge, .vl-badge--large .vl-badge__notification .vl-badge-container--condensed .vl-badge {
  margin-left: -1rem;
}
.vl-badge-container--condensed .vl-badge--small, .vl-badge-container--condensed .vl-badge--xlarge .vl-badge__notification .vl-badge, .vl-badge--xlarge .vl-badge__notification .vl-badge-container--condensed .vl-badge {
  margin-left: -1.1875rem;
}
.vl-badge-container--condensed .vl-badge--medium, .vl-badge-container--condensed .vl-badge--xxlarge .vl-badge__notification .vl-badge, .vl-badge--xxlarge .vl-badge__notification .vl-badge-container--condensed .vl-badge {
  margin-left: -1.625rem;
}
.vl-badge-container--condensed .vl-badge--large {
  margin-left: -1.9375rem;
}
.vl-badge-container--condensed .vl-badge--xlarge {
  margin-left: -3rem;
}
.vl-badge-container--condensed .vl-badge--xxlarge {
  margin-left: -4.25rem;
}
.vl-badge-container--condensed .vl-badge:first-child {
  margin-left: auto;
}
a.vl-button {
  cursor: pointer;
}
.vl-button {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  min-height: 3.5rem;
  font-size: 1.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  padding: 0.5rem 2rem;
  background-color: var(--vl-theme-action-color, #05c);
  text-decoration: none;
  border-radius: 0.3rem;
  color: #fff;
  text-align: center;
  outline: 0;
  max-width: 100%;
  cursor: default;
}
@media screen and (max-width: 767px) {
.vl-button {
    font-size: 1.6rem;
    padding: 1rem;
}
}
.vl-button:hover, .vl-button:focus {
  color: #fff;
}
.vl-button:hover {
  background-color: var(--vl-theme-action-hover-color, #003bb0);
  text-decoration: none;
}
.vl-button:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-button:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-button:active {
  background-color: var(--vl-theme-action-active-color, rgb(0%, 25%, 60%));
}
.vl-button:visited {
  color: #fff;
}
.vl-button--ellipse {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-button--ellipse .vl-button__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-button--secondary {
  background-color: transparent;
  color: var(--vl-theme-action-color, #05c);
  border: 0.2rem solid currentColor;
  transition: color 0.2s, border-color 0.2s, box-shadow 0.2s;
}
.vl-button--secondary:visited {
  color: #05c;
}
.vl-button--secondary:focus {
  color: var(--vl-theme-action-active-color, #05c);
}
.vl-button--secondary:hover, .vl-button--secondary:active {
  color: var(--vl-theme-action-hover-color, #003bb0);
  background-color: transparent;
  border-color: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-button--tertiary {
  background-color: transparent;
  color: var(--vl-theme-action-color, #05c);
  border: 0.1rem #c6cdd3 solid;
  transition: background-color 0.2s, box-shadow 0.2s;
}
.vl-button--tertiary:visited {
  color: var(--vl-theme-action-color, #05c);
}
.vl-button--tertiary:focus {
  color: var(--vl-theme-action-hover-color, #05c);
  border-color: var(--vl-theme-action-hover-color, #c6cdd3);
}
.vl-button--tertiary:hover, .vl-button--tertiary:active {
  color: var(--vl-theme-action-hover-color, #05c);
  background-color: transparent;
  border-color: var(--vl-theme-action-hover-color, #5990de);
  border-width: 0.2rem;
  padding: 0 calc(2rem - 0.1rem);
}
@media screen and (max-width: 767px) {
.vl-button--tertiary:hover, .vl-button--tertiary:active {
    padding: calc(1rem - 0.1rem);
}
}
.vl-button--tertiary.vl-button--large:hover, .vl-button--tertiary.vl-button--large:active {
  padding: calc(2rem - 0.1rem);
  padding-top: calc(1.5rem - 0.1rem);
  padding-bottom: calc(1.5rem - 0.1rem);
}
@media screen and (max-width: 767px) {
.vl-button--tertiary.vl-button--large:hover, .vl-button--tertiary.vl-button--large:active {
    padding-left: calc(1rem - 0.1rem);
    padding-right: calc(1rem - 0.1rem);
}
}
.vl-button--tertiary.vl-button--loading:hover, .vl-button--tertiary.vl-button--loading:active {
  padding: 0 calc(8rem - 0.1rem) 0 calc(4rem - 0.1rem);
}
@media screen and (max-width: 767px) {
.vl-button--tertiary.vl-button--loading:hover, .vl-button--tertiary.vl-button--loading:active {
    padding: 0 calc(8rem - 0.1rem) 0 calc(4rem - 0.1rem);
}
}
.vl-button--tertiary.vl-button--loading:focus {
  color: #fff;
}
.vl-button--block {
  display: flex;
  justify-content: center;
  width: 100%;
}
.vl-button--block.vl-button--icon-after, .vl-button--block.vl-button--icon-before {
  width: 100%;
}
.vl-button--icon {
  width: 3.5rem;
}
.vl-button--icon.vl-button {
  padding: 0;
}
.vl-button--icon.vl-button .vl-button__icon {
  margin: auto;
}
.vl-button--error {
  background-color: #d2373c;
}
.vl-button--error.vl-button--secondary {
  background-color: #fff;
  color: #d2373c;
}
.vl-button--error.vl-button--secondary:visited {
  color: #d2373c;
}
.vl-button--error.vl-button--secondary:hover, .vl-button--error.vl-button--secondary:active {
  color: #aa2729;
  border-color: #aa2729;
  background-color: transparent;
}
.vl-button--error.vl-button--tertiary {
  background-color: #fff;
  color: #d2373c;
  border-color: #d2373c;
}
.vl-button--error.vl-button--tertiary:visited {
  color: #d2373c;
}
.vl-button--error.vl-button--tertiary:hover, .vl-button--error.vl-button--tertiary:active {
  color: #aa2729;
  border-color: #aa2729;
  background-color: transparent;
}
.vl-button--error:hover, .vl-button--error:active {
  color: #fff;
  background-color: #aa2729;
}
.vl-button--large {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-size: 1.8rem;
}
.vl-button--wide {
  padding-left: 6rem;
  padding-right: 6rem;
}
.vl-button--narrow {
  padding-left: 1rem;
  padding-right: 1rem;
}
.vl-button--narrow.vl-button--tertiary:hover, .vl-button--narrow.vl-button--tertiary:active {
  padding: 0 calc(1rem - 0.1rem);
}
.vl-button--disabled {
  background-color: #cbd2d9;
  border-color: #cbd2d9;
  color: #687483;
  cursor: not-allowed;
}
.vl-button--disabled:hover, .vl-button--disabled:active {
  background-color: #cbd2d9;
  border-color: #cbd2d9;
  color: #687483;
}
.vl-button--loading {
  background-color: #cbd2d9;
  position: relative;
  color: #fff;
  padding: 0 8rem 0 4rem;
}
.vl-button--loading:hover, .vl-button--loading:active {
  background-color: #cbd2d9;
  color: #fff;
}
.vl-button--loading:focus {
  color: #fff;
}
.vl-button--loading::after {
  animation: waving-light infinite 1s linear;
}
@keyframes waving-light {
0% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px 0px #687483;
}
10% {
    box-shadow: 10px -3px #687483, 20px -0px #687483, 30px -0px #687483;
}
20% {
    box-shadow: 10px -6px #687483, 20px -3px #687483, 30px -0px #687483;
}
30% {
    box-shadow: 10px -3px #687483, 20px -6px #687483, 30px -3px #687483;
}
40% {
    box-shadow: 10px -0px #687483, 20px -3px #687483, 30px -6px #687483;
}
50% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -3px #687483;
}
60% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
100% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
}
.vl-button--loading::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  right: 4rem;
  margin-top: -0.2rem;
  margin-right: 3.2rem;
  width: 0.4rem;
  height: 0.4rem;
  background-color: #cbd2d9;
  border-radius: 50%;
  box-shadow: 1rem 0 #fff, 2rem 0 #fff, 3rem 0 #fff;
}
.vl-button--naked, .vl-button--naked-action {
  background-color: transparent;
  border: 0;
  color: #333332;
}
.vl-button--naked:hover, .vl-button--naked:focus, .vl-button--naked:active, .vl-button--naked:visited, .vl-button--naked-action:hover, .vl-button--naked-action:focus, .vl-button--naked-action:active, .vl-button--naked-action:visited {
  border: 0;
  color: #333332;
  background-color: transparent;
}
.vl-button--naked.vl-button--disabled, .vl-button--naked-action.vl-button--disabled {
  color: #687483;
}
.vl-button--naked.vl-button--disabled:hover, .vl-button--naked.vl-button--disabled:focus, .vl-button--naked.vl-button--disabled:active, .vl-button--naked.vl-button--disabled:visited, .vl-button--naked-action.vl-button--disabled:hover, .vl-button--naked-action.vl-button--disabled:focus, .vl-button--naked-action.vl-button--disabled:active, .vl-button--naked-action.vl-button--disabled:visited {
  color: #687483;
}
.vl-button--naked-action {
  color: var(--vl-theme-action-color, #05c);
}
.vl-button--naked-action:hover, .vl-button--naked-action:focus, .vl-button--naked-action:active, .vl-button--naked-action:visited {
  color: var(--vl-theme-action-color, #05c);
}
.vl-button__icon {
  display: inline-flex;
}
.vl-button__icon.vl-icon {
  display: inline-flex;
}
.vl-button__icon--before {
  margin-right: 0.8rem;
}
.vl-button__icon--after {
  margin-left: 0.8rem;
}
.vl-button-group {
  display: flex;
  flex-wrap: wrap;
}
.vl-button-group .vl-button {
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.vl-checkbox {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
.vl-checkbox:not(.vl-checkbox--block):not(:last-of-type) {
  margin-right: 1.5rem;
}
.vl-checkbox__label {
  display: flex;
  flex: 0 0 auto;
  font-size: 1.6rem;
  line-height: 2.4rem;
}
@media screen and (max-width: 767px) {
.vl-checkbox__label {
    line-height: 2.2rem;
}
}
.vl-checkbox__label .vl-checkbox__box::before, .vl-checkbox__label .vl-checkbox__box::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-checkbox__label .vl-checkbox__box::before {
  content: "\\f15a";
}
.vl-checkbox__label .vl-checkbox__box {
  position: relative;
  flex: 0 0 1.8rem;
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 0.3rem;
  margin-right: 1rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-checkbox__label .vl-checkbox__box {
    margin-top: 0.2rem;
}
}
.vl-checkbox__label .vl-checkbox__box::before {
  position: absolute;
  display: block;
  font-size: 0.8rem;
  color: #8695a8;
  line-height: 1;
  text-align: center;
  transform: translateZ(0) translate(-50%, -50%) scale(0);
  transition: all 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  top: 0.9rem;
  left: 0.9rem;
  z-index: 2;
}
.vl-checkbox__label .vl-checkbox__box::after {
  display: inline-block;
  content: "";
  background: #fff;
  width: 1.8rem;
  height: 1.8rem;
  border: 0.1rem #8695a8 solid;
  outline: 0.2rem transparent solid;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  z-index: 1;
  border-radius: 0.3rem;
}
.vl-checkbox__toggle {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-checkbox__toggle:focus + .vl-checkbox__label .vl-checkbox__box::after {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-checkbox__toggle:focus + .vl-checkbox__label .vl-checkbox__box::after {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-checkbox__toggle:focus + .vl-checkbox__label .vl-checkbox__box::after {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::before {
  transform: translateZ(0) translate(-50%, -50%) scale(1);
  color: #fff;
}
.vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::after {
  background: #05c;
  border: 0.1rem #05c solid;
}
.vl-checkbox--block {
  display: block;
  margin: 0;
}
.vl-checkbox--disabled .vl-checkbox__label {
  color: #687483;
}
.vl-checkbox--disabled .vl-checkbox__label .vl-checkbox__box::after {
  background-color: #8695a8;
  border-color: #8695a8;
  cursor: auto;
}
.vl-checkbox--disabled .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::after {
  background: #8695a8;
  border: 0.1rem #8695a8 solid;
}
.vl-checkbox--single {
  margin: 0;
}
.vl-checkbox--single .vl-checkbox__label {
  padding: 0;
}
.vl-checkbox--single .vl-checkbox__label .vl-checkbox__box {
  margin: 0;
}
.vl-checkbox--single .vl-checkbox__label .vl-checkbox__box::after {
  position: relative;
  top: auto;
  left: auto;
}
.vl-checkbox--single .vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label {
  margin: 0;
}
.vl-checkbox--error .vl-checkbox__label .vl-checkbox__box::after, .vl-checkbox.invalid.validated .vl-checkbox__label .vl-checkbox__box::after {
  background-color: #fff;
  border-color: #d2373c;
}
.vl-checkbox--error .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::before, .vl-checkbox.invalid.validated .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::before {
  color: #d2373c;
}
.vl-checkbox--error .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::after, .vl-checkbox.invalid.validated .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::after {
  background-color: #fff;
  border: 0.1rem #d2373c solid;
}
.vl-checkbox--success .vl-checkbox__label .vl-checkbox__box::after {
  background-color: #fff;
  border-color: #009e47;
}
.vl-checkbox--success .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::before {
  color: #009e47;
}
.vl-checkbox--success .vl-checkbox__toggle:checked + .vl-checkbox__label .vl-checkbox__box::after {
  background-color: #fff;
  border: 0.1rem #009e47 solid;
}
.vl-checkbox--empty {
  margin-top: 0;
}
.vl-checkbox--switch {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-checkbox--switch:focus + .vl-checkbox__label .vl-checkbox--switch__label {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label {
  background: #05c;
  border-color: #05c;
  position: relative;
}
.vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label::before, .vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label span::before {
  margin-left: calc(50% + 0.3rem);
  transform: translate(0.1rem, 0.1rem) scale(1);
  visibility: visible;
  opacity: 1;
}
.vl-checkbox--switch:checked + .vl-checkbox__label .vl-checkbox--switch__label::after {
  width: 2rem;
  height: 2rem;
  margin-left: 50%;
  background-color: #fff;
  border-color: #05c;
  transform: translate(-0.1rem, -0.1rem);
}
.vl-checkbox--switch:checked:disabled + .vl-checkbox__label .vl-checkbox--switch__label {
  border-color: #8695a8;
}
.vl-checkbox--switch:checked:disabled + .vl-checkbox__label .vl-checkbox--switch__label::after {
  border-color: #8695a8;
}
.vl-checkbox--switch + .vl-checkbox__label {
  align-items: center;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label {
  position: relative;
  display: inline-block;
  width: 4rem;
  height: 2.2rem;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  vertical-align: middle;
  outline: transparent solid 0.2rem;
  margin: 0 1rem 0 0;
  background: #fff;
  border: 0.1rem solid #8695a8;
  border-radius: 2em;
  padding: 0.1rem;
  transition: box-shadow 0.1s cubic-bezier(1, 0.1, 0, 0.9);
  line-height: 1rem;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span::before, .vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span::before {
  content: "\\f15a";
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span::before {
  font-size: 0.8rem;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label span::before {
  display: block;
  position: absolute;
  left: 0;
  margin: 0.3rem 0 0 0.3rem;
  transform: translate(0.4rem, 0.4rem) scale(0.6);
  transform-origin: 50%;
  transition: margin 0.2s cubic-bezier(1, 0.1, 0, 0.9), opacity 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  opacity: 0;
  visibility: hidden;
  z-index: 2;
}
.vl-checkbox--switch + .vl-checkbox__label .vl-checkbox--switch__label::after {
  position: relative;
  display: block;
  margin-left: 0;
  content: "";
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 2em;
  background: #8695a8;
  border: 0.1rem #8695a8 solid;
  transition: padding 0.3s ease, margin 0.2s cubic-bezier(1, 0.1, 0, 0.9);
}
.vl-checkbox--switch:disabled + .vl-checkbox__label {
  color: #687483;
}
.vl-checkbox--switch:disabled + .vl-checkbox__label .vl-checkbox--switch__label {
  background-color: #8695a8;
  border-color: #8695a8;
  cursor: default;
}
.vl-checkbox--switch:disabled + .vl-checkbox__label .vl-checkbox--switch__label::after {
  border-color: #f3f5f6;
}
.vl-checkbox__annotation {
  margin-left: auto;
  font-size: 1.5rem;
}
.vl-content-header {
  background-color: var(--vl-theme-primary-color);
  min-width: 768px;
  overflow: hidden;
  max-height: 40rem;
  min-height: 10rem;
  position: relative;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-content-header > .vl-layout {
    position: static;
}
}
.vl-content-header__logo-wrapper {
  display: flex;
  align-items: center;
}
.vl-content-header__logo-wrapper + * {
  margin-top: 0.4rem;
}
.vl-content-header__wrapper {
  overflow: hidden;
}
.vl-content-header--has-logo {
  background-color: #fff;
}
.vl-content-header--no-image {
  border-bottom: 1px solid #cbd2da;
}
@media screen and (max-width: 767px) {
.vl-content-header {
    min-width: 0;
    max-height: none;
    display: none;
}
.vl-content-header.vl-content-header--show-mobile {
    display: block;
}
}
@media screen and (max-width: 767px) {
.vl-content-header:not(.vl-content-header--show-mobile) .vl-content-header__context {
    position: absolute;
    float: none;
    left: 0;
    max-width: 100%;
    bottom: 100%;
    margin-bottom: 1rem;
    padding: 0.3rem 1rem 0.4rem;
}
}
.vl-content-header--alt .vl-content-header__context__content, .vl-content-header--alt .vl-content-header__context__link,
.vl-content-header--alt .vl-content-header__title__content,
.vl-content-header--alt .vl-content-header__title__link {
  color: #333332;
}
.vl-content-header--alt .vl-content-header__context__content:hover, .vl-content-header--alt .vl-content-header__context__content:focus, .vl-content-header--alt .vl-content-header__context__link:hover, .vl-content-header--alt .vl-content-header__context__link:focus,
.vl-content-header--alt .vl-content-header__title__content:hover,
.vl-content-header--alt .vl-content-header__title__content:focus,
.vl-content-header--alt .vl-content-header__title__link:hover,
.vl-content-header--alt .vl-content-header__title__link:focus {
  color: #333332;
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color-70) 21px);
}
.vl-content-header--alt .vl-content-header__context__content,
.vl-content-header--alt .vl-content-header__title__content {
  background-color: var(--vl-theme-primary-color);
}
.vl-content-header--alt .vl-content-header__context__content:hover, .vl-content-header--alt .vl-content-header__context__content:focus,
.vl-content-header--alt .vl-content-header__title__content:hover,
.vl-content-header--alt .vl-content-header__title__content:focus {
  background: var(--vl-theme-primary-color-70);
}
.vl-content-header--alt.vl-content-header--has-context .vl-content-header__title__link {
  background: linear-gradient(70deg, transparent 20px, var(--vl-theme-primary-color) 21px);
}
.vl-content-header--alt.vl-content-header--has-context .vl-content-header__title__link:hover, .vl-content-header--alt.vl-content-header--has-context .vl-content-header__title__link:focus {
  background: linear-gradient(70deg, transparent 20px, var(--vl-theme-primary-color-70) 21px);
}
.vl-content-header__bg {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  max-height: 40rem;
}
.vl-content-header__bg img {
  position: absolute;
  top: -9999px;
  bottom: -9999px;
  left: -9999px;
  right: -9999px;
  margin: auto;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
@supports ((-o-object-fit: cover) or (object-fit: cover)) {
.vl-content-header__bg img {
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
}
.vl-content-header__bg img {
  display: block;
  max-width: none;
}
.vl-content-header--half-image .vl-content-header__bg {
  position: absolute;
  left: 50%;
  right: -20%;
  transform: skew(20deg);
  overflow: hidden;
  transform-origin: 100% 50%;
}
.vl-content-header--half-image .vl-content-header__bg img {
  transform-origin: 100% 0%;
  transform: skew(-20deg);
}
.vl-content-header--large, .vl-content-header--small, .vl-content-header--xsmall {
  max-height: none;
}
.vl-content-header--large .vl-content-header__wrapper, .vl-content-header--small .vl-content-header__wrapper, .vl-content-header--xsmall .vl-content-header__wrapper {
  display: flex;
  flex-direction: row;
}
.vl-content-header--large .vl-content-header__wrapper > .vl-layout, .vl-content-header--small .vl-content-header__wrapper > .vl-layout, .vl-content-header--xsmall .vl-content-header__wrapper > .vl-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 1 auto;
}
.vl-content-header--large .vl-content-header__content, .vl-content-header--small .vl-content-header__content, .vl-content-header--xsmall .vl-content-header__content {
  position: relative;
  bottom: auto;
}
.vl-content-header--large .vl-content-header__content > *, .vl-content-header--small .vl-content-header__content > *, .vl-content-header--xsmall .vl-content-header__content > * {
  vertical-align: bottom;
}
.vl-content-header--small .vl-content-header__wrapper > .vl-layout {
  min-height: 15rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header--small .vl-content-header__wrapper > .vl-layout {
    min-height: 11rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header--small .vl-content-header__wrapper > .vl-layout {
    min-height: 8rem;
    padding-bottom: 1rem;
    padding-top: 1rem;
}
}
.vl-content-header--large .vl-content-header__wrapper > .vl-layout {
  min-height: 31.5rem;
  padding-bottom: 6rem;
  padding-top: 6rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header--large .vl-content-header__wrapper > .vl-layout {
    min-height: 25.5rem;
    padding-bottom: 3rem;
    padding-top: 3rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header--large .vl-content-header__wrapper > .vl-layout {
    min-height: 11rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
}
}
.vl-content-header--xsmall {
  min-height: 9.5rem;
}
@media screen and (max-width: 767px) {
.vl-content-header--xsmall {
    min-height: 5.5rem;
}
}
.vl-content-header--xsmall .vl-content-header {
  min-height: 9.5rem;
}
.vl-content-header--xsmall .vl-content-header__wrapper > .vl-layout {
  min-height: 9.5rem;
  padding-bottom: 2.5rem;
  padding-top: 2.5rem;
}
@media screen and (max-width: 767px) {
.vl-content-header--xsmall .vl-content-header__wrapper > .vl-layout {
    min-height: 5.5rem;
    padding-bottom: 1.5rem;
    padding-top: 1.5rem;
}
}
.vl-content-header__logo {
  background-color: #fff;
  white-space: nowrap;
  position: relative;
  color: #333332;
  display: inline-block;
  vertical-align: middle;
}
.vl-content-header__logo__img {
  background-color: var(--vl-theme-primary-color);
  width: 8rem;
  height: 9rem;
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__img {
    width: 4.5rem;
    height: 5rem;
}
}
.vl-content-header__logo__img svg {
  width: 3.9rem;
  height: 6rem;
  margin-top: 1.5rem;
  margin-left: 1.5rem;
  fill: #333332;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__img svg {
    width: 2.9rem;
    height: 3rem;
    margin-top: 1rem;
    margin-left: 0.3rem;
}
}
.vl-content-header__logo__img::after {
  display: block;
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  border-top: 9rem solid #fff;
  border-left: 3.0781812899rem solid transparent;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__img::after {
    border-top: 5rem solid #fff;
    border-left: 1.7101007166rem solid transparent;
}
}
.vl-content-header--no-image .vl-content-header__logo__img, .vl-content-header--half-image .vl-content-header__logo__img {
  background-color: transparent;
}
.vl-content-header--no-image .vl-content-header__logo__img::after, .vl-content-header--half-image .vl-content-header__logo__img::after {
  height: 100%;
  border: 0;
  width: 1px;
  background-color: #333332;
  transform: rotate(-20deg);
  transform-origin: 100% 80%;
}
.vl-content-header--no-image .vl-content-header__logo, .vl-content-header--half-image .vl-content-header__logo {
  background-color: transparent;
  color: #333332;
}
.vl-content-header__logo__text {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-right: 2rem;
  margin-left: -0.2rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__text {
    padding-right: 1rem;
}
}
.vl-content-header__logo__title {
  font-weight: 500;
  font-size: 3rem;
  margin-bottom: 0.3rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header__logo__title {
    font-size: 2.4rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__title {
    font-size: 1.6rem;
}
}
.vl-content-header__logo__tagline {
  display: block;
  font-size: 1.7rem;
  margin-left: 5px;
  font-weight: normal;
  margin-top: 2px;
}
@media screen and (max-width: 1023px) {
.vl-content-header__logo__tagline {
    font-size: 1.35rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__logo__tagline {
    margin-left: 3px;
    font-size: 1.1rem;
}
}
.vl-content-header__entity-logo + .vl-content-header__logo {
  vertical-align: top;
  margin-left: -1.5rem;
}
@media screen and (max-width: 1023px) {
.vl-content-header__entity-logo + .vl-content-header__logo {
    margin-left: -1.5rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__entity-logo + .vl-content-header__logo {
    display: none;
}
}
.vl-content-header__entity-logo {
  display: inline-block;
  vertical-align: top;
  padding: 1rem 2rem;
  font-size: 2.6rem;
  line-height: 0.95;
  text-transform: uppercase;
  background-color: var(--vl-theme-primary-color);
  color: #333332;
  text-decoration: none;
}
.vl-content-header__entity-logo--right {
  text-align: right;
}
.vl-content-header__entity-logo--lowercase {
  text-transform: none;
}
.vl-content-header__entity-logo--serif {
  font-family: "Flanders Art Serif", serif;
}
.vl-content-header__entity-logo--neutral {
  color: #333332;
}
@media screen and (max-width: 1023px) {
.vl-content-header__entity-logo {
    font-size: 2rem;
}
}
@media screen and (max-width: 767px) {
.vl-content-header__entity-logo {
    font-size: 1.6rem;
    padding: 0.5rem 1rem;
    text-align: left;
}
}
.vl-content-header__entity-logo__prefix, .vl-content-header__entity-logo__title {
  display: block;
}
.vl-content-header__entity-logo__title {
  font-weight: 500;
}
.vl-content-header__entity-logo--small {
  font-size: 1.6rem;
}
.vl-content-header--alt .vl-content-header__entity-logo {
  color: #333332;
  background-color: #fff;
}
.vl-content-header--has-logo .vl-content-header__entity-logo {
  height: 9rem;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
}
@media screen and (max-width: 767px) {
.vl-content-header--has-logo .vl-content-header__entity-logo {
    height: 5rem;
}
}
.vl-content-header--has-logo .vl-content-header__entity-logo + .vl-content-header__logo {
  vertical-align: top;
  margin-left: -1.5rem;
}
a.vl-content-header__entity-logo:hover, a.vl-content-header__entity-logo:focus {
  background-color: var(--vl-theme-primary-color);
  color: #333332;
}
.vl-content-header--alt a.vl-content-header__entity-logo:hover, .vl-content-header--alt a.vl-content-header__entity-logo:focus {
  background-color: white;
  color: #003bb0;
}
.vl-content-header__img-logo {
  display: inline-block;
}
.vl-content-header__img-logo__img {
  max-width: 30rem;
  max-height: 7.5rem;
  width: auto;
  height: auto;
}
@media screen and (max-width: 767px) {
.vl-content-header__img-logo__img {
    max-width: 15rem;
    max-height: 3.5rem;
}
}
.vl-content-header--has-actions::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 0.3rem;
  background-color: #f7f9fc;
  z-index: 2;
}
@media screen and (max-width: 767px) {
.vl-content-header--has-actions::before {
    display: none;
}
}
.vl-content-header__actions {
  background-color: #f7f9fc;
}
.vl-content-header .vl-content-header__action {
  color: #333332;
}
.vl-content-header .vl-content-header__action + .vl-content-header__action {
  border-left: 1px solid #333332;
}
.vl-content-header .vl-content-header__action a,
.vl-content-header .vl-content-header__action button {
  color: #333332;
}
.vl-content-header .vl-content-header__action a:hover, .vl-content-header .vl-content-header__action a:focus,
.vl-content-header .vl-content-header__action button:hover,
.vl-content-header .vl-content-header__action button:focus {
  color: #05c;
}
.vl-content-header__actions::before, .vl-content-header__actions::after {
  content: "";
  display: table;
}
.vl-content-header__actions::after {
  clear: both;
}
.vl-content-header__actions {
  padding: 1.5rem 0.5rem 1rem;
  float: right;
  display: flex;
  background-color: #f7f9fc;
}
@media screen and (max-width: 767px) {
.vl-content-header__actions {
    display: none;
}
}
.vl-content-header__actions {
  position: absolute;
  top: 0;
  right: 3rem;
}
.vl-content-header .vl-content-header__action {
  padding: 0 0.5rem;
  font-size: 1.4rem;
  line-height: 1;
  color: #333332;
}
.vl-content-header .vl-content-header__action + .vl-content-header__action {
  border-left: 1px solid #333332;
}
.vl-content-header .vl-content-header__action a,
.vl-content-header .vl-content-header__action button {
  line-height: inherit;
  color: #333332;
  margin: 0;
}
.vl-content-header__title {
  display: block;
  color: #333332;
}
.vl-content-header__context--has-link + .vl-content-header__title .vl-content-header__title__content {
  padding: 0.5rem 2rem 1.1rem;
  font-family: "Flanders Art Serif", serif;
  font-weight: 400;
  font-size: 4.8rem;
  line-height: 1.1;
  margin-top: 1px;
  background: white;
}
.vl-content-header__title--has-link {
  display: inline-block;
}
@media screen and (max-width: 767px) {
.vl-content-header__title--has-link {
    display: none;
}
}
.vl-content-header__title__content, .vl-content-header__title__link {
  padding: 0.4rem 2rem 0.7rem;
  font-family: "Flanders Art Serif", serif;
  font-weight: 500;
  font-size: 3.4rem;
  line-height: 1.2;
}
@media screen and (max-width: 767px) {
.vl-content-header__title__content, .vl-content-header__title__link {
    font-size: 1.8rem;
    padding: 0.3rem 1rem 0.4rem;
    font-weight: 500;
}
}
.vl-content-header__title__content, .vl-content-header__title__link {
  display: inline-block;
  background-color: white;
  color: #333332;
  text-decoration: none;
}
.vl-content-header--has-context .vl-content-header__title__content, .vl-content-header--has-context .vl-content-header__title__link {
  font-family: "Flanders Art Serif", serif;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 300;
  padding: 0.9rem 2rem 0.9rem 3.5rem;
  font-size: 2.4rem;
  line-height: 1.1;
  background: linear-gradient(70deg, transparent 20px, white 21px);
}
.vl-content-header__subtitle {
  background-color: white;
  font-family: "Flanders Art Serif", serif;
}
.vl-content-header__context {
  font-family: "Flanders Art Serif", serif;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 500;
  background: linear-gradient(-110deg, transparent 20px, white 21px);
  display: inline-block;
}
.vl-content-header--alt .vl-content-header__context {
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color) 21px);
}
.vl-content-header__context__link {
  font-family: "Flanders Art Serif", serif;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 500;
  font-size: 2.4rem;
  line-height: 1.1;
  display: block;
  padding: 0.9rem 3.5rem 0.9rem 2rem;
  background: linear-gradient(-110deg, transparent 20px, white 21px);
  color: #333332;
  text-decoration: none;
}
@media screen and (max-width: 767px) {
.vl-content-header__context__link {
    background: white;
    font-size: 1.8rem;
    font-weight: 500;
    padding: 0.3rem 1rem 0.4rem;
}
}
.vl-content-header--alt .vl-content-header__context__link {
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color) 21px);
  color: #333332;
}
.vl-content-header__context--has-link {
  margin-right: -2.6rem;
}
@media screen and (max-width: 767px) {
.vl-content-header__context--has-link {
    margin-right: 0;
}
}
.vl-content-header__line {
  position: absolute;
  bottom: 0;
  transform-origin: 100%;
  transition: transform 0.1s;
}
.vl-content-header__line::before {
  display: block;
  content: "";
  height: 2px;
  background-color: var(--vl-theme-primary-color);
  width: 1000vw;
  transform-origin: 50%;
}
.vl-content-header__line-1 {
  left: 8rem;
}
@media screen and (max-width: 767px) {
.vl-content-header__line-1 {
    left: 1rem;
}
}
.vl-content-header__line-1::before {
  transform: translateX(-50%) rotate(71deg);
  background-color: #c6cdd3;
}
.vl-content-header__line-2 {
  left: -977vw;
  bottom: 3.5rem;
}
@media screen and (max-width: 767px) {
.vl-content-header__line-2 {
    bottom: 0;
}
}
.vl-content-header__line-2::before {
  transform: translateX(50%) rotate(-25deg);
}
.vl-content-header__line-3 {
  left: -970vw;
  bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-content-header__line-3 {
    right: 31rem;
}
}
.vl-content-header__line-3::before {
  transform: translateX(50%) rotate(-40deg);
  background-color: rgba(198, 205, 211, 0.6);
}
.vl-data-table {
  width: 100%;
  max-width: 100%;
}
.vl-data-table caption {
  text-align: left;
  margin: 15px 0 5px 0;
  font-size: 1.8rem;
  font-weight: 500;
}
.vl-data-table thead tr {
  border-bottom: 0.2rem #cbd2da solid;
}
.vl-data-table tfoot tr {
  border-top: 0.2rem #cbd2da solid;
}
.vl-data-table tfoot td {
  font-weight: 500;
  white-space: nowrap;
}
.vl-data-table tfoot td:first-child {
  padding-left: 0;
}
.vl-data-table tfoot td:last-child {
  padding-right: 0;
}
.vl-data-table tbody tr.vl-data-table__element--error,
.vl-data-table tbody td.vl-data-table__element--error {
  background: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-bottom: 1px solid #d2373c;
}
.vl-data-table tbody tr.vl-data-table__element--warning,
.vl-data-table tbody td.vl-data-table__element--warning {
  background: rgb(100%, 96.3137254902%, 90.3921568627%);
  border-bottom: 1px solid #ffA10a;
}
.vl-data-table tbody tr.vl-data-table__element--success,
.vl-data-table tbody td.vl-data-table__element--success {
  background: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-bottom: 1px solid #009e47;
}
.vl-data-table tbody tr {
  border-bottom: 0.1rem #cbd2da solid;
}
.vl-data-table tbody tr[data-vl-table-selectable] {
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.vl-data-table tbody tr[data-vl-table-selectable]:hover {
  background: #f3f5f6;
}
.vl-data-table tbody tr.vl-data-table__grouped-row:not(.vl-data-table__grouped-row--last) {
  border-bottom: 0;
}
.vl-data-table tbody tr th {
  border-left: 0.2rem #cbd2da solid;
  border-right: 0.2rem #cbd2da solid;
}
.vl-data-table tbody tr th:first-child {
  border-left: none;
}
.vl-data-table tbody tr th:last-child {
  border-right: none;
}
.vl-data-table td,
.vl-data-table th {
  font-size: 1.6rem;
  line-height: 1.3;
  text-align: left;
  vertical-align: top;
  padding: 1.2rem 1rem;
}
@media screen and (max-width: 767px) {
.vl-data-table td,
  .vl-data-table th {
    font-size: 1.4rem;
    padding: 1rem;
}
}
.vl-data-table td.vl-data-table__icon-container,
.vl-data-table th.vl-data-table__icon-container {
  background-color: #f3f5f6;
  color: #333332;
}
.vl-data-table td.vl-data-table__icon-container .vl-vi,
.vl-data-table th.vl-data-table__icon-container .vl-vi {
  color: #687483;
  font-size: 3rem;
}
.vl-vi .vl-data-table td.vl-data-table__icon-container,
.vl-vi .vl-data-table th.vl-data-table__icon-container {
  text-align: center;
}
.vl-data-table th {
  font-weight: 500;
  white-space: nowrap;
}
.vl-data-table th > * {
  white-space: normal;
}
.vl-data-table .vl-data-table__grouped-row td {
  padding: 0.3rem 1rem 0.3rem 0;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-data-table__grouped-row td {
    padding: 0.3rem 1rem 0.3rem 0;
}
}
.vl-data-table .vl-data-table__grouped-row--first td {
  padding-top: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-data-table__grouped-row--first td {
    padding-top: 1rem;
}
}
.vl-data-table .vl-data-table__grouped-row--last td {
  padding-bottom: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-data-table__grouped-row--last td {
    padding-bottom: 1rem;
}
}
.vl-data-table__header-title--sortable {
  text-decoration: none;
}
.vl-data-table__header-title--sortable .vl-data-table__header-title__sort-icon {
  opacity: 0;
}
.vl-data-table__header-title--sortable:hover, .vl-data-table__header-title--sortable:focus {
  text-decoration: underline;
}
.vl-data-table__header-title--sortable:hover .vl-data-table__header-title__sort-icon, .vl-data-table__header-title--sortable:focus .vl-data-table__header-title__sort-icon {
  opacity: 0.5;
}
.vl-data-table__header-title--sortable-active .vl-data-table__header-title__sort-icon {
  opacity: 1;
}
.vl-data-table__body-title {
  max-width: 30rem;
}
.vl-data-table--alt tr th,
.vl-data-table--alt tr td {
  border-left: 0.2rem #cbd2da solid;
  border-right: 0.2rem #cbd2da solid;
}
.vl-data-table--alt tr th:first-child,
.vl-data-table--alt tr td:first-child {
  border-left: none;
}
.vl-data-table--alt tr th:last-child,
.vl-data-table--alt tr td:last-child {
  border-right: none;
}
.vl-data-table--alt tr th:not(:first-child) {
  padding: 0 1.2rem 1.2rem;
}
.vl-data-table--alt tr td:not(:first-child) {
  padding: 1.2rem;
}
.vl-data-table--double-spacing tr td,
.vl-data-table--double-spacing tr th {
  padding: 1.2rem 3rem;
}
.vl-data-table--no-header tbody tr:first-child {
  border-top: 3px #cbd2da solid;
}
.vl-data-table .vl-pill {
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
.vl-data-table .vl-pill {
    font-size: 1.4rem;
    height: 2rem;
    line-height: 2rem;
    padding: 0 0.5rem;
}
}
.vl-u-table-overflow {
  width: 100%;
  overflow-x: auto;
}
.vl-u-table-overflow .vl-data-table {
  overflow: auto;
}
.no-js [data-vl-table-check-all] + span {
  display: none !important;
}
.vl-data-table--hover tbody tr {
  transition: background 0.2s ease-in-out;
}
.vl-data-table--hover tbody tr:hover {
  background: #f3f5f6;
}
.vl-data-table--matrix tr th {
  border-left: 0.2rem #cbd2da solid;
  border-right: 0.2rem #cbd2da solid;
}
.vl-data-table--matrix tr th:first-child {
  border-left: none;
}
.vl-data-table--matrix tr th:last-child {
  border-right: none;
}
.vl-data-table--grid td,
.vl-data-table--grid th {
  padding: 1.2rem;
  border-left: 0.1rem #cbd2da solid;
  border-right: 0.1rem #cbd2da solid;
}
.vl-data-table--grid td:first-child,
.vl-data-table--grid th:first-child {
  border-left: none;
}
.vl-data-table--grid td:last-child,
.vl-data-table--grid th:last-child {
  border-right: none;
}
.vl-data-table--grid th[scope=row] {
  border-width: 0.2rem;
}
.vl-data-table--zebra tbody tr:not(.vl-data-table__element--warning):not(.vl-data-table__element--error):not(.vl-data-table__element--success):nth-child(odd) {
  background-color: #f3f5f6;
}
.vl-data-table--zebra tbody tr:not(.vl-data-table__element--warning):not(.vl-data-table__element--error):not(.vl-data-table__element--success):nth-child(odd):hover {
  background-color: rgb(93.0084033613%, 94.1736694678%, 94.756302521%);
}
.vl-data-table__actions--top {
  margin: 0 0 2rem;
}
.vl-data-table__actions--bottom {
  margin: 2rem 0 0;
}
@media screen and (max-width: 500px) {
.vl-data-table__actions--bottom .vl-data-table__actions__list {
    margin: 0 0 1rem;
}
}
.vl-data-table__actions__list .vl-data-table__action:not(:last-child) {
  margin-right: 0.6rem;
}
.vl-data-table__action {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 0.6rem;
}
.vl-data-table__action__toggle {
  display: flex;
  align-items: center;
  background: none;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 1;
  color: #333332;
  border: 0.1rem #cbd2da solid;
  text-decoration: none;
  text-align: left;
  cursor: pointer;
  padding: 0.9rem 1.5rem 0.8rem;
}
@media screen and (max-width: 767px) {
.vl-data-table__action__toggle {
    font-size: 1.5rem;
}
}
[data-vl-disable=true] .vl-data-table__action__toggle {
  color: #687483;
  cursor: default;
}
.vl-data-table__action__toggle__icon {
  font-size: 1.2rem;
}
.vl-data-table__action__toggle__icon:first-child {
  margin-right: 0.5rem;
}
.vl-data-table__action__toggle__icon:last-child {
  margin-left: 0.5rem;
}
@media screen and (max-width: 500px) {
.vl-data-table__action__toggle--contract-xs span {
    display: none;
}
.vl-data-table__action__toggle--contract-xs .vl-vi::before {
    margin: 0;
}
}
@media screen and (max-width: 500px) {
.vl-data-table--collapsed-xs {
    position: relative;
}
.vl-data-table--collapsed-xs table,
  .vl-data-table--collapsed-xs thead,
  .vl-data-table--collapsed-xs tbody,
  .vl-data-table--collapsed-xs th,
  .vl-data-table--collapsed-xs td,
  .vl-data-table--collapsed-xs tr {
    display: block;
}
.vl-data-table--collapsed-xs thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.vl-data-table--collapsed-xs td {
    border-bottom: 1px solid #cbd2da;
    position: relative;
    padding-left: 40%;
    white-space: normal;
    text-align: left;
}
.vl-data-table--collapsed-xs td::before,
  .vl-data-table--collapsed-xs th::before {
    content: attr(data-title);
    position: absolute;
    top: 10px;
    left: 10px;
    width: 35%;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
}
}
@media screen and (max-width: 767px) {
.vl-data-table--collapsed-s {
    position: relative;
}
.vl-data-table--collapsed-s table,
  .vl-data-table--collapsed-s thead,
  .vl-data-table--collapsed-s tbody,
  .vl-data-table--collapsed-s th,
  .vl-data-table--collapsed-s td,
  .vl-data-table--collapsed-s tr {
    display: block;
}
.vl-data-table--collapsed-s thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.vl-data-table--collapsed-s td {
    border-bottom: 1px solid #cbd2da;
    position: relative;
    padding-left: 40%;
    white-space: normal;
    text-align: left;
}
.vl-data-table--collapsed-s td::before,
  .vl-data-table--collapsed-s th::before {
    content: attr(data-title);
    position: absolute;
    top: 10px;
    left: 10px;
    width: 35%;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
}
}
@media screen and (max-width: 1023px) {
.vl-data-table--collapsed-m {
    position: relative;
}
.vl-data-table--collapsed-m table,
  .vl-data-table--collapsed-m thead,
  .vl-data-table--collapsed-m tbody,
  .vl-data-table--collapsed-m th,
  .vl-data-table--collapsed-m td,
  .vl-data-table--collapsed-m tr {
    display: block;
}
.vl-data-table--collapsed-m thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
}
.vl-data-table--collapsed-m td {
    border-bottom: 1px solid #cbd2da;
    position: relative;
    padding-left: 40%;
    white-space: normal;
    text-align: left;
}
.vl-data-table--collapsed-m td::before,
  .vl-data-table--collapsed-m th::before {
    content: attr(data-title);
    position: absolute;
    top: 10px;
    left: 10px;
    width: 35%;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
    font-weight: 500;
}
}
.vl-data-table--sticky {
  table-layout: auto;
}
.vl-data-table--sticky .vl-data-table__cell--sticky {
  position: sticky;
  left: 0;
  background-color: inherit;
  border: 0;
  z-index: 1;
}
.vl-data-table--sticky thead .vl-data-table__cell--sticky {
  top: 0;
  z-index: 2;
}
.vl-data-table--sticky thead .vl-data-table__cell--sticky::before {
  display: block;
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #cbd2da;
  content: "";
}
.vl-data-table--sticky tbody .vl-data-table__cell--sticky::before {
  display: block;
  position: absolute;
  bottom: 0;
  top: 0;
  right: -1px;
  width: 1px;
  background-color: #cbd2da;
  content: "";
}
.vl-data-table--sticky th,
.vl-data-table--sticky td {
  min-width: 200px;
}
.vl-data-table--sticky tr {
  background-color: #fff;
}
.vl-data-table__sticky-wrapper {
  width: 100%;
  max-height: 75vh;
  overflow-x: auto;
  overflow-y: auto;
}
.vl-u-table-overflow {
  background: linear-gradient(to right, white, white, rgba(255, 255, 255, 0) 30px), radial-gradient(farthest-side at 0 50%, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0)), linear-gradient(to left, white, white, rgba(255, 255, 255, 0) 30px), radial-gradient(farthest-side at 100% 50%, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0)) 100%;
  background-color: white;
  background-repeat: no-repeat;
  background-attachment: local, scroll, local, scroll;
  background-size: 100% 100%, 15px 100%, 100% 100%, 15px 100%;
}
.vl-data-table__navigation {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
}
.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  box-shadow: 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar.open,
.flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}
.flatpickr-calendar.open {
  display: inline-block;
  z-index: 100021;
}
.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px;
}
.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid #eceef1;
}
.flatpickr-calendar.hasTime .flatpickr-innerContainer {
  border-bottom: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time {
  border: 1px solid #eceef1;
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}
.flatpickr-calendar:before,
.flatpickr-calendar:after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
}
.flatpickr-calendar.rightMost:before,
.flatpickr-calendar.arrowRight:before,
.flatpickr-calendar.rightMost:after,
.flatpickr-calendar.arrowRight:after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowCenter:before,
.flatpickr-calendar.arrowCenter:after {
  left: 50%;
  right: 50%;
}
.flatpickr-calendar:before {
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar:after {
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar.arrowTop:before,
.flatpickr-calendar.arrowTop:after {
  bottom: 100%;
}
.flatpickr-calendar.arrowTop:before {
  border-bottom-color: #eceef1;
}
.flatpickr-calendar.arrowTop:after {
  border-bottom-color: #eceef1;
}
.flatpickr-calendar.arrowBottom:before,
.flatpickr-calendar.arrowBottom:after {
  top: 100%;
}
.flatpickr-calendar.arrowBottom:before {
  border-top-color: #eceef1;
}
.flatpickr-calendar.arrowBottom:after {
  border-top-color: #eceef1;
}
.flatpickr-calendar:focus {
  outline: 0;
}
.flatpickr-wrapper {
  position: relative;
  display: inline-block;
}
.flatpickr-months {
  display: flex;
}
.flatpickr-months .flatpickr-month {
  border-radius: 5px 5px 0 0;
  background: #eceef1;
  color: #5a6171;
  fill: #5a6171;
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  overflow: hidden;
  flex: 1;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: #5a6171;
  fill: #5a6171;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
  display: none;
}
.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  left: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}

/*
      /*rtl:begin:ignore*/
/*
      /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  right: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}

/*
      /*rtl:begin:ignore*/
/*
      /*rtl:end:ignore*/
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #bbb;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #f64747;
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: inherit;
}
.numInputWrapper {
  position: relative;
  height: auto;
}
.numInputWrapper input,
.numInputWrapper span {
  display: inline-block;
}
.numInputWrapper input {
  width: 100%;
}
.numInputWrapper input::-ms-clear {
  display: none;
}
.numInputWrapper input::-webkit-outer-spin-button,
.numInputWrapper input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(72, 72, 72, 0.15);
  box-sizing: border-box;
}
.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute;
}
.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(72, 72, 72, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown {
  top: 50%;
}
.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(72, 72, 72, 0.6);
  top: 40%;
}
.numInputWrapper span svg {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path {
  fill: rgba(90, 97, 113, 0.5);
}
.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span {
  opacity: 1;
}
.flatpickr-current-month {
  font-size: 135%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px);
}
.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch�;
  display: inline-block;
}
.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: #5a6171;
}
.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: #5a6171;
}
.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled],
.flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(90, 97, 113, 0.5);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: #eceef1;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 300;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  -webkit-box-sizing: border-box;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  width: auto;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:focus,
.flatpickr-current-month .flatpickr-monthDropdown-months:active {
  outline: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: #eceef1;
  outline: none;
  padding: 0;
}
.flatpickr-weekdays {
  background: #eceef1;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 28px;
}
.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1;
}
span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #eceef1;
  color: #5a6171;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1;
  font-weight: bolder;
}
.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0;
}
.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
  border-left: 1px solid #eceef1;
  border-right: 1px solid #eceef1;
}
.flatpickr-days:focus {
  outline: 0;
}
.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}
.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 #eceef1;
}
.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: #484848;
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}
.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.today.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day:focus,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background: #e2e2e2;
  border-color: #e2e2e2;
}
.flatpickr-day.today {
  border-color: #bbb;
}
.flatpickr-day.today:hover,
.flatpickr-day.today:focus {
  border-color: #bbb;
  background: #bbb;
  color: #fff;
}
.flatpickr-day.selected,
.flatpickr-day.startRange,
.flatpickr-day.endRange,
.flatpickr-day.selected.inRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.selected:focus,
.flatpickr-day.startRange:focus,
.flatpickr-day.endRange:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange:hover,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.endRange.nextMonthDay {
  background: #ff5a5f;
  box-shadow: none;
  color: #fff;
  border-color: #ff5a5f;
}
.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange,
.flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange,
.flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #ff5a5f;
}
.flatpickr-day.selected.startRange.endRange,
.flatpickr-day.startRange.startRange.endRange,
.flatpickr-day.endRange.startRange.endRange {
  border-radius: 50px;
}
.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 #e2e2e2, 5px 0 0 #e2e2e2;
}
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(72, 72, 72, 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(72, 72, 72, 0.1);
}
.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #ff5a5f, 5px 0 0 #ff5a5f;
}
.flatpickr-day.hidden {
  visibility: hidden;
}
.rangeMode .flatpickr-day {
  margin-top: 1px;
}
.flatpickr-weekwrapper {
  float: left;
}
.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  border-left: 1px solid #eceef1;
}
.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 28px;
}
.flatpickr-weekwrapper span.flatpickr-day,
.flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(72, 72, 72, 0.3);
  background: transparent;
  cursor: default;
  border: none;
}
.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  border-bottom: 1px solid #eceef1;
}
.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}
.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  background: #fff;
  border-radius: 0 0 5px 5px;
}
.flatpickr-time:after {
  content: "";
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper {
  flex: 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: #484848;
}
.flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-color: #484848;
}
.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}
.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: #484848;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
}
.flatpickr-time input.flatpickr-hour {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute,
.flatpickr-time input.flatpickr-second {
  font-weight: 400;
}
.flatpickr-time input:focus {
  outline: 0;
  border: 0;
}
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  float: left;
  line-height: inherit;
  color: #484848;
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: #eaeaea;
}
.flatpickr-input[readonly] {
  cursor: pointer;
}
@keyframes fpFadeInDown {
from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
}
to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}
}
span.flatpickr-day.selected {
  font-weight: bold;
}
.flatpickr-calendar {
  background: #fff;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  box-shadow: none;
  margin-top: 0.5rem;
}
.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after, .flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
  display: none;
}
.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
  display: none;
}
.flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
  display: none;
}
.flatpickr-calendar .numInput[type=number],
.flatpickr-calendar input[type=number] {
  -moz-appearance: textfield;
}
.flatpickr-calendar .numInput[type=number]::-webkit-inner-spin-button, .flatpickr-calendar .numInput[type=number]::-webkit-outer-spin-button,
.flatpickr-calendar input[type=number]::-webkit-inner-spin-button,
.flatpickr-calendar input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.flatpickr-innerContainer {
  border-bottom: 0;
}
.flatpickr-days {
  border: 0;
  margin-bottom: 1.5rem;
}
.dayContainer {
  padding: 0 1.5rem;
}
.flatpickr-day {
  font-size: 1.6rem;
  line-height: 3rem;
  height: 3rem;
  max-width: 3rem;
  margin: 0.45rem;
}
.flatpickr-day.today {
  border: 0;
}
.flatpickr-calendar.mark-today .flatpickr-day.today:not(.selected) {
  background: #f4f4f4;
}
.flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay {
  color: #80807d;
}
.flatpickr-day.inRange.today {
  background-color: #05c;
  font-weight: 500;
}
.flatpickr-day.inRange.today::after {
  top: 0;
  right: 1.6rem;
}
.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange {
  background-color: #05c;
  border-color: #05c;
}
.flatpickr-day.selected.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background-color: #05c;
  border-color: #05c;
}
.flatpickr-day.selected.inRange, .flatpickr-day.selected.selected, .flatpickr-day.startRange.inRange, .flatpickr-day.startRange.selected, .flatpickr-day.endRange.inRange, .flatpickr-day.endRange.selected {
  background: #05c;
  border-color: #05c;
  border-radius: 50%;
  color: #fff;
  font-weight: 500;
}
.flatpickr-day.selected::after, .flatpickr-day.startRange::after, .flatpickr-day.endRange::after {
  content: "";
  display: block;
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: -0.1rem;
  background: rgb(50%, 66.6666666667%, 90%);
  z-index: -1;
}
.flatpickr-day.startRange::after {
  left: 1.5rem;
}
.flatpickr-day.endRange::after {
  right: 1.5rem;
}
.flatpickr-day:not(.inRange) + .flatpickr-day.selected:not(.startRange)::after {
  display: none;
}
.flatpickr-day.startRange.startRange + .endRange, .flatpickr-day.endRange.startRange + .endRange {
  box-shadow: none;
}
.flatpickr-day.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.prevMonthDay.inRange {
  background: rgb(50%, 66.6666666667%, 90%);
  box-shadow: -5px 0 0 rgb(50%, 66.6666666667%, 90%), 5px 0 0 rgb(50%, 66.6666666667%, 90%);
  border-color: rgb(50%, 66.6666666667%, 90%);
}
.flatpickr-day.inRange.startRange, .flatpickr-day.inRange.endRange, .flatpickr-day.nextMonthDay.inRange.startRange, .flatpickr-day.nextMonthDay.inRange.endRange, .flatpickr-day.prevMonthDay.inRange.startRange, .flatpickr-day.prevMonthDay.inRange.endRange {
  box-shadow: none;
}
.flatpickr-day:hover, .flatpickr-day:focus {
  color: #333332 !important;
  background: rgb(90%, 93.3333333333%, 98%) !important;
  border-color: transparent !important;
  font-weight: 400;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 rgb(50%, 66.6666666667%, 90%);
}
.flatpickr-day.flatpickr-disabled::before {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translate(0, -50%) rotate(-45deg);
  content: "";
  border-top: 1px solid #80807d;
}
.flatpickr-day.flatpickr-disabled:not(.nextMonthDay):not(.prevMonthDay) {
  color: #6a7686;
}
.flatpickr-day.flatpickr-disabled:not(.nextMonthDay):not(.prevMonthDay)::before {
  border-color: #6a7686;
}
.flatpickr-months {
  position: relative;
}
.flatpickr-months .flatpickr-month {
  border-radius: 0;
  background: 0;
  border-bottom: 1px solid #cbd2da;
  height: 5.5rem;
}
.flatpickr-weekdays {
  background: 0;
  padding: 2rem 1.5rem 2rem;
}
.flatpickr-weekdays span.flatpickr-weekday {
  background: 0;
  font-size: 100%;
  color: inherit;
}
.flatpickr-current-month {
  font-size: 125%;
  color: #333332;
  padding-top: 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  line-height: 3rem;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  border-radius: 0;
  font-size: 1.8rem;
  font-weight: 500;
  font-family: "Flanders Art Sans", sans-serif;
  color: #05c;
  background: transparent;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: none;
}
.flatpickr-current-month span.cur-year,
.flatpickr-current-month input.cur-year {
  font-weight: 500;
  color: #05c;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  border-radius: 50%;
  width: 3.5rem;
  height: 3.5rem;
  top: 50%;
  transform: translateY(-50%);
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  fill: #05c;
  stroke: #05c;
  stroke-width: 0.15rem;
  width: 1.2rem;
  height: 1.2rem;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {
  left: 10px;
}
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  right: 10px;
}
.numInputWrapper:hover {
  background-color: transparent;
}
.vl-datepicker .vl-datepicker__input-field {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.vl-datepicker.validated.invalid .vl-datepicker__input-field,
.vl-datepicker.validated.invalid .vl-datepicker__input-addon {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-datepicker.validated.valid .vl-datepicker__input-field,
.vl-datepicker.validated.valid .vl-datepicker__input-addon {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-document::before, .vl-document::after {
  content: "";
  display: table;
}
.vl-document::after {
  clear: both;
}
.vl-document {
  display: flex;
  align-items: center;
  text-decoration: none;
}
.vl-document__type {
  min-height: 7.5rem;
  margin-right: 3rem;
  position: relative;
  padding: 3rem 0 0 2rem;
}
.vl-document__type .vl-vi {
  font-size: 7.5rem;
  position: absolute;
  left: 0.5rem;
  transform: translateY(-50%);
  color: #b2b2b2;
  top: 50%;
}
.vl-document__type__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  position: relative;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  font-size: 1.5rem;
  line-height: 40px;
  font-weight: 500;
  color: #333332;
  background-color: var(--vl-theme-primary-color);
  text-align: center;
  top: 1rem;
  left: 2rem;
}
.vl-document__content {
  overflow: hidden;
}
.vl-document__title {
  font-weight: 500;
  line-height: 1.25;
}
.vl-document__metadata {
  display: block;
  color: #687483;
  font-size: 1.6rem;
  margin-top: 0.6rem;
}
@media screen and (max-width: 767px) {
.vl-document__metadata {
    font-size: 1.4rem;
}
}

/**
 * Webcomponents design refresh
 * This is still in alpha phase, don't touch & don't use!
*/
.vl-doormat {
  display: flex;
  position: relative;
  padding: 1.5rem 2rem;
  background-color: #fff;
  text-decoration: none;
  border: 1px #cbd2da solid;
}
.vl-doormat::before, .vl-doormat--graphic .vl-doormat__graphic-wrapper::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  background-color: var(--vl-theme-primary-color);
  width: 0.5rem;
  height: 100%;
  margin-left: 1px;
  margin-top: 1px;
}
.vl-doormat--alt {
  background-color: #f7f9fc;
}
.vl-doormat--graphic {
  flex-direction: column;
  border-top: none;
}
.vl-doormat--graphic .vl-doormat__graphic-wrapper {
  display: block;
  position: relative;
  margin-top: -1.5rem;
  margin-right: -2.1rem;
  margin-bottom: 1.6rem;
  margin-left: -2.1rem;
  overflow: hidden;
}
.vl-doormat--graphic .vl-doormat__graphic-wrapper::before {
  background-color: rgba(51, 51, 50, 0.2);
  width: 0.6rem;
  z-index: 2;
}
.vl-doormat--graphic .vl-doormat__graphic-wrapper .vl-doormat__graphic {
  width: 100%;
  display: block;
  transition: transform 0.2s;
}
.vl-doormat--graphic:hover .vl-doormat__graphic, .vl-doormat--graphic:focus .vl-doormat__graphic {
  transform: scale(1.05);
}
.vl-doormat[href]::before {
  background-color: var(--vl-theme-primary-color);
  transition: background-color 0.2s;
}
.vl-doormat[href]:hover .vl-doormat__title, .vl-doormat[href]:focus .vl-doormat__title {
  text-decoration: underline;
}
.vl-doormat[href]:hover::before {
  background-color: var(--vl-theme-primary-color);
}
.vl-doormat[href]:focus::before {
  background-color: var(--vl-theme-primary-color);
}
.vl-doormat[href]:visited::before {
  background: var(--vl-theme-primary-color);
}
.vl-doormat__title {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-doormat__title {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-doormat__title {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-doormat__title {
    margin-bottom: 0;
}
}
.vl-doormat__text, .vl-doormat__content {
  font-size: 1.8rem;
  line-height: 1.5;
}
@media screen and (max-width: 767px) {
.vl-doormat__text, .vl-doormat__content {
    font-size: 1.6rem;
    line-height: 1.33;
}
}
.vl-doormat__text {
  color: #333332;
  margin-top: 1rem;
}
.vl-doormat__image {
  max-width: 15rem;
  float: right;
  flex-shrink: 0;
  margin-left: 1.5rem;
}
.vl-form__label {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-form__label {
    font-size: 1.6rem;
}
}
.vl-form__label {
  display: inline-block;
  line-height: 1;
  font-weight: 500;
  margin-right: 0.5rem;
  margin-bottom: 0.7rem;
}
.vl-form__label--block {
  display: block;
  margin-right: 0;
  margin-bottom: 0.7rem;
}
.vl-form__label--offset {
  margin-top: 1rem;
}
.vl-form__label--light {
  color: #687483;
}
.vl-form__label__message {
  font-weight: normal;
  color: #687483;
  font-size: 1.4rem;
  line-height: 2rem;
}
.vl-form__label--standalone {
  margin-bottom: 0;
}
.vl-form__error,
.vl-form__success {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-form__error,
  .vl-form__success {
    font-size: 1.6rem;
}
}
.vl-form__error,
.vl-form__success {
  font-size: 1.4rem;
  color: #d2373c;
  margin-bottom: 0.5rem;
}
.vl-form__error--block,
.vl-form__success--block {
  display: block;
}
.vl-form__error .vl-vi,
.vl-form__success .vl-vi {
  margin-left: 0.5rem;
  font-size: 0.8rem;
}
.vl-form__error {
  color: #d2373c;
}
.vl-form__success {
  color: #007a37;
}
.vl-form__annotation {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-form__annotation {
    font-size: 1.6rem;
}
}
.vl-form__annotation {
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: normal;
}
@media screen and (max-width: 767px) {
.vl-form__annotation {
    font-size: 1.3rem;
}
}
.vl-form__annotation--block {
  display: block;
}
.vl-form {
  font-size: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-form {
    font-size: 1.6rem;
}
}
.vl-form__group {
  background-color: #f7f9fc;
  padding: 2rem 1.5rem;
  margin: 2rem 0 0;
}
@media screen and (max-width: 767px) {
.vl-form__group {
    padding: 1.5rem 1rem;
}
}
@media screen and (max-width: 767px) {
.vl-form__group--mobile-full-width {
    padding-left: 3%;
    padding-right: 3%;
    position: relative;
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
}
}
.vl-form__row + .vl-form__row {
  margin-top: 1.5rem;
}
@media screen and (max-width: 767px) {
.vl-form__row .vl-form__row__group + .vl-form__row__group {
    margin-top: 1.5rem;
}
}
.vl-form__row--addon {
  display: flex;
  flex-direction: row;
}
.vl-form__row--addon .vl-form__addon {
  flex-grow: 0;
}
.vl-form__row--inline::before, .vl-form__row--inline::after {
  content: "";
  display: table;
}
.vl-form__row--inline::after {
  clear: both;
}
.vl-form__row--inline {
  display: flex;
  margin-left: -3rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline {
    display: block;
    margin-left: -1.5rem;
}
}
.vl-form__row--inline .vl-form__label {
  float: left;
  width: 25%;
  min-width: 25%;
  max-width: 25%;
  flex-basis: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0.4rem;
  padding-left: 3rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline .vl-form__label {
    display: block;
    width: auto;
    max-width: none;
    padding-left: 1.5rem;
}
}
.vl-form__row--inline .vl-form__input {
  float: right;
  width: 75%;
  margin-left: 3rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline .vl-form__input {
    width: auto;
    margin-left: 1.5rem;
}
}
.vl-form__row--inline .vl-form__input .vl-radio,
.vl-form__row--inline .vl-form__input .vl-checkbox,
.vl-form__row--inline .vl-form__input input[type=file] {
  margin-top: 0.6rem;
}
@media screen and (max-width: 767px) {
.vl-form__row--inline .vl-form__input,
  .vl-form__row--inline .vl-form__label {
    float: none;
    width: auto;
}
}

/*@import "~@govflanders/vl-ui-form-validation/src/scss/form-validation"; */
.vl-functional-header {
  margin-bottom: 2rem;
  color: #333332;
  position: relative;
  min-width: 768px;
  background-color: #f7f9fc;
  padding: 1.5rem 0;
  min-height: 6.5rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header {
    min-width: 0;
    margin-bottom: 0;
    padding: 0.8rem 0;
    min-height: 0;
}
}
.vl-functional-header--has-actions::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 0.3rem;
  background-color: rgb(79.4081996435%, 84.5561497326%, 92.2780748663%);
  z-index: 2;
}
.vl-functional-header__row {
  display: flex;
  justify-content: space-between;
}
.vl-functional-header .vl-layout {
  position: static;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-layout {
    padding: 0;
}
}
.vl-functional-header .vl-title {
  margin-bottom: 0;
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 0.5rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-title {
    margin-bottom: 0;
}
}
.vl-functional-header__actions {
  margin-top: -1.2rem;
  padding: 1.5rem 0.5rem 1rem;
  background: rgb(79.4081996435%, 84.5561497326%, 92.2780748663%);
}
@media screen and (max-width: 767px) {
.vl-functional-header__actions {
    margin-top: -0.8rem;
}
}
.vl-functional-header__action {
  float: left;
  padding: 0 0.5rem;
  font-size: 1.4rem;
  line-height: 1;
  color: #333332;
}
.vl-functional-header__action + .vl-functional-header__action {
  border-left: 1px solid #333332;
}
.vl-functional-header__action > a,
.vl-functional-header__action > button {
  line-height: inherit;
  color: #333332;
  margin: 0;
}
.vl-functional-header__title {
  font-size: 2rem;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
}
.vl-functional-header__title[href] {
  color: inherit;
}
.vl-functional-header__title[href]:hover, .vl-functional-header__title[href]:focus {
  color: #05c;
}
@media screen and (max-width: 767px) {
.vl-functional-header__title {
    font-size: 1.8rem;
}
}
@media screen and (max-width: 767px) {
.vl-functional-header__content, .vl-functional-header__menu, .vl-functional-header__search, .vl-functional-header__sub__actions {
    padding: 0 1rem;
}
}
.vl-functional-header__content {
  display: flex;
  align-items: center;
}
.vl-functional-header__sub {
  margin-top: 0.5rem;
  clear: both;
  position: relative;
  border-top: 1px solid #cbd2da;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub {
    margin-top: 0.8rem;
}
}
.vl-functional-header__sub__actions {
  display: flex;
  align-items: flex-start;
  font-size: 0;
  padding-top: 1rem;
}
.vl-functional-header__sub__action {
  font-size: 1.6rem;
  display: inline-flex;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub__action {
    font-size: 1.6rem;
}
}
.vl-functional-header__sub__action + .vl-functional-header__sub__action::before {
  content: "";
  height: 2.4rem;
  width: 1px;
  margin: 0 1rem;
  background-color: #cbd2da;
  flex: 0 0 auto;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub__action + .vl-functional-header__sub__action::before {
    height: 2rem;
    margin: 0 0.6rem 0 0.8rem;
}
}
.vl-functional-header__sub__title {
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 700;
  font-size: 1.6rem;
  display: inline-block;
}
@media screen and (max-width: 767px) {
.vl-functional-header__sub__title {
    font-size: 1.5rem;
}
}
.vl-functional-header__search {
  margin: 0;
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search {
    margin: 1rem 0 0.5rem;
    text-align: left;
}
}
.vl-functional-header__search .vl-search {
  padding: 0;
  top: 0.7rem;
}
.vl-functional-header__search__input {
  display: inline-block;
  vertical-align: middle;
  font-size: 1.4rem;
  font-weight: 400;
  width: 100%;
  padding-right: 3.2rem;
  transition: max-width 0.3s ease-in-out;
}
.vl-functional-header__search__input.vl-input-field {
  max-width: 20rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__input.vl-input-field {
    max-width: 100%;
}
}
.vl-functional-header__search__input.vl-input-field:focus {
  max-width: 24rem;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__input.vl-input-field:focus {
    max-width: 100%;
}
}
.vl-functional-header__search__input.vl-input-field:focus + .vl-functional-header__search__submit {
  opacity: 1;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__input {
    transition: max-width 0s ease-in-out;
    max-width: 100%;
}
.vl-functional-header__search__input:focus {
    max-width: 100%;
}
}
.vl-functional-header__search__submit {
  position: absolute;
  top: 0;
  right: 0;
  color: #333332;
  border: 0;
  background: none;
  font-size: 1.6rem;
  outline: none;
  margin: 0.6rem 0 0;
  padding: 0.8rem 1.1rem;
  cursor: pointer;
  transition: opacity 0.1s, color 0.2s ease-in-out;
  opacity: 0.7;
}
.vl-functional-header__search__submit:hover, .vl-functional-header__search__submit:focus {
  color: #05c;
  opacity: 1;
}
@media screen and (max-width: 767px) {
.vl-functional-header__search__submit {
    margin: 0.1rem 0 0;
    right: 1rem;
    top: 1rem;
}
}
.vl-functional-header__menu {
  position: relative;
  border-bottom: 1px solid #cbd2da;
}
.vl-functional-header__menu--open .vl-functional-header__menu__list {
  max-height: 100%;
  height: auto;
}
.vl-functional-header__menu--open .vl-functional-header__menu__toggle::before {
  content: "\\f17f";
}
.vl-functional-header__menu--open .vl-functional-header__menu__toggle {
  font-size: 1.3rem;
  border: 0;
}
.vl-functional-header__menu__list {
  width: calc(100% - 5rem);
  max-height: 4.2rem;
  height: 4.2rem;
  overflow: hidden;
}
.vl-functional-header__menu__item:first-child {
  margin: 0.3rem 0 0;
}
.vl-functional-header__menu__item:last-child {
  margin: 0 0 0.3rem;
}
.vl-functional-header__menu__cta {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.8rem 0;
  text-decoration: none;
  font-size: 1.5rem;
}
.vl-functional-header__menu__cta:hover {
  text-decoration: underline;
}
.vl-functional-header__menu__toggle::before, .vl-functional-header__menu__toggle::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-functional-header__menu__toggle::before {
  content: "\\f125";
}
.vl-functional-header__menu__toggle {
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem 1.3rem;
  font-size: 1.5rem;
  border-left: 1px solid #cbd2da;
  color: #333332;
  cursor: pointer;
}
.vl-functional-header__menu__toggle::before {
  display: inline-block;
  transform: rotate(90deg);
  position: relative;
  top: 1px;
}
.vl-icon-wrapper {
  display: flex;
}
.vl-icon-wrapper .vl-icon {
  display: inline-block;
}
.vl-icon {
  font-size: 1em;
  display: inline;
  color: inherit;
}
.vl-icon svg {
  height: 1em;
  width: auto;
  fill: currentColor;
  display: inline-block;
  font-size: inherit;
  overflow: visible;
  vertical-align: middle;
}
.vl-icon--small {
  font-size: 0.8em;
}
.vl-icon--small svg {
  height: 0.8em;
  width: auto;
}
.vl-icon--large {
  font-size: 1.2em;
}
.vl-icon--large svg {
  height: 1.2em;
  width: auto;
}
.vl-icon--light {
  color: #8695a8;
}
.vl-icon--before {
  margin-right: 0.5em;
}
.vl-icon--after {
  margin-left: 0.5em;
}
.vl-icon--inline-svg:before {
  display: none;
}
.vl-icon-list__item {
  padding-left: 3rem;
  margin-bottom: 1rem;
  position: relative;
  line-height: 1.3;
}
.vl-icon-list__item .vl-vi {
  font-size: 2rem;
  position: absolute;
  left: 0;
  top: -0.3rem;
}
.vl-icon-list__item .vl-vi::before, .vl-icon-list__item .vl-vi::after {
  color: #b2b2b2;
}
.vl-icon-list__item .vl-vi svg {
  fill: #b2b2b2;
}
.vl-icon-list--small .vl-icon-list__item {
  font-size: 1.6rem;
}
.vl-icon-list--small .vl-icon-list__item .vl-vi {
  font-size: 1.8rem;
  top: -0.2rem;
}
.vl-icon-list--xsmall .vl-icon-list__item {
  padding-left: 2.5rem;
  font-size: 1.4rem;
}
.vl-icon-list--xsmall .vl-icon-list__item .vl-vi {
  font-size: 1.6rem;
  top: -0.1rem;
}
.vl-infoblock--border {
  border: 1px solid #cbd2da;
  padding: 5rem;
}
@media screen and (max-width: 1023px) {
.vl-infoblock--border {
    padding: 3rem;
}
}
@media screen and (max-width: 767px) {
.vl-infoblock--border {
    padding: 2rem;
}
}
.vl-infoblock__header::before, .vl-infoblock__header::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock__header {
  position: relative;
  display: flex;
  align-items: center;
  line-height: 4.2rem;
  overflow-wrap: break-word;
}
@media screen and (max-width: 767px) {
.vl-infoblock__header {
    line-height: 3.6rem;
}
}
.vl-infoblock__header__icon-wrapper {
  position: relative;
}
.vl-infoblock__header__icon.vl-icon, .vl-infoblock__header__icon {
  display: block;
  flex: 0 0 auto;
  background-color: transparent;
  background: var(--vl-theme-primary-color);
  font-size: 2rem;
  border-radius: 50%;
  color: var(--vlw-theme-primary-fg-color, #333332);
  width: 4.2rem;
  height: 4.2rem;
  text-align: center;
  margin-right: 2.7rem;
  align-self: start;
}
@media screen and (max-width: 767px) {
.vl-infoblock__header__icon.vl-icon, .vl-infoblock__header__icon {
    font-size: 1.5rem;
    width: 3.6rem;
    height: 3.6rem;
    margin-right: 1.5rem;
}
}
.vl-infoblock__header__icon.vl-icon::before, .vl-infoblock__header__icon::before {
  display: block;
}
.vl-infoblock--alt .vl-infoblock__header__icon {
  background-color: #f7f9fc;
  border: 1px solid #cbd2da;
}
.vl-infoblock--contact .vl-infoblock__header__icon::before, .vl-infoblock--contact .vl-infoblock__header__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--contact .vl-infoblock__header__icon::before {
  content: "\\f102";
}
.vl-infoblock--publications .vl-infoblock__header__icon::before, .vl-infoblock--publications .vl-infoblock__header__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--publications .vl-infoblock__header__icon::before {
  content: "\\f134";
}
.vl-infoblock--faq .vl-infoblock__header__icon::before, .vl-infoblock--faq .vl-infoblock__header__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--faq .vl-infoblock__header__icon::before {
  content: "\\f1a4";
}
.vl-infoblock--news .vl-infoblock__header__icon::before, .vl-infoblock--news .vl-infoblock__header__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--news .vl-infoblock__header__icon::before {
  content: "\\f223";
}
.vl-infoblock--timeline .vl-infoblock__header__icon::before, .vl-infoblock--timeline .vl-infoblock__header__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--timeline .vl-infoblock__header__icon::before {
  content: "\\f29c";
}
.vl-infoblock--question .vl-infoblock__header__icon::before, .vl-infoblock--question .vl-infoblock__header__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-infoblock--question .vl-infoblock__header__icon::before {
  content: "\\f252";
}
@media screen and (max-width: 767px) {
.vl-infoblock__header__icon {
    font-size: 1.5rem;
    width: 3.6rem;
    height: 3.6rem;
    margin-right: 1.5rem;
}
}
.vl-infoblock__header__badge {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-infoblock__header__badge {
    margin-right: 0.9rem;
}
}
.vl-infoblock__title {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-infoblock__title {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-infoblock__title {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-infoblock__title {
    font-size: 1.8rem;
    font-family: "Flanders Art Sans", sans-serif;
    font-weight: 500;
    margin-bottom: 1.4rem;
    line-height: 1.44;
    margin-bottom: 0;
}
}
@media screen and (max-width: 767px) and (max-width: 767px) {
.vl-infoblock__title {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
@media screen and (max-width: 500px) {
.vl-infoblock__title {
    margin-bottom: 0;
}
}
.vl-infoblock__content {
  padding-top: 1.5rem;
  margin-left: 7rem;
}
@media screen and (max-width: 767px) {
.vl-infoblock__content {
    padding-top: 0.75rem;
    margin-left: 5.2rem;
}
}
.vl-info-tile {
  display: block;
  position: relative;
  border: 1px solid #cbd2da;
  padding: 1.7rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile {
    padding: 1rem;
}
}
.vl-info-tile--alt {
  background-color: #f7f9fc;
}
.vl-info-tile--clickable {
  text-decoration: none;
  cursor: pointer;
  text-align: left;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0;
  color: var(--vl-theme-action-color, #05c);
}
.vl-info-tile--clickable:hover, .vl-info-tile--clickable:focus {
  background-color: #f7f9fc;
  color: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-info-tile--clickable:hover .vl-info-tile__header__title, .vl-info-tile--clickable:focus .vl-info-tile__header__title {
  text-decoration: underline;
}
.vl-info-tile--clickable:hover.vl-info-tile--date .vl-info-tile__date, .vl-info-tile--clickable:focus.vl-info-tile--date .vl-info-tile__date {
  background: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-info-tile--clickable.vl-info-tile--date .vl-info-tile__date {
  background: var(--vl-theme-action-hover-color, #003bb0);
}
.vl-info-tile--clickable:visited.vl-info-tile--date .vl-info-tile__date {
  background: #660599;
}
.vl-info-tile--m {
  padding: 2.5rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile--m {
    padding: 2rem;
}
}
.vl-info-tile--l {
  padding: 4.5rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile--l {
    padding: 2rem;
}
}
.vl-info-tile--center {
  text-align: center;
}
.vl-info-tile--center .vl-info-tile__header {
  display: block;
  margin-bottom: 1.6rem;
}
.vl-info-tile--center .vl-info-tile__header__wrapper {
  width: 100%;
}
.vl-info-tile--center .vl-info-tile__header__icon:not(.vl-badge) {
  color: #cbd2da;
  font-size: 3rem;
  line-height: 1;
  display: inline-block;
}
.vl-info-tile--center .vl-info-tile__footer {
  margin-top: 2rem;
}
.vl-info-tile--v-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.vl-info-tile.vl-js-equal-height {
  height: 100%;
}
.vl-info-tile--date {
  padding: 0;
  display: flex;
  align-items: stretch;
}
.vl-info-tile--date[href] .vl-info-tile__date {
  color: #fff;
}
.vl-info-tile--date .vl-info-tile__date {
  background-color: #f7f9fc;
  padding: 1.7rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile--date .vl-info-tile__date {
    padding: 1rem;
}
}
.vl-info-tile--date .vl-info-tile__date__main {
  text-align: center;
  font-weight: bold;
}
.vl-info-tile--date .vl-info-tile__date__sub {
  text-align: center;
  font-size: 1.4rem;
}
.vl-info-tile--date .vl-info-tile__date__wrapper {
  padding: 1.7rem;
  flex: 1;
}
@media screen and (max-width: 767px) {
.vl-info-tile--date .vl-info-tile__date__wrapper {
    padding: 1rem;
}
}
.vl-info-tile--badge-bottom .vl-info-tile__content {
  display: flex;
}
.vl-info-tile__badges {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-left: 1.7rem;
}
.vl-info-tile__badges__badge:not(:first-of-type) {
  margin-top: 0.5rem;
}
.vl-info-tile--highlight {
  box-shadow: inset 0 0.5rem 0 0 var(--vl-theme-accent-color, var(--vl-theme-primary-color));
}
.vl-info-tile__header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1;
}
.vl-info-tile__header .vl-info-tile__badge__wrapper {
  margin-right: 1.4rem;
  flex-shrink: 0;
}
.vl-info-tile__header__title {
  font-weight: 500;
  line-height: 1.25;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.8rem;
}
@media screen and (max-width: 767px) {
.vl-info-tile__header__title {
    font-size: 1.5rem;
}
}
.vl-info-tile__header__subtitle {
  color: #687483;
  line-height: 1.3;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.4rem;
  margin-top: 0.3rem;
}
.vl-info-tile__content {
  font-size: 1.6rem;
  margin-top: 1rem;
  flex: 1;
  color: #333332;
}
@media screen and (max-width: 767px) {
.vl-info-tile__content {
    font-size: 1.5rem;
}
}
.vl-info-tile__content__wrapper {
  flex: 1;
}
.vl-input-addon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 3.5rem;
  line-height: 3.5rem;
  min-width: 3.5rem;
  border: 0.1rem solid #8695a8;
  text-decoration: none;
  padding: 0 1rem;
  font-weight: 500;
  font-size: 1.6rem;
  color: #333332;
  background: #fff;
  margin: 0;
}
.vl-input-addon[type=button] .vl-vi, .vl-input-addon[href] .vl-vi {
  color: #05c;
}
.vl-input-addon[type=button]:hover, .vl-input-addon[href]:hover {
  box-shadow: inset 0 0 0 0.1rem rgba(0, 85, 204, 0.65);
  border-color: rgba(0, 85, 204, 0.65);
  background: rgba(179, 207, 245, 0.3);
}
.vl-input-addon[type=button]:hover .vl-vi, .vl-input-addon[type=button]:focus .vl-vi, .vl-input-addon[href]:hover .vl-vi, .vl-input-addon[href]:focus .vl-vi {
  color: #003bb0;
}
.vl-input-addon[type=button]:focus, .vl-input-addon[href]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-input-addon[type=button]:focus, .vl-input-addon[href]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-input-addon[type=button]:focus, .vl-input-addon[href]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-input-addon[type=button]:hover:focus, .vl-input-addon[href]:hover:focus {
  box-shadow: inset 0 0 0 0.1rem rgba(0, 85, 204, 0.65), 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-input-addon--disabled[type=button], .vl-input-addon--disabled[href] {
  background-color: #cbd2d9;
  cursor: not-allowed;
}
.vl-input-addon--disabled[type=button] .vl-vi, .vl-input-addon--disabled[href] .vl-vi {
  color: #687483;
}
.vl-input-addon--disabled[type=button]:hover, .vl-input-addon--disabled[type=button]:active, .vl-input-addon--disabled[href]:hover, .vl-input-addon--disabled[href]:active {
  background-color: #cbd2d9;
  border-color: #cbd2d9;
}
.vl-input-addon--disabled[type=button]:hover .vl-vi, .vl-input-addon--disabled[type=button]:active .vl-vi, .vl-input-addon--disabled[href]:hover .vl-vi, .vl-input-addon--disabled[href]:active .vl-vi {
  color: #687483;
}
.vl-input-addon--disabled[type=button]:focus .vl-vi, .vl-input-addon--disabled[href]:focus .vl-vi {
  color: #687483;
}
.vl-input-addon .vl-vi {
  display: inline-flex;
  color: inherit;
}
.vl-input-addon .vl-vi::before, .vl-input-addon .vl-vi::after {
  font-size: 1.8rem;
}
.vl-input-field {
  display: inline-block;
  background: #fff;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  color: #333332;
  max-width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  padding: 0 1rem;
  transition: background-color 0.2s;
}
@media screen and (max-width: 767px) {
.vl-input-field {
    font-size: 1.6rem;
}
}
.vl-input-field:hover {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0 0.9rem;
}
.vl-input-field:hover.vl-input-field--error, .vl-input-field:hover.invalid.validated {
  border-color: #d2373c;
}
.vl-input-field:hover.vl-input-field--success {
  border-color: #009e47;
}
.vl-input-field:hover.vl-input-field--small {
  padding: 0 0.7rem;
}
.vl-input-field:focus, .vl-input-field--focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-input-field:focus, .vl-input-field--focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-input-field:focus, .vl-input-field--focus {
  border: 0.1rem solid #8695a8;
  padding: 0 1rem;
}
.vl-input-field:focus.vl-input-field--error, .vl-input-field:focus.invalid.validated, .vl-input-field--focus.vl-input-field--error, .vl-input-field--focus.invalid.validated {
  border-color: #d2373c;
}
.vl-input-field:focus.vl-input-field--success, .vl-input-field--focus.vl-input-field--success {
  border-color: #009e47;
}
.vl-input-field:focus:hover, .vl-input-field--focus:hover {
  padding: 0 1rem;
}
.vl-input-field:focus.vl-input-field--small, .vl-input-field--focus.vl-input-field--small {
  padding: 0 0.8rem;
}
.vl-input-field::-moz-placeholder {
  color: #687483;
}
.vl-input-field::placeholder {
  color: #687483;
}
.vl-input-field::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.vl-input-field--block {
  display: block;
  width: 100%;
}
.vl-input-field--small {
  max-width: 6rem;
  padding: 0 0.8rem;
}
.vl-input-field--error, .vl-input-field.invalid.validated {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  display: inline;
}
.vl-input-field--error .vl-select, .vl-input-field.invalid.validated .vl-select {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-input-field--error .js-vl-select[data-type*=select-one], .vl-input-field--error .js-vl-select[data-type*=select-multiple], .vl-input-field.invalid.validated .js-vl-select[data-type*=select-one], .vl-input-field.invalid.validated .js-vl-select[data-type*=select-multiple] {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-input-field--error .js-vl-select[data-type*=select-one] .vl-select__inner, .vl-input-field--error .js-vl-select[data-type*=select-multiple] .vl-select__inner, .vl-input-field.invalid.validated .js-vl-select[data-type*=select-one] .vl-select__inner, .vl-input-field.invalid.validated .js-vl-select[data-type*=select-multiple] .vl-select__inner {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  background-color: transparent;
}
.vl-input-field--success {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  display: inline;
}
.vl-input-field--success .vl-select {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-input-field--success .js-vl-select[data-type*=select-one], .vl-input-field--success .js-vl-select[data-type*=select-multiple] {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-input-field--success .js-vl-select[data-type*=select-one] .vl-select__inner, .vl-input-field--success .js-vl-select[data-type*=select-multiple] .vl-select__inner {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  background-color: transparent;
}
.vl-input-field--disabled, .vl-input-field[disabled] {
  background-color: #f3f5f6;
  border-color: #8695a8;
}
.vl-input-field--disabled:hover, .vl-input-field[disabled]:hover {
  border-width: 0.1rem;
  padding: 0 1rem;
}
.vl-input-field--inline {
  position: relative;
  display: block;
  max-width: 100%;
}
@media screen and (max-width: 767px) {
.vl-input-field--inline {
    display: block;
    width: auto;
}
}
.vl-input-field--inline .vl-input-field__submit {
  position: absolute;
  display: block;
  color: #fff;
  width: 4.3rem;
  height: 3.5rem;
  opacity: 0;
  padding: 0;
  margin-bottom: -2rem;
  transform: translateX(100%);
  top: 0;
  right: 0;
  z-index: -1;
}
.vl-input-field--inline .vl-input-field__submit:focus {
  transform: translateX(0%);
  transition: opacity 0.2s, transform 0.2s;
  opacity: 1;
  z-index: 1;
}
.vl-input-field--inline .vl-input-field__submit::before {
  position: absolute;
  font-size: 1.7rem;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.vl-input-field--inline .vl-input-field__input {
  display: block;
  width: 100%;
  text-align: left;
  padding-right: 5rem;
}
.vl-input-field--inline .vl-input-field__input:focus, .vl-input-field--inline .vl-input-field__input--focus {
  width: calc(100% - 5.2rem);
  padding-right: 0;
  transition: width 0.2s;
}
.vl-input-field--inline .vl-input-field__input:focus + .vl-input-field__submit, .vl-input-field--inline .vl-input-field__input--focus + .vl-input-field__submit {
  transform: translateX(0%);
  transition: opacity 0.2s, transform 0.2s;
  opacity: 1;
  z-index: 1;
}
.vl-input-group {
  display: flex;
  align-items: stretch;
}
.vl-input-group .vl-button,
.vl-input-group .vl-input-addon {
  flex-shrink: 0;
}
.vl-input-group .vl-button:focus,
.vl-input-group .vl-input-addon:focus {
  z-index: 1;
}
.vl-input-group :first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  border-right-width: 0;
}
.vl-input-group :first-child:focus {
  z-index: 1;
  border-right-width: 1px;
}
.vl-input-group .vl-input-field + .vl-input-addon,
.vl-input-group .vl-input-field + .vl-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  margin-left: -0.1rem;
}
.vl-input-group .vl-input-addon + .vl-input-field,
.vl-input-group .vl-button + .vl-input-field {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.vl-input-group .vl-button + .vl-input-field {
  border-left-width: 0;
  padding-left: 1.1rem;
}
.vl-input-group .vl-button + .vl-input-field:focus {
  padding-left: 1rem;
}
.vl-input-group .vl-input-field,
.vl-input-group .vl-input-addon {
  position: relative;
}
.vl-input-group .vl-input-field:focus,
.vl-input-group .vl-input-addon:focus {
  z-index: 1;
  border-left-width: 1px;
}
.vl-input-group--inline {
  display: inline-flex;
}
[type=submit].vl-link.vl-link--icon, .vl-sidebar-panel-list-item__button [type=submit].vl-link--icon.vl-icon, [type=submit].vl-link--icon.vl-sidebar-header__toggle {
  padding-left: 1.8rem;
}
button.vl-link, .vl-sidebar-panel-list-item__button button.vl-icon, button.vl-sidebar-header__toggle {
  cursor: default;
}
.vl-link, .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-header__toggle {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  text-decoration: underline;
}
.vl-link:hover, .vl-sidebar-panel-list-item__button .vl-icon:hover, .vl-sidebar-header__toggle:hover {
  text-decoration: none;
}
.vl-link:focus, .vl-sidebar-panel-list-item__button .vl-icon:focus, .vl-sidebar-header__toggle:focus, .vl-link:active, .vl-sidebar-panel-list-item__button .vl-icon:active, .vl-sidebar-header__toggle:active {
  text-decoration: none;
}
.vl-link, .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-header__toggle {
  display: inline-block;
  cursor: pointer;
  font-weight: inherit;
  text-align: left;
  font-family: inherit;
  font-size: inherit;
  color: var(--vl-theme-action-color, #05c);
  position: relative;
  word-break: break-word;
  line-height: inherit;
}
.vl-link:hover, .vl-sidebar-panel-list-item__button .vl-icon:hover, .vl-sidebar-header__toggle:hover, .vl-link:focus, .vl-sidebar-panel-list-item__button .vl-icon:focus, .vl-sidebar-header__toggle:focus, .vl-link:active, .vl-sidebar-panel-list-item__button .vl-icon:active, .vl-sidebar-header__toggle:active {
  color: var(--vl-theme-action-hover-color, #003bb0);
  text-decoration: none;
}
.vl-link:focus, .vl-sidebar-panel-list-item__button .vl-icon:focus, .vl-sidebar-header__toggle:focus, .vl-link:active, .vl-sidebar-panel-list-item__button .vl-icon:active, .vl-sidebar-header__toggle:active {
  color: var(--vl-theme-action-active-color, rgb(0%, 25%, 60%));
}
.vl-link:visited, .vl-sidebar-panel-list-item__button .vl-icon:visited, .vl-sidebar-header__toggle:visited {
  color: #660599;
}
.vl-link:visited .vl-link__icon, .vl-sidebar-panel-list-item__button .vl-icon:visited .vl-link__icon, .vl-sidebar-header__toggle:visited .vl-link__icon {
  color: #660599;
}
.vl-link--bold {
  font-weight: 500;
  text-decoration: none;
}
.vl-link--bold:hover, .vl-link--bold:focus, .vl-link--bold:active {
  text-decoration: underline;
}
.vl-link--small {
  font-size: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-link--small {
    font-size: 1.5rem;
}
}
.vl-link--large {
  font-size: 2rem;
}
@media screen and (max-width: 767px) {
.vl-link--large {
    font-size: 1.8rem;
}
}
.vl-link--block {
  display: block;
}
.vl-link--inline {
  display: inline;
}
.vl-link--flex {
  display: flex;
  align-items: center;
}
.vl-link--error {
  color: #d2373c;
}
.vl-link--error:hover, .vl-link--error:focus, .vl-link--error:active, .vl-link--error:visited {
  color: #aa2729;
}
.vl-link__icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  line-height: 1;
  margin-top: -0.1em;
  flex-shrink: 0;
}
.vl-link__icon::before, .vl-link__icon::after {
  display: inline-block;
}
.vl-link__icon--before {
  padding-right: 0.4rem;
}
.vl-link__icon--after {
  padding-left: 0.4rem;
}
.vl-link__icon--standalone {
  padding: 0;
  float: none;
  position: relative;
}
.vl-link__icon--light {
  color: #687483;
}
.vl-link__icon--borderless {
  overflow: visible;
}
.vl-link__icon--borderless::after {
  position: absolute;
  display: block;
  height: 0.1rem;
  left: 0;
  width: 100%;
  bottom: 0;
  margin-bottom: -0.3rem;
  background-color: #fff;
  content: "";
}
.vl-link__icon.vl-vi-external {
  font-size: 1em;
}
.vl-loader {
  display: inline-block;
  position: relative;
  width: 3rem;
  height: 1.8rem;
}
.vl-loader::before {
  animation: loader-wave infinite 1s linear;
}
@keyframes loader-wave {
0% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px 0px #687483;
}
10% {
    box-shadow: 10px -3px #687483, 20px -0px #687483, 30px -0px #687483;
}
20% {
    box-shadow: 10px -6px #687483, 20px -3px #687483, 30px -0px #687483;
}
30% {
    box-shadow: 10px -3px #687483, 20px -6px #687483, 30px -3px #687483;
}
40% {
    box-shadow: 10px -0px #687483, 20px -3px #687483, 30px -6px #687483;
}
50% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -3px #687483;
}
60% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
100% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
}
.vl-loader::before {
  position: absolute;
  display: block;
  content: "";
  width: 0.4rem;
  height: 0.4rem;
  box-shadow: 1rem 0 #687483, 2rem 0 #687483, 3rem 0 #687483;
  border-radius: 50%;
  margin-top: -0.2rem;
  margin-left: -2.2rem;
  top: 50%;
  left: 50%;
}
.vl-loader--light::before {
  animation: loader-light-wave infinite 1s linear;
}
@keyframes loader-light-wave {
0% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px 0px #fff;
}
10% {
    box-shadow: 10px -3px #fff, 20px -0px #fff, 30px -0px #fff;
}
20% {
    box-shadow: 10px -6px #fff, 20px -3px #fff, 30px -0px #fff;
}
30% {
    box-shadow: 10px -3px #fff, 20px -6px #fff, 30px -3px #fff;
}
40% {
    box-shadow: 10px -0px #fff, 20px -3px #fff, 30px -6px #fff;
}
50% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px -3px #fff;
}
60% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px -0px #fff;
}
100% {
    box-shadow: 10px -0px #fff, 20px -0px #fff, 30px -0px #fff;
}
}
.vl-loader--small::before {
  width: 0.3rem;
  height: 0.3rem;
}
.vl-loader + p {
  font-style: 1.6rem;
}
.vl-loader-alert--inline {
  display: inline-flex;
  vertical-align: middle;
}
.vl-loader-alert .vl-loader::before {
  margin-top: 0;
}
.vl-modal .backdrop,
.vl-modal .vl-modal__backdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
}
.vl-modal .vl-modal-dialog__title {
  font-size: 2.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.3;
}
@media screen and (max-width: 767px) {
.vl-modal .vl-modal-dialog__title {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
}
}
.vl-modal .vl-modal-dialog__title {
  font-family: "Flanders Art Serif", serif;
  margin-bottom: 1.5rem;
}
.vl-modal-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
}
.vl-modal-backdrop--hidden {
  display: none;
}
.vl-modal-dialog {
  display: none;
  position: fixed;
  width: 60rem;
  max-width: 95vw;
  max-height: 85vh;
  top: 50%;
  left: 50%;
  margin: 0;
  padding: 0;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border: 0;
  box-shadow: 0 0 2.1rem 0 rgba(0, 0, 0, 0.3);
  z-index: 10010;
}
.vl-modal-dialog::backdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
}
.vl-modal-dialog[open], .vl-modal-dialog.vl-modal-dialog--opened {
  display: flex;
  flex-direction: column;
}
.vl-modal-dialog[open]:focus, .vl-modal-dialog.vl-modal-dialog--opened:focus {
  outline: auto #ffc515 3px;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog {
    left: 0;
    right: 0;
    top: initial;
    transform: initial;
    max-width: initial;
    width: 100vw;
    bottom: 0;
}
}
.vl-modal-dialog--static {
  position: static;
  transform: none;
}
.vl-modal-dialog--medium {
  width: 80rem;
}
.vl-modal-dialog--large {
  width: 100rem;
}
.vl-modal-dialog--right, .vl-modal-dialog--left {
  left: initial;
  right: initial;
  top: 0;
  transform: initial;
  max-height: initial;
  height: 100vh;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--right, .vl-modal-dialog--left {
    left: 0;
    right: 0;
    top: initial;
    transform: initial;
    max-width: initial;
    width: 100vw;
    height: auto;
    bottom: 0;
}
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--right.vl-modal-dialog--mobile-left, .vl-modal-dialog--right.vl-modal-dialog--mobile-right, .vl-modal-dialog--left.vl-modal-dialog--mobile-left, .vl-modal-dialog--left.vl-modal-dialog--mobile-right {
    height: 100vh;
}
}
.vl-modal-dialog--bottom, .vl-modal-dialog--top {
  left: 0;
  right: 0;
  top: initial;
  transform: initial;
  max-width: initial;
  width: 100vw;
}
.vl-modal-dialog--right {
  right: 0;
}
.vl-modal-dialog--left {
  left: 0;
}
.vl-modal-dialog--bottom {
  bottom: 0;
}
.vl-modal-dialog--top {
  top: 0;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--top:not(.vl-modal-dialog--mobile-top) {
    top: initial;
}
}
.vl-modal-dialog__header {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__header {
    margin-bottom: 1.5rem;
}
}
.vl-modal-dialog__footer {
  margin-top: 3rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__footer {
    margin-top: 1.5rem;
}
}
.modal-fade-leave-active,
.modal-fade-enter-active {
  transition: opacity 0.3s ease-in-out;
}
@media screen and (max-width: 767px) {
.modal-fade-leave-active,
  .modal-fade-enter-active {
    transition: transform 0.3s ease-in-out;
}
}
.modal-fade-enter {
  opacity: 0;
}
@media screen and (max-width: 767px) {
.modal-fade-enter {
    opacity: 1;
    transform: translate(0, 100%);
}
}
.modal-fade-leave-to {
  opacity: 0;
}
@media screen and (max-width: 767px) {
.modal-fade-leave-to {
    opacity: 1;
    transform: translate(0, 100%);
}
}
.modal-slide-from-right-leave-active,
.modal-slide-from-right-enter-active,
.modal-slide-from-left-leave-active,
.modal-slide-from-left-enter-active,
.modal-slide-from-top-leave-active,
.modal-slide-from-top-enter-active,
.modal-slide-from-bottom-leave-active,
.modal-slide-from-bottom-enter-active {
  transition: transform 0.3s ease-in-out;
}
.modal-slide-from-right-enter,
.modal-slide-from-right-leave-to {
  transform: translate(100%, 0);
}
@media screen and (max-width: 767px) {
.modal-slide-from-right-enter:not(.vl-modal-dialog--mobile-right),
  .modal-slide-from-right-leave-to:not(.vl-modal-dialog--mobile-right) {
    transform: translate(0, 100%);
}
}
.modal-slide-from-left-enter,
.modal-slide-from-left-leave-to {
  transform: translate(-100%, 0);
}
@media screen and (max-width: 767px) {
.modal-slide-from-left-enter:not(.vl-modal-dialog--mobile-left),
  .modal-slide-from-left-leave-to:not(.vl-modal-dialog--mobile-left) {
    transform: translate(0, 100%);
}
}
.modal-slide-from-top-enter,
.modal-slide-from-top-leave-to {
  transform: translate(0, -100%);
}
@media screen and (max-width: 767px) {
.modal-slide-from-top-enter:not(.vl-modal-dialog--mobile-top),
  .modal-slide-from-top-leave-to:not(.vl-modal-dialog--mobile-top) {
    transform: translate(0, 100%);
}
}
.modal-slide-from-bottom-enter,
.modal-slide-from-bottom-leave-to {
  transform: translate(0, 100%);
}
.vl-modal-dialog__wrapper {
  overflow: auto;
  padding: 3rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__wrapper {
    padding: 1.5rem;
}
}
.vl-modal-dialog--mobile-left .vl-modal-dialog__mobile-close,
.vl-modal-dialog--mobile-right .vl-modal-dialog__mobile-close,
.vl-modal-dialog--mobile-top .vl-modal-dialog__mobile-close {
  display: none;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog--mobile-left .vl-modal-dialog__close,
  .vl-modal-dialog--mobile-right .vl-modal-dialog__close,
  .vl-modal-dialog--mobile-top .vl-modal-dialog__close {
    display: block;
}
}
.vl-modal-dialog__close {
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  padding: 1rem;
  border: 0;
  background: none;
  line-height: 1;
  overflow: hidden;
  color: var(--vl-theme-action-color, #05c);
}
.vl-modal-dialog__close:hover .vl-modal-dialog__close__icon, .vl-modal-dialog__close:focus .vl-modal-dialog__close__icon {
  color: var(--vl-theme-action-color, #05c);
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__close {
    display: none;
}
}
.vl-modal-dialog__close__icon::before, .vl-modal-dialog__close__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-modal-dialog__close__icon::before {
  content: "\\f160";
}
.vl-modal-dialog__close__icon {
  display: flex;
  font-size: 1.4rem;
  line-height: 1;
}
.vl-modal-dialog__close__icon::before {
  font-weight: bold;
}
.vl-modal-dialog__mobile-close {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-modal-dialog__mobile-close {
    display: inline-flex;
    top: -4.5rem;
}
}
.vl-modal-dialog__footer .vl-action-group {
  margin-top: 1.5rem;
}
.vl-pill {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  background-color: #fff;
  font-size: 1.4rem;
  font-weight: 500;
  color: #687483;
  text-decoration: none;
  vertical-align: middle;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
  padding: 0 1.4rem;
  line-height: calc(2.4rem - 0.2rem);
  min-width: 0;
}
.vl-pill__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.vl-pill__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #05c;
  width: 2.4rem;
  height: 2.4rem;
  border: 0.1rem solid #8695a8;
  text-decoration: none;
  margin-left: 1.4rem;
  padding: 0;
  border-radius: 0 0.3rem 0.3rem 0;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
  margin-top: -0.1rem;
  margin-right: -0.1rem;
  margin-bottom: -0.1rem;
  min-width: 2.4rem;
}
.vl-pill__close:hover:not([disabled]) {
  color: #003bb0;
  box-shadow: inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
  background-color: rgb(90%, 93.3333333333%, 98%);
}
.vl-pill__close:focus {
  outline: transparent solid 0.2rem;
  border: #05c 0.1rem solid;
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
}
[dir=rtl] .vl-pill__close {
  border-left: 0;
  border-right: #8695a8 0.1rem solid;
}
.is-disabled .vl-pill__close, .vl-pill__close[disabled] {
  color: #687483;
  cursor: default;
}
.vl-pill__close__icon::before, .vl-pill__close__icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-pill__close__icon::before {
  content: "\\f160";
}
.vl-pill__close__icon {
  line-height: 0;
}
.vl-pill__close__icon::before {
  display: inline-block;
  font-size: 0.8rem;
  text-indent: 0;
  line-height: 1;
  font-weight: bold;
}
.vl-pill--success {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-color: #009e47;
  color: #007a37;
}
.vl-pill--warning {
  background-color: rgb(100%, 96.3137254902%, 90.3921568627%);
  border-color: #ffA10a;
  color: #9f5804;
}
.vl-pill--error {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-color: #d2373c;
  color: #aa2729;
}
.vl-pill--disabled:not(.vl-pill--checkable):not(.vl-pill--closable) {
  background-color: #cbd2d9;
}
.vl-pill--closable {
  padding-right: 0;
}
.vl-pill--closable.vl-pill--disabled .vl-pill__close {
  background-color: #cbd2d9;
}
.vl-pill--clickable:not(.vl-pill--disabled) {
  color: #05c;
}
.vl-pill--clickable:not(.vl-pill--disabled):hover {
  background-color: rgb(90%, 93.3333333333%, 98%);
  color: #003bb0;
  border-color: #05c;
  box-shadow: inset 0 0 0 0.1rem #05c;
}
.vl-pill--clickable:not(.vl-pill--disabled):focus {
  outline: transparent solid 0.2rem;
  border-color: #05c;
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
}
.vl-pill--checkable {
  position: relative;
  padding-left: 3.6rem;
  margin-bottom: 0.3rem;
}
.vl-pill--checkable:not(.vl-pill--disabled) {
  cursor: pointer;
  color: #05c;
}
.vl-pill--checkable:not(.vl-pill--disabled):hover {
  box-shadow: inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
  background-color: rgb(90%, 93.3333333333%, 98%);
}
.vl-pill--checkable__checkbox {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-pill--checkable__checkbox[disabled] + span {
  background-color: #cbd2d9;
  color: #687483;
}
.vl-pill--checkable__checkbox:not([disabled]):focus + span {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
}
.vl-pill--checkable__checkbox:not([disabled]):active + span {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
}
.vl-pill--checkable__checkbox:not([disabled]):checked + span {
  background: #05c;
}
.vl-pill--checkable__checkbox:not([disabled]):checked + span::before {
  transform: translateZ(0) translate(-50%, -50%) scale(1);
}
.vl-pill--checkable__checkbox + span::before, .vl-pill--checkable__checkbox + span::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-pill--checkable__checkbox + span::before {
  content: "\\f15a";
}
.vl-pill--checkable__checkbox + span {
  position: absolute;
  display: inline-block;
  background: #fff;
  width: 2.4rem;
  height: 2.4rem;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  transition: background-color 0.2s, box-shadow 0.2s;
  margin: 0 1.4rem 0 0;
  left: -0.1rem;
  top: -0.1rem;
  border: 0.1rem solid #8695a8;
}
.vl-pill--checkable__checkbox + span::before {
  position: absolute;
  display: block;
  font-size: 0.8rem;
  color: #fff;
  line-height: 1;
  text-align: center;
  transition: all 0.3s cubic-bezier(1, 0.1, 0, 0.9) 0.1s, background-color 0.2, box-shadow 0.2s;
  transform: translateZ(0) translate(-50%, -50%) scale(0);
  top: 50%;
  left: 50%;
}
.vl-pill--checkable__checkbox[disabled] + span {
  cursor: auto;
}
.vl-pill-input__inner {
  display: inline-block;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 3.5rem;
  padding: 0 0.5rem;
  line-height: calc(3.5rem - 0.3rem);
  border: 1px solid #8695a8;
  border-radius: 0.3rem;
  color: #666;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  overflow: hidden;
  vertical-align: top;
}
.vl-pill-input__inner .vl-pill__input {
  border: 0;
  outline: 0;
  background: transparent;
  max-width: 100%;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  transform: translateY(1px);
}
.vl-pill-input__inner .vl-pill__input.is-hidden {
  display: none;
}
.is-disabled .vl-pill-input__inner {
  background-color: #f3f5f6;
  border-color: #8695a8;
  pointer-events: none;
}
.is-focused .vl-pill-input__inner {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.is-focused .vl-pill-input__inner {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
[dir=rtl] .vl-pill-input__inner {
  padding: 0 1rem 0 6rem;
}
.vl-pill-input__list {
  line-height: 1;
}
.vl-pill-input__list--multiple {
  display: inline;
}
.vl-pill-input__list--multiple .vl-pill {
  vertical-align: middle;
  word-break: break-all;
  margin-right: 0.5rem;
}
.vl-pill-input__list--multiple .vl-pill[data-deletable] {
  padding-right: 0;
}
[dir=rtl] .vl-pill-input__list--multiple .vl-pill[data-deletable] {
  padding-right: 0.7rem;
  padding-left: 0;
}
[dir=rtl] .vl-pill-input__list--multiple .vl-pill {
  margin: 0.3rem 0 0 0.5rem;
}
.vl-ol-map {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 450px;
  overflow: hidden;
  display: flex;
  font-size: 1.6rem;
}
.vl-ol-map--boxed {
  border: 1px #cbd2da solid;
}
.vl-ol-map__body {
  display: flex;
  flex: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.vl-ol-map__content {
  position: relative;
  width: 100%;
  flex: 1;
}
.vl-ol-map__map {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background-color: #f7f9fc;
}
.vl-ol-map__view-tools, .vl-ol-map__action-tools, .vl-ol-map__search {
  position: absolute;
  z-index: 10;
}
.vl-ol-map__view-tools {
  right: 2.5rem;
  bottom: 2.5rem;
}
@media screen and (max-width: 500px) {
.vl-ol-map__view-tools {
    right: 1rem;
    bottom: 1rem;
}
}
.vl-ol-map__action-tools {
  top: 2.5rem;
  right: 2.5rem;
}
@media screen and (max-width: 500px) {
.vl-ol-map__action-tools {
    top: 1rem;
    right: 1rem;
}
}
.vl-ol-map__info {
  position: absolute;
  z-index: 10;
  bottom: 0;
  left: 0;
}
.vl-ol-map__search {
  top: 2.5rem;
  left: 2.5rem;
}
@media screen and (max-width: 500px) {
.vl-ol-map__search {
    top: 1rem;
    left: 1rem;
}
}
.vl-ol-map .vl-ol-map__toaster {
  position: absolute;
  overflow: hidden;
  margin: 15px;
}
.vl-ol-map__base-layer {
  position: absolute;
  bottom: 2.5rem;
  right: 7.7rem;
  z-index: 9;
}
@media screen and (max-width: 500px) {
.vl-ol-map__base-layer {
    bottom: 1rem;
    right: 6.2rem;
}
}
@media print {
.vl-ol-map,
  .vl-ol-map canvas {
    display: block !important;
}
}
.vl-ol-map-info {
  display: flex;
  flex-wrap: wrap;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  line-height: 1.2;
}
.vl-ol-map-info > *:not(:last-child) {
  margin-right: 10px;
}
.vl-ol-map-search--offset {
  margin-left: 3.5rem;
}
.vl-ol-map-loader--blocking {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 2;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 10800;
}
.vl-ol-map-loader--overlay {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 2;
  justify-content: center;
  align-items: center;
  text-align: center;
  pointer-events: none;
}
.vl-ol-map-tools-bar {
  display: flex;
}
.vl-ol-map-tools-bar .vl-ol-map-tools-action-group:not(:last-child) {
  margin-right: 15px;
}
.vl-ol-map-tools-bar--vertical {
  display: flex;
  flex-direction: column;
}
.vl-ol-map-tools-bar--vertical .vl-ol-map-tools-action-group:not(:last-child) {
  margin-right: 0;
  margin-bottom: 1.5rem;
}
.vl-ol-map-tools-action {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: block;
  width: 3.5rem;
  height: 3.5rem;
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  font-size: 16px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.vl-ol-map-tools-action:hover {
  background: #f7f9fc;
  color: #333332;
}
.vl-ol-map-tools-action--active {
  background-color: #05c;
  color: #fff;
}
.vl-ol-map-tools-action--active:hover {
  background: #003bb0;
  color: #fff;
}
.vl-ol-map-tools-action--disabled {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-ol-map-tools-action--disabled:hover {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-ol-map-tools-action {
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
  border-radius: 0px 0.3rem 0.3rem 0px;
  color: #05c;
  background-color: #fff;
  border: none;
  box-shadow: none;
}
.vl-ol-map-tools-action[disabled] {
  cursor: not-allowed;
}
.vl-ol-map-tools-action[disabled] .vl-ol-map-tools-action__button {
  cursor: not-allowed;
}
.vl-ol-map-tools-action--active {
  background-color: #05c;
}
.vl-ol-map-tools-action--active .vl-ol-map-tools-action__svg-icon svg {
  color: #fff;
  fill: #fff;
}
.vl-ol-map-tools-action--disabled .vl-ol-map-tools-action__svg-icon svg {
  color: var(--vl-theme-fg-color-70);
  fill: var(--vl-theme-fg-color-70);
}
.vl-ol-map-tools-action:focus {
  z-index: 1;
}
.vl-ol-map-tools-action__text {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.vl-ol-map-tools-action__svg-icon svg {
  width: 14px;
  height: auto;
  color: #333332;
  fill: #333332;
}
@media screen and (max-width: 767px) {
.vl-ol-map .vl-sidebar__toggle {
    transform: none;
    top: 1rem;
    left: calc(100% + 1rem);
}
}
.vl-ol-map-tools-action-group {
  display: flex;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
}
.vl-ol-map-tools-action-group .vl-ol-map-tools-action {
  border-radius: 0;
}
.vl-ol-map-tools-action-group--vertical {
  flex-direction: column;
}
.vl-ol-map-base-layer {
  display: flex;
  background: #fff;
  border-radius: 0.3rem;
  height: 7.2rem;
  overflow: hidden;
  min-width: 10.3rem;
  border: 1px #8695a8 solid;
  position: relative;
}
.vl-ol-map-base-layer--toggle {
  min-width: 7.3rem;
}
.vl-ol-map-base-layer--toggle:hover {
  background-color: #f7f9fc;
}
.vl-ol-map-base-layer-toggle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  box-shadow: 0;
  display: inline-block;
  width: 6.55rem;
  flex: 0 0 6.55rem;
  margin: 0.3rem;
  background: #fff;
}
.vl-ol-map-base-layer--open .vl-ol-map-base-layer-toggle {
  position: relative;
  right: 0;
}
.vl-ol-map-base-layer--open .vl-ol-map-base-layer-toggle:hover {
  opacity: 0.8;
}
.vl-ol-map-base-layer-toggle__radio {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.vl-ol-map-base-layer-toggle__radio:checked + .vl-ol-map-base-layer-toggle__body {
  z-index: 3;
}
.vl-ol-map-base-layer--toggle .vl-ol-map-base-layer-toggle__radio:checked + .vl-ol-map-base-layer-toggle__body {
  z-index: 1;
}
.vl-ol-map-base-layer-toggle__body {
  position: relative;
  height: 100%;
  z-index: 2;
  border-radius: 0.3rem;
  overflow: hidden;
}
.vl-ol-map-base-layer-toggle__body__label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: #333332;
  font-size: 12px;
  text-align: center;
  z-index: 2;
}
.vl-ol-map-base-layer-toggle__body__label::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.9) 20%, rgba(255, 255, 255, 0) 100%);
  height: 40px;
}
.vl-ol-map-base-layer-toggle__body__label span {
  display: block;
  position: relative;
  z-index: 2;
  padding: 0 2px;
  text-shadow: 0 1px 1px #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-ol-map-base-layer-toggle__body__image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.vl-ol-map-base-layer__more {
  display: inline-flex;
  background: #fff;
  border: none;
  width: 3rem;
  margin-right: 0.3rem;
}
.vl-ol-map-base-layer__more:hover {
  box-shadow: 0;
}
.vl-ol-map-base-layer__more:focus {
  box-shadow: inset 0 0 0 2px rgba(0, 85, 204, 0.65);
}
.vl-ol-map-base-layer__more:hover .vl-ol-map-base-layer__more__icon {
  color: #05c;
}
.vl-ol-map-base-layer__more__icon {
  display: inline-flex;
  font-size: 1.8rem;
  transition: transform 0.2s ease-in-out;
  align-self: center;
}
.vl-ol-map-base-layer--open .vl-ol-map-base-layer__more__icon {
  transform: rotate(180deg);
}

/* @import "~@govflanders/vl-ui-pattern/src/scss/pattern"; */
.vl-person-info {
  display: block;
}
.vl-person-info__img {
  position: relative;
  width: 14rem;
  height: 14rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: -7rem;
}
.vl-person-info__img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.vl-person-info__content {
  background-color: #f7f9fc;
  padding: 9rem 2rem 2rem;
}
.vl-person-info__data {
  font-size: 1.6rem;
  line-height: 1.25;
}
@media screen and (max-width: 767px) {
.vl-person-info__data {
    font-size: 1.6rem;
}
}
.vl-person-info__data .vl-person-info__value {
  margin-bottom: 1.5rem;
  font-weight: 500;
}
.vl-person-info--quote .vl-quote {
  overflow: visible;
}
.vl-person-info--quote .vl-quote__content {
  overflow: visible;
}
.vl-person-info--quote .vl-quote__content::before {
  position: absolute;
  transform: translateX(-100%);
  top: -8rem;
  left: 50%;
}
.vl-person-info--quote .vl-quote__text, .vl-person-info--quote .vl-quote__author, .vl-person-info--quote .vl-quote__reference {
  margin-left: 0;
}
@keyframes slideIn {
0% {
    display: none;
}
1% {
    display: block;
    opacity: 0;
}
100% {
    opacity: 1;
    transform: translateY(0%);
}
}
@keyframes slideOut {
0% {
    transform: translateY(0%);
    opacity: 1;
    display: block;
}
99% {
    opacity: 0;
    transform: translateY(120%);
}
100% {
    display: none;
}
}
.vl-popover {
  display: inline-block;
  position: relative;
}
.vl-popover .vl-popover__arrow {
  display: none;
  position: absolute;
  right: 0.5rem;
  bottom: -1.4rem;
  border: 0.9rem solid transparent;
  border-bottom-color: #cfd5dd;
  border-top-width: 0;
  z-index: 99999;
}
.vl-popover .vl-popover__arrow::before {
  content: "";
  position: absolute;
  border: 0.9rem solid transparent;
  border-bottom-color: #fff;
  border-top-width: 0;
  transform: translate(-50%, 1px);
}
@media screen and (max-width: 767px) {
.vl-popover .vl-popover__arrow {
    display: none;
}
}
.vl-popover--static {
  position: static;
}
.vl-popover--static .vl-popover__arrow {
  position: relative;
}
.vl-popover--align-left .vl-popover__arrow {
  left: 0.4rem;
  right: auto;
}
.vl-popover--align-center .vl-popover__arrow {
  left: 50%;
  transform: translateX(-50%);
  right: auto;
  margin: auto;
}
.vl-popover--align-top .vl-popover__arrow {
  top: -1.1rem;
  bottom: auto;
  transform: scale(-1);
}
.vl-popover .vl-popover__toggle {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  text-decoration: none;
  display: inline-block;
  font-size: 1.6rem;
  font-family: "Flanders Art Sans", sans-serif;
}
.vl-popover .vl-popover__toggle .vl-vi-arrow {
  transition: cubic-bezier(1, 0.1, 0, 0.9) 0.2s transform;
}
.vl-popover .vl-popover__toggle .vl-popover__toggle-icon {
  margin-left: 0.8rem;
}
.vl-popover .vl-popover__toggle .vl-badge {
  margin-top: 0.5rem;
}
.vl-popover.js-vl-popover--open .vl-popover__arrow {
  display: block;
}
@media screen and (max-width: 767px) {
.vl-popover.js-vl-popover--open .vl-popover__arrow {
    display: none;
}
}
@media screen and (max-width: 767px) {
.vl-popover.js-vl-popover--open .vl-popover__content {
    display: block;
    opacity: 0;
    animation: slideIn 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
}
}
@media screen and (min-width: 767px) {
.vl-popover.js-vl-popover--open .vl-popover__content {
    visibility: visible;
    opacity: 1;
}
}
.vl-popover.js-vl-popover--open .vl-vi-arrow {
  transform: rotate(-180deg);
}
@media screen and (max-width: 767px) {
.vl-popover.js-vl-popover--closing .vl-popover__content {
    will-change: transform;
    display: block;
    animation: slideOut 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
}
}
.vl-popover--closable .vl-popover__close-btn {
  display: inline-flex;
}
.vl-popover--closable .vl-popover__close-btn:hover {
  color: #05c;
}
.vl-popover--closable .vl-popover__close-btn:focus {
  color: rgb(0%, 25%, 60%);
}
@media screen and (min-width: 767px) {
.vl-popover--closable .vl-popover__close-btn {
    padding: 1.5rem;
    right: 0;
    width: auto;
}
.vl-popover--closable .vl-popover__close-btn .vl-button__icon {
    margin: 0;
}
}
.vl-popover__close-btn {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-popover__close-btn {
    display: inline-flex;
    top: -4.5rem;
}
}
.vl-backdrop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10008;
  background-color: rgba(232, 235, 238, 0.95);
  opacity: 0.95;
  opacity: 0;
  z-index: -1;
  transition: cubic-bezier(1, 0.1, 0, 0.9) 0.4s opacity, cubic-bezier(1, 0.1, 0, 0.9) 0.4s z-index;
  will-change: opacity;
}
@media screen and (max-width: 767px) {
.vl-backdrop--active {
    opacity: 1;
    z-index: 10008;
}
}
.vl-popover__content-overflow {
  max-height: 30rem;
  overflow-y: auto;
  padding: 2rem;
}
@media screen and (max-width: 767px) {
.vl-popover__content-overflow {
    max-height: 65vh;
}
}
@media screen and (min-width: 767px) {
.vl-popover--closable .vl-popover__content-overflow {
    padding-right: 5rem;
}
}
.vl-popover__content {
  background-color: #fff;
  box-shadow: 0 0 2.1rem 0 rgba(0, 0, 0, 0.1);
  width: 23rem;
  min-width: 23rem;
  max-width: 90vw;
  z-index: 10003;
  border: 0.1rem solid #cfd5dd;
}
@media screen and (max-width: 767px) {
.vl-popover__content {
    width: 100%;
    max-width: 100%;
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    top: auto;
    display: none;
    z-index: 10009;
    transform: translateY(120%);
}
}
@media screen and (min-width: 767px) {
.vl-popover__content {
    visibility: hidden;
    opacity: 0;
    margin: 0;
    margin-top: 0.3rem;
}
}
@media screen and (min-width: 767px) {
.vl-popover--large .vl-popover__content {
    width: 45rem;
}
}
.vl-popover .vl-link-list,
.vl-popover__link-list {
  padding: 0;
}
.vl-popover .vl-link-list li,
.vl-popover .vl-link-list .vl-link-list__item,
.vl-popover__link-list li,
.vl-popover__link-list .vl-link-list__item {
  padding: 0.6rem 0;
}
.vl-popover .vl-link-list li:first-child,
.vl-popover .vl-link-list .vl-link-list__item:first-child,
.vl-popover__link-list li:first-child,
.vl-popover__link-list .vl-link-list__item:first-child {
  padding-top: 0;
}
.vl-popover--closable .vl-popover .vl-link-list li:first-child,
.vl-popover--closable .vl-popover .vl-link-list .vl-link-list__item:first-child,
.vl-popover--closable .vl-popover__link-list li:first-child,
.vl-popover--closable .vl-popover__link-list .vl-link-list__item:first-child {
  max-width: calc(100% - 4.5rem);
}
.vl-popover .vl-link-list li:last-of-type,
.vl-popover .vl-link-list .vl-link-list__item:last-of-type,
.vl-popover__link-list li:last-of-type,
.vl-popover__link-list .vl-link-list__item:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
}
.vl-popover .vl-link-list li.vl-popover__link-list__separator,
.vl-popover .vl-link-list .vl-link-list__item.vl-popover__link-list__separator,
.vl-popover__link-list li.vl-popover__link-list__separator,
.vl-popover__link-list .vl-link-list__item.vl-popover__link-list__separator {
  height: 0.1rem;
  background: #cfd5dd;
  padding: 0;
  margin: 0.5rem 0;
}
.vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-link, .vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-icon, .vl-popover .vl-link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-header__toggle,
.vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-link,
.vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon,
.vl-sidebar-panel-list-item__button .vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-icon,
.vl-popover .vl-link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-header__toggle,
.vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-link,
.vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon,
.vl-sidebar-panel-list-item__button .vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-icon,
.vl-popover__link-list--bordered .vl-popover .vl-link-list__item:not(:last-of-type) .vl-sidebar-header__toggle,
.vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-link,
.vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-panel-list-item__button .vl-icon,
.vl-sidebar-panel-list-item__button .vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-icon,
.vl-popover__link-list--bordered .vl-popover__link-list__item:not(:last-of-type) .vl-sidebar-header__toggle {
  position: relative;
}
.vl-radio {
  position: relative;
  display: inline-block;
  margin-top: 0.2rem;
  margin-right: 5rem;
}
.vl-radio:not(.vl-radio--block):not(:last-of-type) {
  margin-right: 1.5rem;
}
.vl-radio__label {
  position: relative;
  padding: 0 0 0 2.4rem;
  line-height: 2.8rem;
  font-size: 1.6rem;
}
.vl-radio__label::before, .vl-radio__label::after {
  position: absolute;
  display: block;
  content: "";
  cursor: pointer;
  border-radius: 100%;
}
.vl-radio__label::before {
  background-color: #fff;
  height: 6px;
  width: 6px;
  top: 10px;
  left: 6px;
  transform: scale(0);
  transition: border-color 0.2s cubic-bezier(1, 0.1, 0, 0.9);
  z-index: 2;
}
@media screen and (max-width: 767px) {
.vl-radio__label::before {
    font-size: 1.6rem;
}
}
.vl-radio__label::after {
  background-color: #fff;
  width: 18px;
  height: 18px;
  top: 4px;
  left: 0;
  border: 0.1rem solid #8695a8;
  text-indent: 100%;
  overflow: hidden;
  white-space: nowrap;
  transition: border-color 0.2s cubic-bezier(1, 0.1, 0, 0.9), box-shadow 0.1s cubic-bezier(1, 0.1, 0, 0.9);
  z-index: 1;
}
.vl-radio__toggle {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
}
.vl-radio__toggle:focus + .vl-radio__label::after {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-radio__toggle:focus + .vl-radio__label::after {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-radio__toggle:checked + .vl-radio__label::before {
  transform: scale(1);
  background-color: #fff;
}
.vl-radio__toggle:checked + .vl-radio__label::after {
  background: #05c;
  border: 0;
}
.vl-radio--block {
  display: block;
  margin: 0;
}
.vl-radio--disabled .vl-radio__label {
  color: #687483;
}
.vl-radio--disabled .vl-radio__label::after {
  background-color: #8695a8;
  border-color: #8695a8;
}
.vl-radio--disabled .vl-radio__toggle:checked + .vl-radio__label::before {
  background-color: #fff;
}
.vl-radio--disabled .vl-radio__toggle:checked + .vl-radio__label::after {
  background: #8695a8;
  border: 0.1rem #8695a8 solid;
}
.vl-radio--single {
  margin: 0;
}
.vl-radio--single .vl-radio__label {
  padding: 0;
}
.vl-radio--single .vl-radio__label::after {
  position: relative;
}
.vl-radio--error .vl-radio__label::after, .vl-radio.invalid.validated .vl-radio__label::after {
  background-color: #fff;
  border-color: #d2373c;
}
.vl-radio--error .vl-radio__toggle:checked + .vl-radio__label::before, .vl-radio.invalid.validated .vl-radio__toggle:checked + .vl-radio__label::before {
  background-color: #d2373c;
}
.vl-radio--error .vl-radio__toggle:checked + .vl-radio__label::after, .vl-radio.invalid.validated .vl-radio__toggle:checked + .vl-radio__label::after {
  background-color: #fff;
  border: 0.1rem #d2373c solid;
}
.vl-radio--success .vl-radio__label::after {
  background-color: #fff;
  border-color: #009e47;
}
.vl-radio--success .vl-radio__toggle:checked + .vl-radio__label::before {
  background-color: #009e47;
}
.vl-radio--success .vl-radio__toggle:checked + .vl-radio__label::after {
  background-color: #fff;
  border: 0.1rem #009e47 solid;
}
.vl-radio-tile__label {
  display: block;
  position: relative;
  padding: 1.5rem;
  border: 1px solid #cbd2da;
  border-width: 1px 1px 1px 30px;
  background-color: #fff;
  font-size: 1.6rem;
  border-radius: 0.3rem;
}
.vl-radio-tile__label::after {
  display: block;
  position: absolute;
  top: 2rem;
  left: -2.2rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  background-color: #fff;
  color: #05c;
  content: "";
  z-index: 1;
}
.vl-radio-tile__input {
  position: absolute !important;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label {
  cursor: pointer;
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label:hover, .vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label:focus {
  padding: 1.4rem 1.4rem 1.4rem 1.5rem;
  border: 2px solid #003bb0;
  border-width: 2px 2px 2px 30px;
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label:hover::after, .vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label:focus::after {
  top: 1.9rem;
}
.vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label:hover::before, .vl-radio-tile__input:not(:disabled) + .vl-radio-tile__label:focus::before {
  top: 2rem;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label {
  padding: 1.4rem 1.4rem 1.4rem 1.5rem;
  border: 2px solid #05c;
  border-width: 2px 2px 2px 30px;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label::after {
  border-color: #05c;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label::before {
  display: block;
  position: absolute;
  top: 2.1rem;
  left: -2.1rem;
  width: 1.3rem;
  height: 1.3rem;
  border: 4px solid #05c;
  border-radius: 50%;
  background-color: #fff;
  color: #05c;
  content: "";
  z-index: 2;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label:hover, .vl-radio-tile__input:checked + .vl-radio-tile__label:focus {
  border-color: #003bb0;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label:hover::after, .vl-radio-tile__input:checked + .vl-radio-tile__label:focus::after {
  top: 2rem;
}
.vl-radio-tile__input:checked + .vl-radio-tile__label:hover::before, .vl-radio-tile__input:checked + .vl-radio-tile__label:focus::before {
  top: 2.1rem;
}
.vl-radio-tile__input:focus + .vl-radio-tile__label {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-radio-tile__input:focus + .vl-radio-tile__label {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label::before, .vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label::before {
  content: "\\f15a";
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label::after {
  border-radius: 0;
}
.vl-radio-tile__input[type=checkbox] + .vl-radio-tile__label::before {
  display: none;
  border: 0;
  border-radius: 0;
  font-size: 1rem;
}
.vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label::before, .vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label::before {
  content: "\\f15a";
}
.vl-radio-tile__input[type=checkbox]:checked + .vl-radio-tile__label::before {
  display: block;
}
.vl-radio-tile__input:disabled + .vl-radio-tile__label {
  background-color: #cbd2d9;
}
.vl-radio-tile__input:disabled + .vl-radio-tile__label .vl-checkbox-tile__title {
  color: var(--vl-theme-fg-color-70);
}
.vl-radio-tile__title {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-radio-tile__title {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-radio-tile__title {
  display: block;
}
.vl-radio-tile__icon {
  font-size: 2.8rem;
  line-height: 1;
}
.vl-radio-tile__image {
  margin-top: 0.5rem;
}
.vl-radio-tile__info {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: block;
  color: #687483;
}
.vl-radio-tile--error .vl-radio-tile__label {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  border-color: #d2373c;
}
.vl-radio-tile--error .vl-radio-tile__input:checked + .vl-radio-tile__label {
  border-color: #d2373c;
}
.vl-radio-tile--error .vl-radio-tile__input:checked + .vl-radio-tile__label::before {
  color: #d2373c;
}
.vl-radio-tile--success .vl-radio-tile__label {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-color: #009e47;
}
.vl-radio-tile--success .vl-radio-tile__input:checked + .vl-radio-tile__label {
  border-color: #009e47;
}
.vl-radio-tile--success .vl-radio-tile__input:checked + .vl-radio-tile__label::before {
  color: #009e47;
}
.vl-radio-tile--disabled .vl-radio-tile__label {
  background-color: #f3f5f6;
  border-color: #8695a8;
}
.vl-radio-tile + .vl-radio-tile {
  margin-top: 10px;
}
.vl-radio-tile--error .vl-radio-tile__input:checked + .vl-radio-tile__label::before {
  background-color: #d2373c;
  border-color: #f3f5f6;
}
.vl-radio-tile--success .vl-radio-tile__input:checked + .vl-radio-tile__label::before {
  background-color: #009e47;
  border-color: #f3f5f6;
}
.vl-search {
  position: relative;
}
.vl-search .vl-search__reset {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0px;
  z-index: 1;
  background: none;
  border: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 10px 11px;
  min-height: 2.5rem;
  width: 2.5rem;
}
.vl-search {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2rem 1.5rem;
  background-color: #f7f9fc;
}
@media screen and (max-width: 767px) {
.vl-search {
    display: block;
    padding: 1.5rem 1rem;
}
}
.vl-search .vl-search__label {
  color: #687483;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1;
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__label {
    font-size: 1.6rem;
}
}
.vl-search .vl-search__label {
  white-space: nowrap;
}
.vl-search .vl-search__input-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__input-wrapper {
    flex-direction: column;
    align-items: flex-start;
}
}
.vl-search .vl-search__input {
  flex: 6;
  margin: 0 2rem;
}
@media screen and (max-width: 1023px) {
.vl-search .vl-search__input {
    margin: 0 1rem;
    flex: 4;
}
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__input {
    margin: 0;
    width: 100%;
    margin-bottom: 1.5rem;
}
}
.vl-search .vl-search__reset {
  right: 25px;
}
@media screen and (max-width: 1023px) {
.vl-search .vl-search__reset {
    right: 15px;
}
}
@media screen and (max-width: 767px) {
.vl-search .vl-search__reset {
    right: 5px;
    top: calc(50% - 0.75rem);
}
}
.vl-search.vl-search--alt {
  background-color: transparent;
  padding: 0;
  background: none;
}
@media screen and (max-width: 767px) {
.vl-search.vl-search--alt {
    padding: 0;
}
}
@media screen and (max-width: 767px) {
.vl-search--inline {
    display: block;
    width: auto;
}
}
.vl-search--inline .vl-search__label {
  display: block;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 4.3rem;
  color: #fff;
  font-size: 0 !important;
}
.vl-search--inline .vl-search__submit {
  padding: 0;
  position: absolute;
  right: 5px;
  font-size: 1.9rem;
  z-index: 1;
  top: 50%;
  min-height: 2.5rem;
  width: 2.5rem;
  transform: translateY(-50%);
}
.vl-search--inline .vl-search__label {
  color: #333332;
}
.vl-search--inline .vl-search__reset {
  right: 35px;
  top: 50%;
}
.vl-search--inline .vl-search__input {
  padding-right: 30px;
  flex: unset;
  margin: 0;
  text-overflow: ellipsis;
  width: 100%;
}
.vl-search--inline .vl-search__input:focus, .vl-search--inline .vl-search__input:hover {
  padding-right: 30px;
}
.vl-search--inline.vl-search--has-input-value .vl-search__input {
  padding-right: 60px;
}
.vl-search--inline.vl-search--has-input-value .vl-search__input:focus, .vl-search--inline.vl-search--has-input-value .vl-search__input:hover {
  padding-right: 60px;
}
.vl-search--inline .vl-search__submit:focus {
  transition: none;
}
.vl-search--inline .vl-search__input-wrapper {
  display: block;
  width: 100%;
  text-align: left;
  position: relative;
}
.vl-select {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -moz-appearance: none;
       appearance: none;
  display: inline-block;
  position: relative;
  padding: 0 4rem 0 1.5rem;
  max-width: 100%;
  height: 3.5rem;
  line-height: calc(3.5rem - 0.2rem);
  border: 1px solid #8695a8;
  border-radius: 0.3rem;
  text-decoration: none;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  -webkit-appearance: none;
}
.vl-select:focus::-ms-value {
  background: inherit;
  color: inherit;
}
.vl-select::-ms-expand {
  display: none;
}
.vl-select:hover:not([disabled]) {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0 3.9rem 0 1.4rem;
  line-height: 3.2rem;
  background-position: calc(100% - 1.4rem) 50%;
}
.vl-select:hover:not([disabled]).vl-select--error, .vl-select:hover:not([disabled]).invalid.validated {
  border-color: #d2373c;
}
.vl-select:hover:not([disabled]).vl-select--success, .vl-select:hover:not([disabled]).valid.validated {
  border-color: #009e47;
}
.vl-select:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-select:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-select[disabled], .vl-select--disabled {
  border-color: #8695a8;
  background-color: #f3f5f6;
  color: var(--vl-theme-fg-color-70);
}
.vl-select--error, .vl-select.invalid.validated {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.vl-select--success, .vl-select.valid.validated {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.vl-select--block {
  display: block;
  width: 100%;
}
@media screen and (max-width: 767px) {
.vl-select {
    height: 3.5rem;
    line-height: 3.5rem;
    font-size: 1.6rem;
}
}
@media all and (min-width: 0�) and (min-resolution: 0.001dpcm) {
.vl-select {
    padding-right: 0;
    background-image: none;
}
}
.no-js [data-vl-select] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -moz-appearance: none;
       appearance: none;
  display: inline-block;
  position: relative;
  padding: 0 4rem 0 1.5rem;
  max-width: 100%;
  height: 3.5rem;
  line-height: calc(3.5rem - 0.2rem);
  border: 1px solid #8695a8;
  border-radius: 0.3rem;
  text-decoration: none;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  -webkit-appearance: none;
}
.no-js [data-vl-select]:focus::-ms-value {
  background: inherit;
  color: inherit;
}
.js-vl-select {
  position: relative;
  border-radius: 0.3rem;
  z-index: 999;
}
.js-vl-select.is-disabled {
  border-color: #687483;
  background-color: #f3f5f6 !important;
  outline: 0;
}
.js-vl-select.is-disabled .vl-select__inner {
  border-color: #8695a8;
}
.js-vl-select.is-disabled .vl-select__item {
  color: var(--vl-theme-fg-color-70);
  cursor: default;
}
.js-vl-select.is-focused {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.js-vl-select.is-focused {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.js-vl-select.is-open {
  z-index: 1000;
}
.js-vl-select.is-open .vl-select__inner {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.js-vl-select.is-open::after {
  transform: translateY(-0.75rem);
  border-color: transparent transparent #000;
}
.js-vl-select.is-flipped .vl-select__inner {
  border-radius: 0 0 0.3rem 0.3rem;
}
.js-vl-select.is-flipped .vl-select__list--dropdown {
  top: auto;
  bottom: 100%;
  transform: translateY(0.1rem);
  border-radius: 0.3rem 0.3rem 0 0;
}
.js-vl-select:hover:not(.is-disabled) .vl-select__inner {
  border-color: rgba(0, 85, 204, 0.65);
  box-shadow: inset 0 0 0 0.1rem rgba(0, 85, 204, 0.65);
}
.js-vl-select[data-type*=select-one] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.js-vl-select[data-type*=select-one] .vl-input-field {
  display: block;
  padding: 0;
  color: #333332;
  overflow: hidden;
  white-space: nowrap;
}
.js-vl-select[data-type*=select-one] .vl-select__list--dropdown .vl-input-field {
  width: calc(100% - 2 * 2rem);
  margin: 2rem;
  padding: 0 1rem;
  border: 0.1rem solid #8695a8;
}
.js-vl-select[data-type*=select-one] .vl-select__item--selectable {
  min-height: calc(3.5rem - 1.2rem);
  height: calc(3.5rem - 1.2rem);
}
.js-vl-select[data-type*=select-one] .vl-select__inner {
  height: 3.5rem;
  line-height: 3.5rem;
  padding-right: 3.5rem;
}
.js-vl-select[data-type*=select-one][dir=rtl]::after {
  right: auto;
  left: 1.15rem;
}
.js-vl-select[data-type*=select-one][dir=rtl] .vl-select__button {
  right: auto;
  left: 0;
  margin-right: 0;
  margin-left: 2.5rem;
}
.js-vl-select[data-type*=select-one][dir=rtl] .vl-pill__close {
  margin-right: auto;
  margin-left: 0;
}
.js-vl-select[data-type*=select-one] .vl-select__button {
  border: 0;
}
.js-vl-select[data-type*=select-one] .vl-pill__close::before, .js-vl-select[data-type*=select-one] .vl-pill__close::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-select[data-type*=select-one] .vl-pill__close::before {
  content: "\\f17f";
}
.js-vl-select[data-type*=select-one] .vl-pill__close {
  border: 0;
  display: inline-flex;
  margin-left: auto;
}
.js-vl-select[data-type*=select-one] .vl-pill__close:hover, .js-vl-select[data-type*=select-one] .vl-pill__close:focus, .js-vl-select[data-type*=select-one] .vl-pill__close:active {
  color: #003bb0;
}
.js-vl-select[data-type*=select-one].is-disabled .vl-pill__close,
.js-vl-select[data-type*=select-one] .vl-select__placeholder .vl-pill__close {
  display: none;
}
.js-vl-select[data-type*=select-multiple] {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) 50%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.js-vl-select[data-type*=select-multiple], .js-vl-select[data-type*=text] {
  background-color: #fff;
}
.js-vl-select[data-type*=select-multiple] .vl-select__inner, .js-vl-select[data-type*=text] .vl-select__inner {
  cursor: text;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button::before, .js-vl-select[data-type*=select-multiple] .vl-select__button::after, .js-vl-select[data-type*=text] .vl-select__button::before, .js-vl-select[data-type*=text] .vl-select__button::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button::before, .js-vl-select[data-type*=text] .vl-select__button::before {
  content: "\\f17f";
}
.js-vl-select[data-type*=select-multiple] .vl-select__button, .js-vl-select[data-type*=text] .vl-select__button {
  display: inline-block;
  width: 2.2rem;
  height: 2.3rem;
  margin-left: 0.5rem;
  transform: translateY(-0.1rem);
  border-left: 0.1rem solid #8695a8;
  color: #666;
  text-align: center;
  text-decoration: none;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button::before, .js-vl-select[data-type*=text] .vl-select__button::before {
  padding: 0 0.4rem;
  font-size: 1.1rem;
  text-indent: 0;
}
.js-vl-select[data-type*=select-multiple] .vl-select__button:hover, .js-vl-select[data-type*=select-multiple] .vl-select__button:focus, .js-vl-select[data-type*=text] .vl-select__button:hover, .js-vl-select[data-type*=text] .vl-select__button:focus {
  opacity: 1;
}
.js-vl-select[data-type*=select-multiple] .vl-input-field, .js-vl-select[data-type*=text] .vl-input-field {
  display: inline;
  padding: 0;
  line-height: 2.2rem;
  height: 2.4rem;
}
.js-vl-select[data-type*=select-multiple] .vl-input-field:focus, .js-vl-select[data-type*=text] .vl-input-field:focus {
  outline: 0;
  box-shadow: none;
}
.js-vl-select__group {
  padding: 0.3rem 0.5rem 0.3rem 0;
  border-top: 0.1rem solid #8695a8;
  text-decoration: none;
}
.js-vl-select .vl-select__inner {
  padding: 0.5rem 6rem 0.4rem 1rem;
  border: 0.1rem solid #8695a8;
  border-radius: 0.3rem;
  color: #666;
  font-family: "Flanders Art Sans", sans-serif;
  overflow: hidden;
}
.is-open .js-vl-select .vl-select__inner {
  border-bottom: 0;
}
.js-vl-select .vl-select__list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.js-vl-select .vl-select__list--single {
  display: inline-block;
  width: 100%;
}
[dir=rtl] .js-vl-select .vl-select__list--single {
  padding-right: 0.5rem;
  padding-left: 1.5rem;
}
.js-vl-select .vl-select__list--multiple {
  display: inline-flex;
  align-content: center;
  max-width: 100%;
}
.js-vl-select .vl-select__list--multiple .vl-select__item {
  margin: 0.2rem 0.6rem 0.5rem 0;
  display: inline-flex;
}
.js-vl-select .vl-select__list--multiple .vl-select__item[data-deletable] {
  padding-right: 0;
}
[dir=rtl] .js-vl-select .vl-select__list--multiple--multiple {
  margin-right: 0;
  margin-left: 0.375rem;
}
.js-vl-select .vl-select__list--multiple .vl-input-field {
  padding: 0.4rem 0 0.4rem 0.2rem;
}
.js-vl-select .vl-select__list--dropdown {
  display: none;
  position: absolute;
  top: 100%;
  width: 100%;
  transform: translateY(-0.1rem);
  border: 0.1rem #8695a8 solid;
  background-color: #fff;
  z-index: 1;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.js-vl-select .vl-select__list--dropdown.is-active {
  display: block;
}
.js-vl-select .vl-select__list--dropdown .vl-select__list {
  position: relative;
  max-height: 35vh;
  overflow: auto;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
}
.js-vl-select .vl-select__list--dropdown .vl-input-field + .vl-select__list {
  border-top: 0.1rem solid #8695a8;
}
.js-vl-select .vl-select__list--dropdown .vl-select__item {
  width: 100%;
  min-height: 0;
  height: auto;
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  padding-left: 3rem;
  border: 0;
  color: #000;
  font-weight: normal;
  text-decoration: none;
}
.js-vl-select .vl-select__list--dropdown .vl-select__item:not(:first-of-type) {
  border-top: 0.1rem #cbd2da solid;
}
[dir=rtl] .js-vl-select .vl-select__list--dropdown .vl-select__item {
  text-align: right;
}
@media screen and (min-width: 767px) {
.js-vl-select .vl-select__list--dropdown .vl-select__item--selectable {
    padding-right: 10rem;
}
.js-vl-select .vl-select__list--dropdown .vl-select__item--selectable::after {
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    content: attr("data-select-text");
    opacity: 0.5;
}
[dir=rtl] .js-vl-select .vl-select__list--dropdown .vl-select__item--selectable {
    padding-right: 1rem;
    padding-left: 10rem;
    text-align: right;
}
[dir=rtl] .js-vl-select .vl-select__list--dropdown .vl-select__item--selectable::after {
    right: auto;
    left: 1rem;
}
}
.js-vl-select .vl-select__list--dropdown .vl-select__item--selectable.is-highlighted {
  position: relative;
  background-color: rgba(179, 207, 245, 0.3);
}
.js-vl-select .vl-select__list--dropdown .vl-select__item[aria-selected=true] {
  background-color: rgba(179, 207, 245, 0.3);
}
.js-vl-select .vl-select__item {
  cursor: default;
  display: flex;
  align-items: center;
}
.js-vl-select .vl-select__item--disabled {
  background-color: #f3f5f6 !important;
  border-color: #8695a8;
  color: var(--vl-theme-fg-color-70) !important;
  cursor: not-allowed;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.js-vl-select .vl-select__item--disabled:hover {
  background-color: #f3f5f6;
}
.js-vl-select .vl-select__item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.js-vl-select .vl-input-field {
  display: inline-block;
  max-width: 100%;
  border: 0;
  background-color: transparent;
  vertical-align: baseline;
}
[dir=rtl] .js-vl-select .vl-input-field {
  padding-right: 0.2rem;
  padding-left: 0;
}
.js-vl-select .vl-select__placeholder {
  opacity: 0.5;
}
.js-vl-select .vl-select__group {
  display: block;
}
.js-vl-select .vl-select__group:not(:first-of-type) {
  border-top: 0.1rem solid #8695a8;
}
.js-vl-select .vl-select__group .vl-select__heading {
  padding: 0.6rem 2rem;
  color: #687483;
  font-weight: 500;
}
.vl-select--error .js-vl-select {
  background-color: #d2373c;
  border: 0.2rem solid #d2373c;
  box-shadow: inset 0 0 0 0.1rem #d2373c;
}
.vl-select--error .js-vl-select:focus {
  background-color: #fff;
}
.vl-select--success .js-vl-select {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  border-width: 0.2rem;
  border-style: solid;
}
.vl-spotlight {
  display: block;
  text-decoration: none;
  position: relative;
  padding: 2rem 0rem;
}
.vl-spotlight::before {
  display: block;
  content: "";
  height: 0.2rem;
  left: 0;
  right: 0;
  position: absolute;
  top: 0;
  background-color: #cbd2da;
  z-index: 3;
}
.vl-spotlight.vl-spotlight--alt-focus .vl-spotlight__link-wrapper {
  box-shadow: none;
  text-decoration: none;
}
.vl-spotlight--link::before {
  background-color: #05c;
}
.vl-spotlight--alt {
  background-color: #f7f9fc;
  padding: 2rem;
}
.vl-spotlight--alt.vl-spotlight--no-border {
  padding: 2rem;
}
.vl-spotlight--alt.vl-spotlight--no-border.vl-spotlight--image {
  padding-top: 0;
}
.vl-region--alt .vl-spotlight--alt {
  background-color: #fff;
}
.vl-spotlight--image-icon::before {
  top: 85px;
  z-index: 0;
}
@media screen and (max-width: 500px) {
.vl-spotlight--image-icon::before {
    top: 60px;
}
}
.vl-spotlight--image-icon .vl-spotlight__image--icon {
  margin-bottom: 2rem;
  padding-top: 0;
}
.vl-spotlight--image-icon .vl-spotlight__image--icon .vl-badge {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
@media screen and (max-width: 500px) {
.vl-spotlight--image-icon .vl-spotlight__image--icon {
    margin-bottom: 1rem;
}
.vl-spotlight--image-icon .vl-spotlight__image--icon .vl-badge {
    width: 75px;
    height: 75px;
}
}
.vl-spotlight--horizontal .vl-spotlight__main {
  display: flex;
  align-items: center;
}
.vl-spotlight--horizontal .vl-spotlight__container {
  flex: 1;
}
.vl-spotlight--horizontal .vl-spotlight__header {
  overflow: visible;
}
.vl-spotlight--horizontal .vl-spotlight__color-block--rounded {
  background: transparent;
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block,
.vl-spotlight--horizontal .vl-spotlight__color-block,
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) {
  max-width: 15rem;
  width: 15rem;
}
@media screen and (max-width: 500px) {
.vl-spotlight--horizontal .vl-spotlight__transparent-block,
  .vl-spotlight--horizontal .vl-spotlight__color-block,
  .vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) {
    max-width: 7.5rem;
}
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block .vl-icon,
.vl-spotlight--horizontal .vl-spotlight__color-block .vl-icon,
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) .vl-icon {
  font-size: 6rem;
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block .vl-badge,
.vl-spotlight--horizontal .vl-spotlight__color-block .vl-badge,
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) .vl-badge {
  height: 100%;
  font-size: 0;
}
@media screen and (max-width: 500px) {
.vl-spotlight--horizontal .vl-spotlight__transparent-block .vl-badge,
  .vl-spotlight--horizontal .vl-spotlight__color-block .vl-badge,
  .vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon) .vl-badge {
    width: 100%;
    height: auto;
}
}
.vl-spotlight--horizontal .vl-spotlight__transparent-block,
.vl-spotlight--horizontal .vl-spotlight__color-block,
.vl-spotlight--horizontal .vl-spotlight__image {
  margin-right: 3rem;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-spotlight--horizontal .vl-spotlight__transparent-block,
  .vl-spotlight--horizontal .vl-spotlight__color-block,
  .vl-spotlight--horizontal .vl-spotlight__image {
    margin-bottom: 0rem;
    margin-right: 1.8rem;
}
}
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon).vl-spotlight__image--square {
  padding-top: 77%;
}
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon).vl-spotlight__image--vertical {
  padding-top: 100%;
}
.vl-spotlight--horizontal .vl-spotlight__image:not(.vl-spotlight__image--icon).vl-spotlight__color-block {
  background: transparent;
}
.vl-spotlight--horizontal.vl-spotlight--s .vl-spotlight__transparent-block,
.vl-spotlight--horizontal.vl-spotlight--s .vl-spotlight__color-block,
.vl-spotlight--horizontal.vl-spotlight--s .vl-spotlight__image, .vl-spotlight--horizontal.vl-spotlight--xs .vl-spotlight__transparent-block,
.vl-spotlight--horizontal.vl-spotlight--xs .vl-spotlight__color-block,
.vl-spotlight--horizontal.vl-spotlight--xs .vl-spotlight__image {
  margin-bottom: 0rem;
  margin-right: 1.8rem;
}
.vl-spotlight--no-border {
  padding: 0;
}
@media screen and (max-width: 767px) {
.vl-spotlight--no-border {
    padding: 0.6rem 0;
}
}
.vl-spotlight--no-border::before {
  display: none;
}
.vl-spotlight--no-visual-border .vl-spotlight__transparent-block--visual {
  border: 0;
  padding: 0;
}
.vl-spotlight--no-visual-border .vl-spotlight__image__transparent {
  box-shadow: 0 1px 6px 0 #cfd5dd;
}
.vl-spotlight--inline {
  display: inline-block;
}
.vl-spotlight__link-wrapper {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.vl-spotlight__link-wrapper .vl-link__icon {
  display: none;
}
.vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-link, .vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-icon, .vl-spotlight__link-wrapper:hover ~ .vl-spotlight__main .vl-sidebar-header__toggle, .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-link, .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-sidebar-panel-list-item__button .vl-icon, .vl-sidebar-panel-list-item__button .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-icon, .vl-spotlight__link-wrapper:focus ~ .vl-spotlight__main .vl-sidebar-header__toggle {
  text-decoration: underline;
}
.vl-spotlight__header {
  position: relative;
  overflow: hidden;
  margin-top: -2rem;
  margin-left: 0;
  margin-right: 0;
}
.vl-spotlight--no-border .vl-spotlight__header {
  margin-top: 0;
}
.vl-spotlight--alt .vl-spotlight__header {
  margin-left: -2rem;
  margin-right: -2rem;
}
.vl-spotlight__image,
.vl-spotlight__color-block,
.vl-spotlight__transparent-block {
  padding-top: 56.25%;
  position: relative;
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-spotlight__image,
  .vl-spotlight__color-block,
  .vl-spotlight__transparent-block {
    margin-bottom: 1rem;
}
}
.vl-spotlight__color-block,
.vl-spotlight__transparent-block {
  text-align: center;
}
.vl-spotlight__color-block .vl-icon,
.vl-spotlight__color-block .vl-badge,
.vl-spotlight__transparent-block .vl-icon,
.vl-spotlight__transparent-block .vl-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.vl-spotlight__color-block .vl-icon,
.vl-spotlight__transparent-block .vl-icon {
  font-size: 6rem;
}
@supports (-webkit-background-clip: text) {
.vl-spotlight__color-block .vl-icon::before,
  .vl-spotlight__transparent-block .vl-icon::before {
    background: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color)) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color));
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
.vl-spotlight__color-block .vl-icon::before,
  .vl-spotlight__transparent-block .vl-icon::before {
    background: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color)) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: var(--vl-spotlight-accent-fg-color, var(--vl-theme-primary-color));
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
.vl-spotlight__color-block .vl-badge,
.vl-spotlight__transparent-block .vl-badge {
  width: auto;
  height: calc(100% - 4rem);
  border-radius: 50%;
  aspect-ratio: 1;
}
.vl-spotlight__color-block .vl-badge.vl-badge--initials span,
.vl-spotlight__transparent-block .vl-badge.vl-badge--initials span {
  font-size: inherit;
}
.vl-spotlight__color-block {
  background-color: var(--vl-spotlight-accent-color, var(--vl-theme-primary-color));
}
.vl-spotlight__color-block--rounded {
  background-color: rgb(89.5900178253%, 92.192513369%, 96.0962566845%);
}
.vl-spotlight__color-block.vl-spotlight__image {
  background-color: rgb(89.5900178253%, 92.192513369%, 96.0962566845%);
}
@supports (-webkit-background-clip: text) {
.vl-spotlight__color-block.vl-spotlight__image .vl-icon::before {
    background: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%);
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
.vl-spotlight__color-block.vl-spotlight__image .vl-icon::before {
    background: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%) url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: rgb(38.6809269162%, 54.0106951872%, 77.0053475936%);
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
.vl-spotlight__transparent-block {
  background: transparent;
  border: 1px solid #cbd2da;
}
.vl-spotlight__transparent-block .vl-icon {
  font-size: 12rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
@supports (-webkit-background-clip: text) {
.vl-spotlight__transparent-block .vl-icon::before {
    background: #cbd2da url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: #cbd2da;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@supports ((-webkit-background-clip: text) or (background-clip: text)) {
.vl-spotlight__transparent-block .vl-icon::before {
    background: #cbd2da url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 12px;
    -webkit-background-clip: text;
    background-clip: text;
    color: #cbd2da;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
}
}
@media screen and (max-width: 1023px) {
.vl-spotlight__transparent-block .vl-icon {
    font-size: 10rem;
}
}
.vl-spotlight__transparent-block--visual:not(.vl-spotlight__image) {
  padding: 1rem;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vl-spotlight__transparent-block--hidden {
  display: none;
}
.vl-spotlight__image__img {
  position: absolute;
  top: -9999px;
  bottom: -9999px;
  left: -9999px;
  right: -9999px;
  margin: auto;
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
}
@supports ((-o-object-fit: cover) or (object-fit: cover)) {
.vl-spotlight__image__img {
    -o-object-fit: cover;
       object-fit: cover;
    -o-object-position: center;
       object-position: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
}
.vl-spotlight__image__img {
  transition: transform 0.2s;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
}
.vl-spotlight__image--focus-center-right .vl-spotlight__image__img, .vl-spotlight__image--focus-top-right .vl-spotlight__image__img, .vl-spotlight__image--focus-bottom-right .vl-spotlight__image__img {
  right: 0;
  left: auto;
  margin-left: 0;
  margin-right: 0;
}
.vl-spotlight__image--focus-center-left .vl-spotlight__image__img, .vl-spotlight__image--focus-top-left .vl-spotlight__image__img, .vl-spotlight__image--focus-bottom-left .vl-spotlight__image__img {
  right: auto;
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.vl-spotlight__image--focus-top-right .vl-spotlight__image__img, .vl-spotlight__image--focus-top-center .vl-spotlight__image__img, .vl-spotlight__image--focus-top-left .vl-spotlight__image__img {
  top: 0;
  bottom: auto;
  margin-top: 0;
  margin-bottom: 0;
}
.vl-spotlight__image--focus-bottom-right .vl-spotlight__image__img, .vl-spotlight__image--focus-bottom-center .vl-spotlight__image__img, .vl-spotlight__image--focus-bottom-left .vl-spotlight__image__img {
  bottom: 0;
  top: auto;
  margin-top: 0;
  margin-bottom: 0;
}
.vl-spotlight__image--contained .vl-spotlight__image__img {
  -o-object-fit: contain;
     object-fit: contain;
}
.vl-spotlight__title-wrapper {
  display: flex;
  align-items: flex-start;
  position: relative;
}
.vl-spotlight--alt .vl-spotlight__title-wrapper .vl-spotlight__title, .vl-region--alt .vl-spotlight__title-wrapper .vl-spotlight__title {
  padding-left: 2rem;
  background-color: #f7f9fc;
}
.vl-spotlight--alt .vl-spotlight__title-wrapper .vl-spotlight__title::before, .vl-region--alt .vl-spotlight__title-wrapper .vl-spotlight__title::before {
  background-color: #f7f9fc;
}
.vl-spotlight__container .vl-spotlight__title-wrapper .vl-spotlight__title {
  padding-left: 0;
}
.vl-region--alt .vl-spotlight--alt .vl-spotlight__title-wrapper .vl-spotlight__title, .vl-region--alt .vl-spotlight--alt .vl-spotlight__title-wrapper::before {
  background-color: #fff;
}
.vl-spotlight__title-wrapper::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0rem;
  background-color: #fff;
}
.vl-spotlight__title-wrapper .vl-spotlight__title {
  display: inline-flex;
  max-width: calc(100% - 1rem);
  padding-right: 0.5rem;
  word-break: normal;
  hyphens: auto;
}
@supports (overflow-wrap: break-word) {
.vl-spotlight__title-wrapper .vl-spotlight__title {
    overflow-wrap: break-word;
}
}
.vl-spotlight__title {
  line-height: 1.25;
  position: relative;
  font-size: 2rem;
  font-weight: 500;
  transition: color 0.2s;
}
@media screen and (max-width: 767px) {
.vl-spotlight__title {
    font-size: 1.8rem;
}
}
.vl-spotlight__title.vl-link, .vl-sidebar-panel-list-item__button .vl-spotlight__title.vl-icon, .vl-spotlight__title.vl-sidebar-header__toggle {
  font-weight: 500;
}
.vl-spotlight--xs .vl-spotlight__title {
  font-size: 1.6rem;
}
.vl-spotlight--s .vl-spotlight__title {
  font-size: 1.8rem;
}
@media screen and (max-width: 767px) {
.vl-spotlight--s .vl-spotlight__title {
    font-size: 1.6rem;
}
}
.vl-spotlight--l .vl-spotlight__title {
  font-size: 2.6rem;
}
.vl-spotlight__subtitle {
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #687483;
  margin-top: 0.6rem;
}
@media screen and (max-width: 767px) {
.vl-spotlight__subtitle {
    font-size: 1.3rem;
}
}
.vl-spotlight--xs .vl-spotlight__subtitle {
  font-size: 1.2rem;
}
.vl-spotlight--s .vl-spotlight__subtitle {
  font-size: 1.3rem;
}
.vl-spotlight--l .vl-spotlight__subtitle {
  font-size: 1.5rem;
}
.vl-spotlight__content .vl-document__type {
  padding: 3.6rem 0 0 2rem;
}
.vl-spotlight__annotation.vl-typography {
  margin-top: 1rem;
  font-size: 1.8rem;
  line-height: 1.5;
}
@media screen and (max-width: 767px) {
.vl-spotlight__annotation.vl-typography {
    margin-top: 0.5rem;
    font-size: 1.6rem;
}
}
.vl-spotlight--xs .vl-spotlight__annotation.vl-typography {
  margin-top: 0.5rem;
  font-size: 1.4rem;
}
.vl-spotlight--s .vl-spotlight__annotation.vl-typography {
  margin-top: 0.5rem;
  font-size: 1.6rem;
}
.vl-spotlight__data {
  margin: 0.7rem 0;
  color: #687483;
}
.vl-spotlight__text {
  margin-top: 1rem;
  font-size: 1.8rem;
  line-height: 1.5;
  color: #333332;
  text-decoration: none;
}
@media screen and (max-width: 767px) {
.vl-spotlight__text {
    margin-top: 0.5rem;
    font-size: 1.6rem;
}
}
.vl-spotlight--xs .vl-spotlight__text {
  margin-top: 0.5rem;
  font-size: 1.4rem;
}
.vl-spotlight--s .vl-spotlight__text {
  font-size: 1.6rem;
}
.vl-spotlight--l .vl-spotlight__text {
  font-size: 1.8rem;
}
.vl-tabs {
  margin-bottom: 3rem;
  border-bottom: 1px #cbd2da solid;
  font-size: 0;
  text-align: left;
}
.vl-tabs--overflow {
  position: relative;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  background-repeat: no-repeat;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
.vl-tabs--overflow::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
.vl-tabs--visible-overflow {
  overflow: visible;
}
.vl-tabs__wrapper {
  position: relative;
}
.vl-tabs__wrapper--fit-to-content {
  display: inline-flex;
}
.vl-tabs__wrapper--overflow::after, .vl-tabs__wrapper--overflow::before {
  content: "";
  position: absolute;
  width: 35px;
  height: calc(100% + 1px);
  display: block;
  pointer-events: none;
  top: 0;
  opacity: 0;
  transition: opacity 0.25s;
  z-index: 1;
}
.vl-tabs__wrapper--overflow::before {
  left: -1px;
  right: auto;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, white 70%, white 100%);
}
.vl-tabs__wrapper--overflow::after {
  right: -1px;
  left: auto;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, white 70%, white 100%);
}
.vl-tabs__wrapper--overflow-right::after {
  opacity: 1;
}
.vl-tabs__wrapper--overflow-left::before {
  opacity: 1;
}
.no-js .vl-tabs {
  display: none;
}
@media screen and (max-width: 767px) {
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) {
    display: none;
    position: relative;
    left: -1.5rem;
    width: calc(100% + 3rem);
    margin: 0 0 1rem;
    padding: 0.4rem 0;
    border-top: 1px #f7f9fc solid;
    border-bottom: 1px #f7f9fc solid;
}
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow)[data-vl-show=true] {
    display: block;
}
.vl-functional-header [data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) {
    left: 0;
    width: 100%;
}
}
.vl-functional-header .vl-tabs {
  margin: 0 0 -1.5rem 0;
  border: 0;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tabs {
    border-bottom: 1px #cbd2da solid;
}
}
.vl-tabs--alt {
  position: relative;
}
.vl-tabs--alt::before {
  position: absolute;
  bottom: -1px;
  left: -200%;
  width: 500%;
  height: 1px;
  background: #cbd2da;
  content: "";
}
.vl-tab {
  display: inline-block;
  position: relative;
  text-align: left;
  vertical-align: top;
  top: 1px;
  padding: 1rem 0;
  margin: 0 1.3rem;
  transition: all 0.2s;
  border-bottom: 3px solid transparent;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  font-weight: 500;
  text-decoration: none;
}
.vl-tab:first-child .vl-tab__link {
  margin-left: 0;
}
.vl-tab:last-child .vl-tab__link {
  margin-right: 0;
}
.vl-tab:hover, .vl-tab:focus {
  background-color: transparent;
  border-bottom-color: #333332;
}
.vl-tab--active {
  color: #333332;
  border-bottom: 3px solid #333332;
  background-color: transparent;
}
.vl-tab--active:visited {
  color: #333332;
}
@media screen and (max-width: 767px) {
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) .vl-tab--active {
    border: 0;
}
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tab--active {
    border: 0;
}
}
@media screen and (max-width: 767px) {
.vl-tab {
    font-size: 1.4rem;
    margin: 0 0.8rem;
}
.vl-tabs:not(.vl-tabs--overflow) .vl-tab {
    margin: 0;
}
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) .vl-tab {
    display: block;
    top: 0;
    padding: 0.7rem 1.5rem;
    border: 0;
    font-size: 1.5rem;
}
[data-vl-tabs] .vl-tabs:not(.vl-tabs--overflow) .vl-tab:first-of-type {
    width: calc(100% - 4.2rem);
}
}
.vl-tab__pane {
  display: none;
}
.vl-tab__pane[data-vl-show=true] {
  display: block;
}
.vl-tab__pane[role=tabpanel]:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-tab__pane[role=tabpanel]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
@supports (outline-offset: 2px) {
.vl-tab__pane[role=tabpanel]:focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.no-js .vl-tab__pane {
  display: block;
}
.vl-functional-header .vl-tab {
  top: 0;
  margin: 0 2rem 0 0;
  padding: 0;
}
.vl-functional-header .vl-tab .vl-tab__link {
  padding: 1rem 0;
  border: 0;
  border-top: 3px solid transparent;
  text-decoration: none;
}
.vl-functional-header .vl-tab .vl-tab__link:visited, .vl-functional-header .vl-tab .vl-tab__link .vl-link__icon {
  color: #05c;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tab .vl-tab__link {
    padding: 0.7rem 1rem;
    border: 0 !important;
}
}
.vl-functional-header .vl-tab--active .vl-tab__link {
  color: #333332;
}
.vl-functional-header .vl-tab--active .vl-tab__link:visited {
  color: #333332;
}
.vl-tabs__toggle {
  display: none;
  position: relative;
  left: -1.5rem;
  width: calc(100% + 3rem);
  height: 4.2rem;
  margin: 0 auto 1rem;
  padding: 0 0 0 1.5rem;
  border: 0;
  border-top: 1px #cbd2da solid;
  border-bottom: 1px #cbd2da solid;
  background: none;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}
.vl-functional-header .vl-tabs__toggle {
  border-top: 0px;
}
@media screen and (max-width: 767px) {
.vl-functional-header .vl-tabs__toggle {
    left: 0;
    width: 100%;
    margin: 0;
    border-bottom: 1px #cbd2da solid;
}
}
.vl-tabs__toggle span {
  display: block;
  width: calc(100% - 6rem);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.vl-tabs__toggle::before, .vl-tabs__toggle::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-tabs__toggle::before {
  content: "\\f125";
}
.vl-tabs__toggle::before {
  position: absolute;
  font-size: 1.4rem;
}
.vl-tabs__toggle::before {
  top: 0;
  right: 0;
  padding: 1.2rem 1.4rem;
  transform: rotate(90deg);
  transition: color 0.2s ease-in-out;
  font-size: 1.5rem;
}
.vl-tabs__toggle:hover, .vl-tabs__toggle:focus {
  text-decoration: underline;
}
.vl-tabs__toggle:hover::before, .vl-tabs__toggle:focus::before {
  color: #05c;
}
.vl-tabs__toggle:hover::after, .vl-tabs__toggle:focus::after {
  background: #cbd2da;
}
.vl-tabs__toggle::after {
  position: absolute;
  top: 0;
  right: 4.2rem;
  width: 1px;
  height: 100%;
  background: #cbd2da;
  content: "";
}
.vl-tabs__toggle:focus {
  outline: thin dotted;
}
.vl-tabs__toggle[data-vl-close=true] {
  position: absolute;
  top: 0;
  right: -1.5rem;
  left: auto;
  width: 4.2rem;
  height: 4.2rem;
  border: 0;
  z-index: 2;
}
.vl-tabs__toggle[data-vl-close=true]::after {
  display: none;
}
.vl-tabs__toggle[data-vl-close=true]::before {
  content: "\\f17f";
}
.vl-tabs__toggle[data-vl-close=true]::before {
  padding: 1.4rem;
  font-size: 1.3rem;
}
.vl-tabs__toggle[data-vl-close=true] span {
  display: none;
}
.vl-functional-header .vl-tabs__toggle[data-vl-close=true] {
  right: 0;
  left: auto;
  width: 4.2rem;
  border: 0;
  border-bottom: 1px #cbd2da solid;
}
@media screen and (max-width: 767px) {
.vl-tabs__toggle {
    display: block;
}
}
.vl-textarea {
  display: inline-block;
  background: #fff;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  color: #333332;
  max-width: 100%;
  height: auto;
  line-height: normal;
  border-radius: 0.3rem;
  border: 0.1rem solid #8695a8;
  -webkit-appearance: none;
  padding: 1rem;
  transition: background-color 0.2s;
  margin: 0.5rem 0;
}
@media screen and (max-width: 767px) {
.vl-textarea {
    font-size: 1.6rem;
}
}
.vl-textarea:hover {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0.9rem;
}
.vl-textarea:hover.vl-textarea--error, .vl-textarea:hover.invalid.validated {
  border-color: #d2373c;
}
.vl-textarea:hover.vl-textarea--success, .vl-textarea:hover.valid.validated {
  border-color: #009e47;
}
.vl-textarea:focus, .vl-textarea--focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-textarea:focus, .vl-textarea--focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-textarea:focus, .vl-textarea--focus {
  border: 0.1rem solid #687483;
  padding: 1rem;
}
.vl-textarea:focus.vl-textarea--error, .vl-textarea:focus.invalid.validated, .vl-textarea--focus.vl-textarea--error, .vl-textarea--focus.invalid.validated {
  border-color: #d2373c;
}
.vl-textarea:focus.vl-textarea--success, .vl-textarea:focus.valid.validated, .vl-textarea--focus.vl-textarea--success, .vl-textarea--focus.valid.validated {
  border-color: #009e47;
}
.vl-textarea::-moz-placeholder {
  color: #687483;
}
.vl-textarea::placeholder {
  color: #687483;
}
.vl-textarea--block {
  display: block;
  width: 100%;
  box-sizing: border-box;
}
.vl-textarea--error, .vl-textarea.invalid.validated {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-textarea--error:focus, .vl-textarea.invalid.validated:focus {
  background-color: #fff;
}
.vl-textarea--success, .vl-textarea.valid.validated {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
  display: inline;
}
.vl-textarea--disabled, .vl-textarea[disabled] {
  background-color: #f3f5f6;
  border-color: #8695a8;
  color: var(--vl-theme-fg-color-70);
}
.vl-textarea--disabled:hover, .vl-textarea[disabled]:hover {
  border-width: 0.1rem;
  padding: 1rem;
}
.vl-title--alt {
  text-transform: uppercase;
  font-weight: 500;
  border-bottom: 3px solid #e8ebee;
  font-size: 1.8rem;
  padding: 0 0 0.7rem;
  margin: 0 0 2rem;
  padding-top: 1.3rem;
}
.vl-title--has-border {
  border-bottom: 1px solid #cbd2da;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 767px) {
.vl-title--has-border {
    margin-bottom: 1rem;
}
}
.vl-title a {
  text-decoration: none;
}
.vl-title a:not(.vl-link):not(.vl-sidebar-header__toggle):hover, .vl-title a:not(.vl-link):not(.vl-sidebar-header__toggle):focus {
  text-decoration: underline;
}
.vl-title--h1 {
  font-size: 4.4rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 6rem;
  line-height: 1.18;
}
@media screen and (max-width: 1023px) {
.vl-title--h1 {
    font-size: 4rem;
    margin-bottom: 4.5rem;
}
}
@media screen and (max-width: 767px) {
.vl-title--h1 {
    font-size: 3rem;
    margin-bottom: 3rem;
}
}
.vl-title--h2 {
  font-size: 3.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.24;
}
@media screen and (max-width: 767px) {
.vl-title--h2 {
    font-size: 2.6rem;
    margin-bottom: 1.5rem;
}
}
.vl-title--h3 {
  font-size: 2.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.3;
}
@media screen and (max-width: 767px) {
.vl-title--h3 {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
}
}
.vl-title--h4 {
  font-size: 2.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.8rem;
  line-height: 1.36;
}
@media screen and (max-width: 767px) {
.vl-title--h4 {
    font-size: 2rem;
    margin-bottom: 1.4rem;
}
}
.vl-title--h5 {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-title--h5 {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-title--h6 {
  font-size: 1.8rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.4rem;
  line-height: 1.44;
}
@media screen and (max-width: 767px) {
.vl-title--h6 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
.vl-typography h1 {
  font-size: 4.4rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 6rem;
  line-height: 1.18;
}
@media screen and (max-width: 1023px) {
.vl-typography h1 {
    font-size: 4rem;
    margin-bottom: 4.5rem;
}
}
@media screen and (max-width: 767px) {
.vl-typography h1 {
    font-size: 3rem;
    margin-bottom: 3rem;
}
}
.vl-typography h1:not(:first-child) {
  margin-top: 12rem;
}
.vl-typography h2 {
  font-size: 3.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.24;
}
@media screen and (max-width: 767px) {
.vl-typography h2 {
    font-size: 2.6rem;
    margin-bottom: 1.5rem;
}
}
.vl-typography h2:not(:first-child) {
  margin-top: 4rem;
}
.vl-typography h3 {
  font-size: 2.6rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.3;
}
@media screen and (max-width: 767px) {
.vl-typography h3 {
    font-size: 2.2rem;
    margin-bottom: 1.5rem;
}
}
.vl-typography h3:not(:first-child) {
  margin-top: 4rem;
}
.vl-typography h4 {
  font-size: 2.2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.8rem;
  line-height: 1.36;
}
@media screen and (max-width: 767px) {
.vl-typography h4 {
    font-size: 2rem;
    margin-bottom: 1.4rem;
}
}
.vl-typography h4:not(:first-child) {
  margin-top: 3.6rem;
}
.vl-typography h5 {
  font-size: 2rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.6rem;
  line-height: 1.4;
}
@media screen and (max-width: 767px) {
.vl-typography h5 {
    font-size: 1.8rem;
    margin-bottom: 1.2rem;
}
}
.vl-typography h5:not(:first-child) {
  margin-top: 3.2rem;
}
.vl-typography h6 {
  font-size: 1.8rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  margin-bottom: 1.4rem;
  line-height: 1.44;
}
@media screen and (max-width: 767px) {
.vl-typography h6 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
}
}
.vl-typography h6:not(:first-child) {
  margin-top: 2.8rem;
}
.vl-title-wrapper__title {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper__vl-title {
    margin-bottom: 0;
}
}
.vl-title-wrapper--h1 {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h1 {
    margin-bottom: 3rem;
}
}
.vl-title-wrapper--h2 {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h2 {
    margin-bottom: 1.5rem;
}
}
.vl-title-wrapper--h3 {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h3 {
    margin-bottom: 1.5rem;
}
}
.vl-title-wrapper--h4 {
  margin-bottom: 1.8rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h4 {
    margin-bottom: 1.4rem;
}
}
.vl-title-wrapper--h5 {
  margin-bottom: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h5 {
    margin-bottom: 1.2rem;
}
}
.vl-title-wrapper--h6 {
  margin-bottom: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--h6 {
    margin-bottom: 1rem;
}
}
.vl-title-wrapper--cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3rem;
}
@media screen and (max-width: 767px) {
.vl-title-wrapper--cta__title {
    float: none;
}
}
.vl-title-wrapper--cta__cta--small {
  font-size: 1.4rem;
  margin: 0.8rem 0 0;
}
.vl-title-wrapper--sublink .vl-title,
.vl-title-wrapper--cta .vl-title {
  margin-bottom: 0;
}
.vl-title--no-space-bottom {
  margin-bottom: 0;
}
.vl-toggle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.vl-toggle--align-top {
  align-items: flex-start;
}
.vl-toggle--icon-right {
  flex-direction: row-reverse;
}
.vl-toggle--icon-right .vl-accordion__title {
  flex-grow: 1;
}
.vl-toggle > .vl-vi::before {
  transition: transform 0.2s;
}
.vl-toggle > .vl-vi.vl-vi-arrow-right-fat::before, .vl-toggle > .vl-vi.vl-vi-arrow-right-thin::before {
  transform: rotate(90deg);
}
.js-vl-accordion--open > .vl-toggle .vl-vi-plus::before,
.js-vl-accordion--open > .vl-toggle .vl-vi-minus::before {
  transform: rotate(0);
}
.js-vl-accordion--open > .vl-toggle > .vl-vi-arrow-right-fat::before, .js-vl-accordion--open > .vl-accordion__summary > .vl-toggle > .vl-vi-arrow-right-fat::before, .js-vl-toggle--open > .vl-toggle > .vl-vi-arrow-right-fat::before, [aria-expanded=true] > .vl-toggle > .vl-vi-arrow-right-fat::before,
.js-vl-accordion--open > .vl-toggle > .vl-vi-arrow-right-thin::before,
.js-vl-accordion--open > .vl-accordion__summary > .vl-toggle > .vl-vi-arrow-right-thin::before,
.js-vl-toggle--open > .vl-toggle > .vl-vi-arrow-right-thin::before,
[aria-expanded=true] > .vl-toggle > .vl-vi-arrow-right-thin::before {
  transform: rotate(-90deg);
}
.vl-toggle.js-vl-drawer-active-item .vl-vi-arrow-right-fat::before,
.vl-toggle.js-vl-drawer-active-item .vl-vi-arrow-right-thin::before, .vl-toggle.js-vl-dynamic-drawer-active-item .vl-vi-arrow-right-fat::before,
.vl-toggle.js-vl-dynamic-drawer-active-item .vl-vi-arrow-right-thin::before {
  transform: rotate(-90deg);
}
.js-vl-toggle {
  position: relative;
}
.js-vl-toggle--flex-reverse {
  display: flex;
  flex-direction: column-reverse;
}
summary {
  display: block;
}
summary::-webkit-details-marker {
  display: none;
}
.vl-toggle-wrapper--more-button {
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: margin 0.2s;
}
.js-vl-accordion--open .vl-toggle-wrapper--more-button {
  margin-top: 3rem;
}
.vl-toggle-wrapper--more-button + .vl-accordion__content {
  display: block;
}
.vl-toggle--more-button {
  display: flex;
  align-items: center;
  margin: 0 auto;
  position: relative;
  overflow: visible;
  line-height: 2.3rem;
  width: initial;
}
.vl-toggle--more-button::before, .vl-toggle--more-button::after {
  display: block;
  position: absolute;
  content: "";
  top: 50%;
  margin-top: -1px;
  height: 1px;
  width: 100vw;
  background-color: #cbd2da;
}
.vl-toggle--more-button::before {
  right: calc(100% + 3px);
}
.vl-toggle--more-button::after {
  left: calc(100% + 3px);
}
.vl-toggle--more-button:hover, .vl-toggle--more-button:focus {
  color: #05c;
}
.vl-toggle--more-button .vl-toggle__icon:first-child {
  margin-right: 1rem;
}
.vl-toggle--more-button .vl-toggle__icon:last-child {
  margin-left: 1rem;
}
.vl-toggle--more-button .vl-toggle__icon::before {
  font-size: 1.2rem;
  color: currentColor;
  transition: transform 0.2s;
}
.js-vl-accordion--open .vl-toggle--more-button .vl-toggle__icon::before {
  transform: rotate(-180deg);
}
.vl-typography ul,
.ul {
  list-style-type: disc;
}
.vl-typography ol,
.ol {
  list-style-type: decimal;
}
.vl-typography ol ol,
.vl-typography ol .ol,
.ol ol,
.ol .ol {
  list-style-type: lower-latin;
}
.vl-typography ol,
.ol,
.vl-typography ul,
.ul {
  display: block;
  margin: 1.8rem 0 2rem 1rem;
  padding-left: 2rem;
}
.vl-typography ol:first-child,
.ol:first-child,
.vl-typography ul:first-child,
.ul:first-child {
  margin-top: 0;
}
.vl-typography ol:last-child,
.ol:last-child,
.vl-typography ul:last-child,
.ul:last-child {
  margin-bottom: 0;
}
.vl-typography ol li,
.ol li,
.vl-typography ul li,
.ul li {
  display: list-item;
  margin-bottom: 0.5em;
}
.vl-typography ol li:last-child,
.ol li:last-child,
.vl-typography ul li:last-child,
.ul li:last-child {
  margin-bottom: 0;
}
.vl-typography ol ul,
.ol ul,
.vl-typography ul ul,
.ul ul {
  list-style-type: circle;
}
.vl-typography ol ul,
.vl-typography ol ol,
.ol ul,
.ol ol,
.vl-typography ul ul,
.vl-typography ul ol,
.ul ul,
.ul ol {
  margin: 0.5em 0 0.5rem 1.5em;
}
.vl-typography ol ul:first-child,
.vl-typography ol ol:first-child,
.ol ul:first-child,
.ol ol:first-child,
.vl-typography ul ul:first-child,
.vl-typography ul ol:first-child,
.ul ul:first-child,
.ul ol:first-child {
  margin-top: 0;
}
.vl-typography ol ul:last-child,
.vl-typography ol ol:last-child,
.ol ul:last-child,
.ol ol:last-child,
.vl-typography ul ul:last-child,
.vl-typography ul ol:last-child,
.ul ul:last-child,
.ul ol:last-child {
  margin-bottom: 0;
}
.vl-typography p,
.p {
  margin-bottom: 1.8rem;
}
.vl-typography p:last-child,
.p:last-child {
  margin-bottom: 0;
}
.vl-typography ul li p:last-child,
.vl-typography ul li .p:last-child {
  margin-bottom: 1.8rem;
}
.vl-typography strong,
.vl-typography b {
  font-weight: 500;
}
.vl-typography em,
.vl-typography i {
  font-style: italic;
}
.vl-typography strike,
.vl-typography s {
  text-decoration: line-through;
}
.vl-typography hr {
  display: block;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  border: 0;
  border-top: 1px solid #cbd2da;
}
.vl-typography table {
  width: 100%;
  max-width: 100%;
}
.vl-typography table thead tr {
  border-bottom: 3px #cbd2da solid;
}
.vl-typography table tbody tr {
  border-bottom: 1px #cbd2da solid;
}
.vl-typography table tbody tr[data-vl-table-selectable] {
  transition: background 0.2s ease-in-out;
  cursor: pointer;
}
.vl-typography table tbody tr[data-vl-table-selectable]:hover {
  background: #f3f5f6;
}
.vl-typography table tbody tr.vl-data-table__grouped-row:not(.vl-data-table__grouped-row--last) {
  border-bottom: 0;
}
.vl-typography table td,
.vl-typography table th {
  text-align: left;
  font-size: 1.6rem;
  line-height: 1.3;
  vertical-align: top;
  padding: 1.2rem 1rem;
}
@media screen and (max-width: 767px) {
.vl-typography table td,
  .vl-typography table th {
    padding: 1rem;
}
}
@media screen and (max-width: 767px) {
.vl-typography table td,
  .vl-typography table th {
    font-size: 1.4rem;
}
}
.vl-typography table td:first-child,
.vl-typography table th:first-child {
  border-left: 0;
}
.vl-typography table th {
  font-weight: 500;
}
.vl-typography table .vl-data-table__grouped-row td {
  padding: 0.3rem 1rem 0.3rem 0;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-data-table__grouped-row td {
    padding: 0.3rem 1rem 0.3rem 0;
}
}
.vl-typography table .vl-data-table__grouped-row--first td {
  padding-top: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-data-table__grouped-row--first td {
    padding-top: 1rem;
}
}
.vl-typography table .vl-data-table__grouped-row--last td {
  padding-bottom: 1.2rem;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-data-table__grouped-row--last td {
    padding-bottom: 1rem;
}
}
.vl-typography table__header-title--sortable {
  text-decoration: none;
}
.vl-typography table__header-title--sortable .vl-data-table__header-title__sort-icon {
  opacity: 0;
}
.vl-typography table__header-title--sortable:hover, .vl-typography table__header-title--sortable:focus {
  text-decoration: underline;
}
.vl-typography table__header-title--sortable:hover .vl-data-table__header-title__sort-icon, .vl-typography table__header-title--sortable:focus .vl-data-table__header-title__sort-icon {
  opacity: 0.5;
}
.vl-typography table__header-title--sortable-active .vl-data-table__header-title__sort-icon {
  opacity: 1;
}
.vl-typography table__body-title {
  max-width: 30rem;
}
.vl-typography table--alt tr td:not(:first-child) {
  padding: 1.2rem;
}
.vl-typography table--alt tr th:not(:first-child) {
  padding: 0 1.2rem 1.2rem;
}
.vl-typography table--alt tr th:first-child,
.vl-typography table--alt tr td:first-child {
  border-right: 1px #cbd2da solid;
}
.vl-typography table.vl-data-table--no-header tbody tr:first-child {
  border-top: 3px #cbd2da solid;
}
.vl-typography table .vl-pill {
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
.vl-typography table .vl-pill {
    height: 2rem;
    line-height: 2rem;
    padding: 0 0.5rem;
    font-size: 1.4rem;
}
}
.vl-typography table {
  margin-bottom: 2rem;
}
.vl-typography blockquote {
  position: relative;
  padding-left: 9rem;
  font-size: 3.4rem;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 400;
  margin-bottom: 2rem;
  line-height: 1.5;
}
@media screen and (max-width: 767px) {
.vl-typography blockquote {
    padding-left: 5rem;
}
}
.vl-typography blockquote::before {
  position: absolute;
  content: "“";
  font-size: 9rem;
  left: 0;
  top: 0;
  padding-top: 1rem;
  padding-left: 1rem;
  width: 7rem;
  height: 6rem;
  line-height: 1;
  color: #333332;
  background: linear-gradient(-110deg, transparent 20px, var(--vl-theme-primary-color) 20px);
}
@media screen and (max-width: 767px) {
.vl-typography blockquote::before {
    width: 4.6rem;
    font-size: 6rem;
    height: 3.6rem;
    padding-right: 1.5rem;
    padding-top: 0.5rem;
    padding-left: 0.5rem;
    margin-right: 0rem;
}
}
.vl-typography pre:not([class*=language]) {
  padding: 1.5rem;
  background-color: #333332;
  color: #fff;
  display: block;
  white-space: pre;
  overflow-x: scroll;
  -moz-tab-size: 2;
    -o-tab-size: 2;
       tab-size: 2;
  word-break: normal;
  hyphens: none;
}
.vl-typography pre:not([class*=language]) code,
.vl-typography pre:not([class*=language]) kdb,
.vl-typography pre:not([class*=language]) samp {
  background-color: transparent;
  padding: 0;
}
.vl-typography code,
.vl-typography kdb,
.vl-typography samp {
  font-family: monospace;
  background: #e8ebee;
  padding: 0.2rem;
}
.vl-typography a,
.vl-typography .vl-link,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon,
.vl-typography .vl-sidebar-header__toggle {
  display: inline;
  text-decoration: underline;
}
.vl-typography a:hover,
.vl-typography .vl-link:hover,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon:hover,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon:hover,
.vl-typography .vl-sidebar-header__toggle:hover {
  text-decoration: none;
}
.vl-typography a:focus, .vl-typography a:active,
.vl-typography .vl-link:focus,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon:focus,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon:focus,
.vl-typography .vl-sidebar-header__toggle:focus,
.vl-typography .vl-link:active,
.vl-typography .vl-sidebar-panel-list-item__button .vl-icon:active,
.vl-sidebar-panel-list-item__button .vl-typography .vl-icon:active,
.vl-typography .vl-sidebar-header__toggle:active {
  text-decoration: none;
}
.vl-typography--prewrapped {
  white-space: pre-wrap;
}
.vl-upload {
  position: relative;
  margin-bottom: 1rem;
  transition: background-color 0.3s ease-out;
}
.vl-upload--basic .vl-upload__element__input {
  width: 100%;
  height: auto;
  margin: 0;
  opacity: 1;
  pointer-events: auto;
  position: relative;
  overflow: auto;
}
.vl-upload--error .vl-upload__element, .vl-upload--error .vl-upload__element:hover {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-upload--error .vl-upload__element .vl-upload__element__label:hover, .vl-upload--error .vl-upload__element:hover .vl-upload__element__label:hover {
  background-color: transparent;
}
.vl-upload--success .vl-upload__element, .vl-upload--success .vl-upload__element:hover {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-upload--success .vl-upload__element .vl-upload__element__label:hover, .vl-upload--success .vl-upload__element:hover .vl-upload__element__label:hover {
  background-color: transparent;
}
.vl-upload--disabled .vl-upload__element {
  background-color: #cbd2d9;
}
.vl-upload--disabled .vl-upload__element:hover, .vl-upload--disabled .vl-upload__element:focus {
  background-color: #cbd2d9;
  border: 0.1rem dashed #8695a8;
}
.vl-upload--disabled .vl-upload__element:hover .vl-upload__element__label, .vl-upload--disabled .vl-upload__element:focus .vl-upload__element__label {
  background-color: transparent;
  padding: 1rem;
}
.vl-upload--disabled .vl-upload__element .vl-upload__element__label {
  cursor: not-allowed;
}
.vl-upload--disabled .vl-upload__element .vl-upload__element__label .vl-upload__element__button {
  color: #687483;
  text-decoration: none;
  cursor: not-allowed;
}
.vl-upload__overlay {
  position: absolute;
  display: none;
  pointer-events: none;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 0.1rem dashed #05c;
  z-index: 10;
  opacity: 0.9;
  font-family: "Flanders Art Sans", sans-serif;
}
.vl-upload__overlay__text {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 1.4rem;
}
.vl-upload__overlay__text .vl-vi {
  font-size: 2rem;
  display: block;
  color: #05c;
}
.vl-upload__files::before, .vl-upload__files::after {
  content: "";
  display: table;
}
.vl-upload__files::after {
  clear: both;
}
.vl-upload__files {
  margin-bottom: 2rem;
  display: none;
  position: relative;
}
.vl-upload__files--has-files {
  display: block;
}
.vl-upload__files__close {
  margin: 1rem 0 0;
  float: right;
}
.vl-upload__files__close .vl-vi {
  margin-right: 0.5rem;
}
@media screen and (max-width: 767px) {
.vl-upload__files__close {
    float: none;
}
}
.vl-upload__file {
  position: relative;
  margin-bottom: 0.2rem;
  padding: 1rem 1.5rem;
  z-index: 5;
  font-family: "Flanders Art Sans", sans-serif;
  border: 0;
}
.vl-upload__file:last-child {
  border-bottom: 0;
}
.vl-upload__file:hover {
  background-color: rgba(179, 207, 245, 0.3);
}
.vl-upload__file__size {
  color: #687483;
}
.vl-upload__file__name {
  color: #333332;
  max-width: calc(100% - 2rem);
  word-break: break-all;
}
@supports (overflow-wrap: break-word) {
.vl-upload__file__name {
    overflow-wrap: break-word;
    word-break: normal;
}
}
.vl-upload__file__name__icon {
  display: inline-block;
  transform: translateY(-1px);
  line-height: 2rem;
  padding-right: 1rem;
  color: #687483;
}
.vl-upload__file__close {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding: 1rem;
  margin-right: 1rem;
  color: #05c;
  box-shadow: none;
  overflow: hidden;
}
.vl-upload__file__close .vl-vi {
  height: 1.1rem;
  width: 1.1rem;
  font-size: 1.6rem;
}
@media screen and (max-width: 1023px) {
.vl-upload__file__close .vl-vi {
    font-size: 1.4rem;
}
}
.vl-upload__file__close:hover {
  box-shadow: none;
}
.vl-upload__file__close:focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-upload__file.dz-error, .vl-upload__file--error {
  border: 0.1rem solid #edafb1;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
  padding-left: 6.5rem;
}
@media screen and (max-width: 767px) {
.vl-upload__file.dz-error, .vl-upload__file--error {
    padding-left: 5rem;
}
}
.vl-upload__file.dz-error::before, .vl-upload__file--error::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  position: absolute;
  display: inline-flex;
  top: 50%;
  left: 2rem;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
}
@media screen and (max-width: 767px) {
.vl-upload__file.dz-error::before, .vl-upload__file--error::before {
    left: 1.5rem;
    width: 18px;
    height: 18px;
}
}
.vl-upload__file.dz-error .vl-upload__file__name, .vl-upload__file--error .vl-upload__file__name {
  font-weight: 500;
}
.vl-upload__file.dz-error .vl-upload__file__error,
.vl-upload__file.dz-error .dz-error-message, .vl-upload__file--error .vl-upload__file__error,
.vl-upload__file--error .dz-error-message {
  font-size: 0.9em;
}
.vl-upload__file.dz-error .vl-upload__file__name__icon, .vl-upload__file--error .vl-upload__file__name__icon {
  display: none;
}
.vl-upload__file.dz-error .vl-upload__file__close, .vl-upload__file--error .vl-upload__file__close {
  cursor: pointer;
}
.vl-upload__file.dz-error .vl-upload__file__close .vl-vi, .vl-upload__file--error .vl-upload__file__close .vl-vi {
  color: #333332;
}
.vl-upload__file.dz-error .vl-upload__file__close:focus, .vl-upload__file--error .vl-upload__file__close:focus {
  box-shadow: 0 0 0 2px rgb(98.2352941176%, 92.1568627451%, 92.3529411765%), 0 0 0 5px rgba(0, 85, 204, 0.65);
}
.vl-upload__file.dz-error.vl-upload__file--error-size .vl-upload__file__size, .vl-upload__file--error.vl-upload__file--error-size .vl-upload__file__size {
  color: #333332;
}
.vl-upload__file.dz-error:hover, .vl-upload__file--error:hover {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-upload.upload--dragging .vl-upload__overlay {
  opacity: 1;
  display: block;
}
.vl-upload.upload--dragging .vl-upload__element {
  min-height: 8.75rem;
}
.vl-upload__element {
  font-family: "Flanders Art Sans", sans-serif;
  border: 0.1rem dashed #8695a8;
  border-radius: 0.3rem;
  text-align: center;
  position: relative;
  z-index: 4;
  min-height: 100%;
}
.vl-upload__element:hover {
  border-width: 0.2rem;
  border-color: rgba(0, 85, 204, 0.65);
}
.vl-upload__element:hover .vl-upload__element__label {
  background-color: rgba(179, 207, 245, 0.3);
  padding: 0.9rem;
}
.vl-upload__element__input {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 1rem;
  overflow: hidden;
}
.vl-upload__element__input:focus {
  outline: none;
}
.vl-upload__element__input:focus + label {
  background-color: rgba(179, 207, 245, 0.3);
}
.vl-upload__element__label {
  color: #05c;
  display: block;
  padding: 1rem;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s ease-out;
  height: 100%;
}
.vl-upload__element__label .vl-vi {
  display: inline-block;
  font-size: 1.4rem;
  margin-right: 0.5rem;
  line-height: 2.4rem;
  top: 1px;
}
.vl-upload__element__label small {
  font-size: 1.4rem;
  color: #687483;
  display: none;
  text-decoration: none;
  text-align: center;
  line-height: 1.5;
  margin-top: 0.5rem;
}
.vl-upload .vl-upload__element__label small {
  display: block;
}
.vl-upload .vl-upload__element__label__error {
  color: #d2373c;
  font-size: 0.9em;
}
.vl-upload--dragging .vl-upload__overlay {
  opacity: 1;
  display: block;
}
.no-js .vl-upload__element__label {
  display: none;
}
.dz-image-preview {
  overflow: hidden;
}
.vl-upload__element__button {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  color: inherit;
  font-size: inherit;
  line-height: 2.4rem;
}
.vl-upload--dragging [data-vl-upload-full-body-drop] {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 100vh;
  z-index: 10006;
  margin: 0;
}
.dropzone .dz-message .dz-button {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  width: 100%;
  font-size: inherit;
}
.dropzone .dz-message .dz-button:focus::after {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(179, 207, 245, 0.3);
  content: "";
}
.js-vl-autocomplete {
  position: relative;
}
.js-vl-autocomplete input,
.js-vl-autocomplete select {
  position: relative;
  z-index: 2;
}
.js-vl-autocomplete .vl-autocomplete {
  position: absolute;
  z-index: 3;
  top: calc(100% + 0.7rem);
  right: 0;
  left: 0;
  background: #fff;
  border: 0.1rem solid #8695a8;
  border-radius: 0.3rem;
}
.js-vl-autocomplete .vl-autocomplete[data-vl-position=up] {
  top: auto;
  bottom: calc(100% + 0.7rem);
}
.no-js .js-vl-autocomplete .vl-autocomplete, .js-vl-autocomplete .vl-autocomplete[data-vl-show=false] {
  display: none !important;
}
.js-vl-autocomplete .vl-autocomplete__list-wrapper {
  max-height: 35vh;
  overflow: auto;
}
.js-vl-autocomplete .vl-autocomplete__cta {
  display: block;
  padding: 1rem;
  transition: background 0.1s ease-in-out;
  border-top: 1px #cbd2da solid;
  text-decoration: none;
}
.js-vl-autocomplete .vl-autocomplete__cta:hover, .js-vl-autocomplete .vl-autocomplete__cta:focus, .js-vl-autocomplete .vl-autocomplete__cta.vl-autocomplete__cta--focus {
  background: rgba(179, 207, 245, 0.3);
}
.js-vl-autocomplete .vl-autocomplete__cta:focus, .js-vl-autocomplete .vl-autocomplete__cta.vl-autocomplete__cta--focus {
  outline: 0;
}
.js-vl-autocomplete .vl-autocomplete__cta__sub {
  display: block;
  color: #687483;
  font-size: 1.4rem;
}
.js-vl-autocomplete .vl-autocomplete__cta__title {
  display: block;
  color: #333332;
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location::before, .js-vl-autocomplete .vl-autocomplete__cta__title--location::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location::before {
  content: "\\f1fb";
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location {
  color: #05c;
  text-decoration: underline;
}
.js-vl-autocomplete .vl-autocomplete__cta__title--location::before {
  display: inline-block;
  margin: 0 1rem 0 0.3rem;
  transform: scale(1.5);
  color: #333332;
  font-size: 0.7em;
  vertical-align: middle;
}
.js-vl-autocomplete .vl-autocomplete__item:first-child .vl-autocomplete__cta {
  border: 0;
}
.js-vl-autocomplete .vl-autocomplete__alert {
  display: block;
  padding: 1rem;
  font-weight: 400;
  text-decoration: none;
}
.js-vl-autocomplete .vl-autocomplete__alert__title {
  display: block;
  line-height: 1.2;
}
.js-vl-autocomplete .vl-autocomplete__alert__subtitle {
  display: block;
  color: #687483;
  font-size: 1.4rem;
}
.js-vl-autocomplete .vl-autocomplete__loader {
  position: absolute;
  top: 0;
  right: 0;
  width: 5rem;
  height: 3.5rem;
  z-index: 2;
}
.js-vl-autocomplete .vl-autocomplete__loader::before {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  margin-top: -2px;
  margin-left: -22px;
  border-radius: 50%;
  box-shadow: 10px -0px #cbd2da, 20px -0px #cbd2da, 30px 0px #cbd2da;
  content: "";
  animation: "waving-dark" infinite 1s linear;
}
@keyframes waving-dark {
0% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px 0px #687483;
}
10% {
    box-shadow: 10px -3px #687483, 20px -0px #687483, 30px -0px #687483;
}
20% {
    box-shadow: 10px -6px #687483, 20px -3px #687483, 30px -0px #687483;
}
30% {
    box-shadow: 10px -3px #687483, 20px -6px #687483, 30px -3px #687483;
}
40% {
    box-shadow: 10px -0px #687483, 20px -3px #687483, 30px -6px #687483;
}
50% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -3px #687483;
}
60% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
100% {
    box-shadow: 10px -0px #687483, 20px -0px #687483, 30px -0px #687483;
}
}
.js-vl-autocomplete .vl-autocomplete__loader[data-vl-show=false] {
  display: none;
}
.vl-progress-bar {
  display: table;
  table-layout: fixed;
  width: 100%;
  height: 2.2rem;
  margin-bottom: 2.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar {
    height: 1.8rem;
    margin-bottom: 0px;
}
}
.vl-progress-bar__step {
  position: relative;
  display: table-cell;
}
.vl-progress-bar__step::before {
  display: block;
  position: absolute;
  background-color: #8695a8;
  content: "";
  height: 0.3rem;
  top: 50%;
  right: 2.3rem;
  left: 0.2rem;
  transform: translate(0%, -50%);
}
@media screen and (max-width: 767px) {
.vl-progress-bar__step::before {
    right: 1.9rem;
}
}
.vl-progress-bar__step--active::before {
  background: #8695a8;
  right: 2.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar__step--active::before {
    right: 2.3rem;
}
}
.vl-progress-bar__step--active .vl-progress-bar__bullet {
  background-color: #8695a8;
  border-color: #8695a8;
  width: 2.2rem;
  height: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar__step--active .vl-progress-bar__bullet {
    width: 1.8rem;
    height: 1.8rem;
}
}
.vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet, .vl-progress-bar__step--active ~ .vl-progress-bar__step::before {
  background-color: #cfd5dd;
  border-color: #cfd5dd;
}
.vl-region--alt .vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet, .vl-region--alt .vl-progress-bar__step--active ~ .vl-progress-bar__step::before {
  background-color: #cfd5dd;
}
.vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet::after {
  color: #687483;
}
.vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet__text {
  color: #687483;
}
.vl-progress-bar__step:last-child .vl-progress-bar__bullet__text {
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-progress-bar__bullet {
  position: absolute;
  background-color: #8695a8;
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  top: 50%;
  right: 0.2rem;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-style: solid;
  border-color: #8695a8;
  padding: 0;
  transform: translate(0%, -50%);
}
@media screen and (max-width: 767px) {
.vl-progress-bar__bullet {
    width: 1.4rem;
    height: 1.4rem;
}
}
.vl-progress-bar__bullet::after {
  color: #333332;
}
.vl-progress-bar__bullet__text {
  position: absolute;
  transform: translate(-50%, 1.6rem);
  font-size: 1.6rem;
  white-space: nowrap;
}
.vl-progress-bar a .vl-progress-bar__bullet:hover::after {
  color: #003bb0;
}
.vl-progress-bar--numeric {
  counter-reset: progressbar-counter;
  height: 4.2rem;
  margin-bottom: 2.6rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric {
    height: 3.5rem;
    margin-bottom: 0px;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step::before {
  right: 3.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step::before {
    right: 3rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet {
  width: 3.2rem;
  height: 3.2rem;
  text-decoration: none;
  background-color: var(--vl-theme-primary-color);
  border-color: var(--vl-theme-primary-color);
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet {
    width: 2.5rem;
    height: 2.5rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet::after {
  position: absolute;
  content: counter(progressbar-counter);
  counter-increment: progressbar-counter;
  font-family: "Flanders Art Serif", serif;
  font-size: 1.8rem;
  font-weight: 500;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet::after {
    font-size: 1.4rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step .vl-progress-bar__bullet__text {
  transform: translate(-50%, 2.6rem);
}
.vl-progress-bar--numeric .vl-progress-bar__step--active::before {
  right: 4.7rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step--active::before {
    right: 4rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet {
  width: 4.2rem;
  height: 4.2rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet {
    width: 3.5rem;
    height: 3.5rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet::after {
  font-size: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-progress-bar--numeric .vl-progress-bar__step--active .vl-progress-bar__bullet::after {
    font-size: 1.8rem;
}
}
.vl-progress-bar--numeric .vl-progress-bar__step--active ~ .vl-progress-bar__step .vl-progress-bar__bullet, .vl-progress-bar--numeric .vl-progress-bar__step--active ~ .vl-progress-bar__step::before {
  background-color: #cfd5dd;
  border-color: #cfd5dd;
}
.vl-tooltip {
  max-width: 27rem;
  background: #fff;
  border: 1px #cfd5dd solid;
  text-align: center;
  font-size: 1.6rem;
  line-height: 1.25;
  font-weight: 400;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  padding: 0.3rem 1rem;
  z-index: 10009;
  position: relative;
  box-shadow: 0 0 2rem 0 rgba(51, 51, 50, 0.15);
}
.vl-tooltip::before {
  content: "";
  position: absolute;
  top: -0.9rem;
  right: -0.9rem;
  bottom: -0.9rem;
  left: -0.9rem;
  z-index: 0;
}
.vl-tooltip--static {
  display: block;
  pointer-events: auto;
}
.vl-tooltip--static[x-placement^=top], .vl-tooltip--static[data-popper-placement^=top] {
  transform: translate(-50%, -100%);
  margin-left: 50%;
}
.vl-tooltip--static[x-placement^=left], .vl-tooltip--static[data-popper-placement^=left] {
  transform: translate(-100%, 0%);
}
.vl-tooltip--static[x-placement^=bottom], .vl-tooltip--static[data-popper-placement^=bottom] {
  transform: translate(-50%, 0%);
  margin-left: 50%;
  top: 100%;
}
.vl-tooltip--static[x-placement^=right], .vl-tooltip--static[data-popper-placement^=right] {
  margin-left: calc(100% + 10px);
}
.vl-tooltip .tooltip__inner {
  position: relative;
  z-index: 1;
}
.vl-tooltip.vl-tooltip--large {
  font-weight: 400;
  font-size: 1.4rem;
  padding: 2rem 3.2rem 2rem 2rem;
}
.vl-tooltip.vl-tooltip--large .tooltip__inner {
  text-align: left;
}
.vl-tooltip__title {
  margin: 0 0 0.5rem;
  border-bottom: 1px solid rgb(74.1520803443%, 77.3830703013%, 81.6910569106%);
  font-size: 1.6rem;
}
.vl-tooltip__close {
  margin: 5px;
  padding: 3px;
  position: absolute;
  right: 0px;
  top: 0px;
  border: 0;
  font-size: 1.6rem;
}
.vl-tooltip__close:hover {
  color: #05c;
}
.vl-tooltip__close:focus {
  color: rgb(0%, 25%, 60%);
}
@media screen and (max-width: 767px) {
.vl-tooltip__close {
    font-size: 1.4rem;
}
}
.vl-tooltip[x-placement^=top] .vl-tooltip__arrow, .vl-tooltip[data-popper-placement^=top] .vl-tooltip__arrow {
  left: 50%;
  margin-left: -0.6rem;
  border-bottom-width: 0;
  border-top-color: #cfd5dd;
  bottom: -0.6rem;
}
.vl-tooltip[x-placement^=top] .vl-tooltip__arrow::after, .vl-tooltip[data-popper-placement^=top] .vl-tooltip__arrow::after {
  content: " ";
  bottom: 1px;
  margin-left: -0.5rem;
  border-bottom-width: 0;
  border-top-color: #fff;
}
.vl-tooltip[x-placement^=right] .vl-tooltip__arrow, .vl-tooltip[data-popper-placement^=right] .vl-tooltip__arrow {
  top: 50%;
  left: -0.6rem;
  margin-top: -0.6rem;
  border-left-width: 0;
  border-right-color: #cfd5dd;
}
.vl-tooltip[x-placement^=right] .vl-tooltip__arrow::after, .vl-tooltip[data-popper-placement^=right] .vl-tooltip__arrow::after {
  content: " ";
  left: 1px;
  bottom: -0.5rem;
  border-left-width: 0;
  border-right-color: #fff;
}
.vl-tooltip[x-placement^=bottom] .vl-tooltip__arrow, .vl-tooltip[data-popper-placement^=bottom] .vl-tooltip__arrow {
  left: 50%;
  margin-left: -0.6rem;
  border-top-width: 0;
  border-bottom-color: #cfd5dd;
  top: -0.6rem;
}
.vl-tooltip[x-placement^=bottom] .vl-tooltip__arrow::after, .vl-tooltip[data-popper-placement^=bottom] .vl-tooltip__arrow::after {
  content: " ";
  top: 1px;
  margin-left: -0.5rem;
  border-top-width: 0;
  border-bottom-color: #fff;
}
.vl-tooltip[x-placement^=left] .vl-tooltip__arrow, .vl-tooltip[data-popper-placement^=left] .vl-tooltip__arrow {
  top: 50%;
  right: -0.6rem;
  margin-top: -0.6rem;
  border-right-width: 0;
  border-left-color: #cfd5dd;
}
.vl-tooltip[x-placement^=left] .vl-tooltip__arrow::after, .vl-tooltip[data-popper-placement^=left] .vl-tooltip__arrow::after {
  content: " ";
  right: 1px;
  border-right-width: 0;
  border-left-color: #fff;
  bottom: -0.5rem;
}
.vl-tooltip__arrow {
  border-width: 0.6rem;
}
.vl-tooltip__arrow, .vl-tooltip__arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 0.5rem;
  content: "";
}
.vl-side-navigation {
  max-height: 90vh;
  overflow: auto;
  padding: 5px;
  padding-left: 12px;
}
@media screen and (min-width: 767px) {
.vl-side-navigation::-webkit-scrollbar {
    width: 16px;
    height: 20px;
}
.vl-side-navigation::-webkit-scrollbar-thumb {
    height: 8px;
    border: 6px solid rgba(0, 0, 0, 0);
    border-radius: 7px;
    background-clip: padding-box;
    background-color: #e8ebee;
}
.vl-side-navigation::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
}
.vl-side-navigation::-webkit-scrollbar-corner {
    background-color: transparent;
}
}
@media screen and (max-width: 767px) {
.vl-side-navigation {
    display: none;
    min-height: 10rem;
    max-height: calc(100vh - 15rem);
    padding: 1.5rem 1rem 1.5rem 1.5rem;
    background: #fff;
    box-shadow: 0 0 2.1rem rgba(0, 0, 0, 0.3);
    animation: fade-transition 0.3s;
}
}
.vl-side-navigation a {
  text-decoration: none;
}
.vl-side-navigation a:hover, .vl-side-navigation a:focus {
  text-decoration: underline;
}
.js-vl-scrollspy-mobile--active .vl-side-navigation {
  display: block !important;
}
.vl-side-navigation .js-vl-scrollspy-active {
  color: #333332;
  position: relative;
}
.vl-side-navigation .js-vl-scrollspy-active::before {
  content: "";
  height: 90%;
  display: block;
  position: absolute;
  left: -12px;
  top: 1px;
  bottom: 0;
  width: 3px;
  background-color: #5990de;
}
@media screen and (min-width: 767px) {
.vl-side-navigation[data-vl-side-navigation-scrollable] {
    max-height: none;
}
}
.vl-side-navigation__content {
  font-size: 1.6rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__content {
    font-size: 1.6rem;
}
}
.vl-side-navigation__group {
  margin-bottom: 2rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__group {
    padding: 0;
    border: 0 !important;
}
}
.vl-side-navigation__group:last-child {
  margin-bottom: 0;
}
.vl-side-navigation__group--has-title {
  padding-top: 3rem;
  border-top-width: 3px;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__group--has-title {
    padding-top: 1.5rem;
}
}
.vl-side-navigation__title {
  margin-bottom: 20px;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #687483;
  font-weight: 500;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item {
    padding: 0;
    font-size: 1.4rem;
}
}
.vl-side-navigation__group--spaced .vl-side-navigation__item:not(:last-child) {
  margin-bottom: 1.5rem;
}
.vl-side-navigation__group--has-title .vl-side-navigation__item + .vl-side-navigation__item {
  margin-top: 0.5rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item > a {
    display: block;
    margin: 0.7rem 0 1.4rem;
}
}
.vl-side-navigation__item a {
  font-weight: 500;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item:last-child > a {
    margin-bottom: 0.7rem;
}
}
.vl-side-navigation__item > ul {
  display: none;
  padding: 0 0 0.15rem 2rem;
}
@media screen and (max-width: 767px) {
.vl-side-navigation__item > ul {
    padding: 0 1rem 0.15rem 1.3rem;
}
}
.vl-side-navigation__item > ul.vl-side-navigation__subgroup--active {
  display: block;
}
.vl-side-navigation__toggle {
  display: block;
  position: relative;
  font-weight: 500;
  box-shadow: none;
  margin: 13px 0;
}
.vl-side-navigation__toggle[aria-expanded=true] .vl-vi::before {
  transform: rotate(90deg);
}
.vl-side-navigation__toggle[aria-expanded=true] + ul {
  display: block;
  animation: side-navigation-transition 0.3s;
}
.vl-side-navigation__toggle[aria-expanded=true] + ul .vl-side-navigation__toggle:first-child {
  margin-top: 0;
}
.vl-side-navigation__toggle .vl-vi {
  font-size: 1.6rem;
  position: absolute;
  top: 50%;
  right: 0.4rem;
  transform: translateY(-50%);
}
.vl-side-navigation__toggle .vl-vi::before {
  transition: transform 0.1s ease-in-out;
}
@keyframes side-navigation-transition {
0% {
    display: none;
    transform: translateX(-10px);
}
1% {
    display: block;
    transform: translateX(-10px);
}
100% {
    display: block;
    transform: translateX(0);
    opacity: 1;
}
}
.js-vl-scrollspy__content {
  border-radius: 5rem;
}
@media screen and (max-width: 767px) {
.js-vl-scrollspy__content {
    position: relative;
    padding: 4rem 0 0;
}
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle::before, .js-vl-scrollspy__content .js-vl-scrollspy__toggle::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle::before {
  content: "\\f13e";
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle {
  display: none;
  cursor: pointer;
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle::before {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1.1rem;
}
@media screen and (max-width: 767px) {
.js-vl-scrollspy__content .js-vl-scrollspy__toggle {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle.js-vl-scrollspy__toggle--fixed {
  position: fixed;
  top: auto;
  right: auto;
  bottom: 4rem;
  left: calc(100% - 6rem);
  height: 5rem;
  border-radius: 5rem;
  font-size: 0;
  z-index: 3;
}
.js-vl-scrollspy__content .js-vl-scrollspy__toggle.js-vl-scrollspy__toggle--fixed::before {
  right: auto;
  left: 2rem;
  line-height: 2.7rem;
}
.js-vl-scrollspy-placeholder {
  display: none;
  position: fixed;
  top: auto;
  bottom: 1.5rem;
  left: 1.5rem;
  width: calc(100% - 3rem);
  outline: none;
  z-index: 4;
}
@media screen and (max-width: 767px) {
.js-vl-scrollspy-placeholder {
    height: auto;
}
}
.js-vl-scrollspy-placeholder.js-vl-scrollspy-mobile--active {
  display: block;
}
.js-vl-scrollspy__close::before, .js-vl-scrollspy__close::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.js-vl-scrollspy__close::before {
  content: "\\f17f";
}
.js-vl-scrollspy__close {
  position: absolute;
  top: -1.8rem;
  right: 0;
  left: 0;
  width: 3rem;
  height: 3rem;
  margin: auto;
  border: 0;
  border-radius: 3rem;
  background-color: #05c;
  color: #fff;
  font-size: 0;
  cursor: pointer;
  z-index: 5;
}
.js-vl-scrollspy__close::before {
  font-size: 1.2rem;
  line-height: 2.6rem;
}
.js-vl-scrollspy__close:focus {
  outline: thin dotted;
}
.js-vl-sticky {
  position: relative;
  transform: translate3d(0, 0, 0);
  will-change: position, transform;
  z-index: 2;
}
.js-vl-sticky--viewport-top, .js-vl-sticky--viewport-bottom {
  position: fixed;
}
.js-vl-sticky--container-bottom, .js-vl-sticky--viewport-unbottom {
  position: relative;
}
.js-vl-sticky--placeholder {
  position: relative;
  width: 100%;
  will-change: min-height;
}
.vl-toaster {
  position: fixed;
  width: 30rem;
  z-index: 10012;
  top: 0;
  right: 0;
}
.vl-toaster[class*=left] {
  right: auto;
  left: 0;
}
.vl-toaster[class*=bottom] {
  top: auto;
  bottom: 0;
}
.vl-toaster--fade {
  opacity: 0 !important;
}
.vl-toaster .vl-alert {
  opacity: 1;
  transition: opacity 0.3s;
  margin: 1rem;
}
.vl-toaster .vl-alert--fade-out {
  opacity: 0;
}
.vl-sidebar {
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 426.6666666667px;
  transition: margin 0.2s ease-out;
  background-color: #fff;
  flex: 1;
  z-index: 100;
}
@media screen and (max-width: 767px) {
.vl-sidebar {
    max-width: 50%;
}
}
.vl-sidebar--collapsible {
  margin-left: -426.6666666667px;
  min-height: 3.5rem;
}
@media screen and (max-width: 767px) {
.vl-sidebar--collapsible {
    margin-left: -50%;
}
}
.vl-sidebar--collapsible.vl-sidebar--opened {
  margin-left: 0;
}
@media screen and (max-width: 500px) {
.vl-sidebar--collapsible.vl-sidebar--opened {
    position: fixed !important;
}
}
.vl-sidebar--collapsible:not(.vl-sidebar--opened) .vl-sidebar__container {
  display: none;
}
.vl-sidebar--collapsible.vl-sidebar--right {
  margin-left: 0;
  margin-right: -426.6666666667px;
}
@media screen and (max-width: 767px) {
.vl-sidebar--collapsible.vl-sidebar--right {
    margin-right: -50%;
}
}
.vl-sidebar--collapsible.vl-sidebar--right.vl-sidebar--opened {
  margin-right: 0;
}
@media screen and (max-width: 767px) {
.vl-sidebar--collapsible {
    min-height: 3.5rem;
}
.vl-sidebar--collapsible.vl-sidebar--opened {
    margin-left: -50%;
    z-index: 10009;
}
.vl-sidebar--collapsible.vl-sidebar--opened.vl-sidebar--right {
    margin-right: -50%;
}
.vl-sidebar--collapsible.vl-sidebar--opened .vl-sidebar__container {
    display: block;
    opacity: 0;
    animation: slideIn 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
    overflow: initial;
}
.vl-sidebar--collapsible.vl-sidebar--opened .vl-sidebar__toggle {
    display: none;
}
.vl-sidebar--collapsible.vl-sidebar--closing .vl-sidebar__container {
    will-change: transform;
    display: block;
    animation: slideOut 0.5s cubic-bezier(1, 0.1, 0, 0.9);
    animation-fill-mode: forwards;
}
.vl-sidebar--collapsible .vl-sidebar__container {
    width: 100%;
    max-width: 100%;
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    top: auto;
    display: none;
    z-index: 10009;
    transform: translateY(120%);
    height: auto;
    max-height: 85vh;
    background: #fff;
    display: block;
}
}
.vl-sidebar--flyout {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}
.vl-sidebar--flyout.vl-sidebar--right {
  left: auto;
  right: 0;
}
.vl-sidebar__container {
  height: 100%;
  max-height: 100%;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
}
.vl-sidebar__toggle {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: block;
  width: 3.5rem;
  height: 3.5rem;
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  font-size: 16px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.vl-sidebar__toggle:hover {
  background: #f7f9fc;
  color: #333332;
}
.vl-sidebar__toggle--active {
  background-color: #05c;
  color: #fff;
}
.vl-sidebar__toggle--active:hover {
  background: #003bb0;
  color: #fff;
}
.vl-sidebar__toggle--disabled {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-sidebar__toggle--disabled:hover {
  background-color: #cbd2d9;
  color: var(--vl-theme-fg-color-70);
}
.vl-sidebar__toggle {
  box-shadow: 0px 2px 12px rgba(106, 118, 134, 0.35);
  border-radius: 0px 0.3rem 0.3rem 0px;
  color: #05c;
  background-color: #fff;
  border: none;
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%) translateX(-2px);
  z-index: -1;
  font-size: 18px;
}
.vl-sidebar--right .vl-sidebar__toggle {
  left: auto;
  right: 100%;
  transform: translateY(-50%) translateX(2px);
}
.vl-sidebar__wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  z-index: 101;
  overflow: auto;
  background-color: #fff;
}
.vl-sidebar__close-btn {
  display: none;
  position: absolute;
  right: 0.5rem;
  top: 0;
  font-size: 1.4rem;
}
@media screen and (max-width: 767px) {
.vl-sidebar__close-btn {
    display: inline-flex;
    top: -4.5rem;
}
}
.vl-sidebar-content {
  flex-grow: 1;
  overflow: auto;
  padding: 1.8rem 1.5rem;
}
.vl-sidebar-content--container {
  padding: 0;
  overflow: hidden;
  max-width: 100%;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-sidebar-content {
    max-height: 65vh;
}
}
.vl-sidebar-content .vl-sidebar__image-container .vl-image--full-width {
  margin-left: -1.5rem;
  width: calc(100% + 1.5rem * 2);
  max-width: calc(100% + 1.5rem * 2);
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
}
.vl-sidebar-content > .vl-sidebar-accordion-list > .vl-sidebar-accordion-list-item > .vl-accordion__wrapper > .vl-accordion > .vl-accordion__summary {
  background: #f7f9fc;
}
.vl-sidebar-panel {
  padding: 1.8rem 1.5rem;
}
.vl-sidebar-panel-list {
  width: 100%;
  max-height: 100%;
  padding: 8px 0;
}
.vl-sidebar-panel-list--sub {
  padding: 0;
  transform: translateX(20px);
  opacity: 0;
  transition: transform 0.35s ease-in-out, opacity 0.25s linear 0.1s;
  pointer-events: none;
}
.vl-sidebar-panel-list-item {
  display: flex;
  flex-direction: column;
}
.vl-sidebar-panel-list-item--has-children {
  display: block;
}
.vl-sidebar-panel-list-item--full {
  height: 100%;
}
.vl-sidebar-panel-list-item--active .vl-sidebar-panel-list--sub {
  pointer-events: all;
  visibility: visible;
  opacity: 1;
  transform: translateX(0);
  transition: transform 0.35s ease-in-out, opacity 0.25s linear 0.1s;
}
.vl-sidebar-panel-list-item:last-child {
  border-bottom: 0;
}
.vl-sidebar-panel-list-item__header {
  display: flex;
  padding: 1.8rem 1.5rem;
  border-bottom: 1px solid #cbd2da;
  margin-bottom: 8px;
  align-items: center;
}
.vl-sidebar-panel-list-item__header__title {
  font-size: 16px;
}
.vl-sidebar-panel-list-item__image-container .vl-image--full-width {
  width: 100%;
  max-width: 100%;
  margin-top: -8px;
  margin-bottom: 8px;
}
.vl-sidebar-panel-list-item__content {
  padding: 0 1.5rem;
}
.vl-sidebar-panel-list-item__footer {
  padding: 1.8rem 1.5rem;
  border-top: 1px solid #cbd2da;
  margin-top: 1.5rem;
}
.vl-sidebar-footer {
  display: flex;
  padding: 1.5rem;
  border-top: 1px solid #cbd2da;
  min-height: 72px;
}
.vl-sidebar-header {
  display: flex;
  padding: 1.5rem;
  border-bottom: 1px solid #cbd2da;
  margin-top: 1px;
  min-height: 72px;
  align-items: center;
  background: #f7f9fc;
}
.vl-sidebar-header__toggle {
  margin-right: 1.5rem;
  padding-right: 1.5rem;
  border-right: 1px solid #cbd2da;
  cursor: pointer;
}
.vl-sidebar-header__title {
  margin: 0;
}
.vl-sidebar-panel-list-item__button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
  width: 100%;
  font-size: inherit;
  text-align: initial;
  border: none;
  line-height: inherit;
}
.vl-sidebar-panel-list-item__back-link {
  margin-right: 1.5rem;
}
.vl-sidebar-panel-list-item__link {
  border-bottom: 1px solid #cbd2da;
}
.vl-sidebar-accordion-list {
  margin: -1.8rem -1.5rem !important;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list {
  margin: -1.8rem 0 !important;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item:first-child {
  border-top: none;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item:last-child {
  border-bottom: none;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item.vl-accordion-list__item {
  padding: 0;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item--no-title .vl-accordion__summary {
  display: none;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__panel {
  padding: 1.5rem;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__panel:not(.vl-accordion__panel--with-footer) {
  padding-bottom: 1.5rem;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__summary {
  padding: 1.5rem;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__summary:focus {
  outline-offset: -3px;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__summary[aria-expanded=true] {
  border-bottom: 1px solid #cbd2da;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-sidebar-panel-list {
  padding: 0px;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-sidebar-panel-list .vl-sidebar-panel-list-item__content {
  padding: 0px;
}
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-accordion__image-container .vl-image--full-width {
  width: 100%;
  max-width: 100%;
  margin-top: -0px;
  margin-bottom: 0px;
}
@media screen and (max-width: 767px) {
.vl-sidebar-accordion-list .vl-sidebar-accordion-list-item .vl-accordion__wrapper .vl-accordion__content .vl-accordion__image-container .vl-image--full-width {
    width: 100%;
    max-width: 100%;
    margin-top: -0px;
    margin-bottom: 0px;
}
}
.vl-accordion__panel .vl-sidebar-panel-list-item__image-container .vl-image--full-width {
  margin-left: -2.2rem;
  width: calc(100% + 2.2rem * 2);
  max-width: calc(100% + 2.2rem * 2);
  margin-top: -2.2rem;
  margin-bottom: 2.2rem;
}
@media screen and (max-width: 767px) {
.vl-accordion__panel .vl-sidebar-panel-list-item__image-container .vl-image--full-width {
    margin-left: -1rem;
    width: calc(100% + 1rem * 2);
    max-width: calc(100% + 1rem * 2);
    margin-top: -1rem;
    margin-bottom: 1rem;
}
}
.vl-multiselect .multiselect__spinner {
  position: absolute;
  top: 1px;
  bottom: 1px;
  width: 32px;
  height: calc(100% - 2px);
  display: block;
  background: #fff;
}
.vl-multiselect .multiselect__spinner:after, .vl-multiselect .multiselect__spinner:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -8px 0 0 -8px;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-top-color: #b2b2b2;
  box-shadow: 0 0 0 1px transparent;
}
.vl-multiselect .multiselect__spinner:before {
  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
  animation-iteration-count: infinite;
}
.vl-multiselect .multiselect__spinner:after {
  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
  animation-iteration-count: infinite;
}
.vl-multiselect .multiselect__loading-enter-active, .vl-multiselect .multiselect__loading-leave-active {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}
.vl-multiselect .multiselect__loading-enter, .vl-multiselect .multiselect__loading-leave-active {
  opacity: 0;
}
.vl-multiselect .multiselect__spinner {
  right: 4px;
  left: auto;
}
@keyframes spinning {
0% {
    transform: rotate(0);
}
to {
    transform: rotate(2turn);
}
}
.vl-multiselect .multiselect,
.vl-multiselect .multiselect__input,
.vl-multiselect .multiselect__single {
  font-size: 1.6rem;
  touch-action: manipulation;
}
.vl-multiselect .multiselect--disabled {
  opacity: 0.6;
}
.vl-multiselect .multiselect--active {
  z-index: 10013;
}
.vl-multiselect .multiselect--active .multiselect__input {
  position: relative !important;
  border: 0.1rem solid #8695a8;
}
.vl-multiselect .multiselect--active .multiselect__tags {
  border-radius: 0.3rem 0.3rem 0 0;
  border-bottom: 1px solid #8695a8;
}
.vl-multiselect .multiselect {
  display: block;
  position: relative;
  max-width: 100%;
  text-decoration: none;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  -webkit-appearance: none;
}
.vl-multiselect .multiselect:focus::-ms-value {
  background: inherit;
  color: inherit;
}
.vl-multiselect .multiselect--active:not(.multiselect--above) .multiselect__current,
.vl-multiselect .multiselect--active:not(.multiselect--above) .multiselect__tags {
  padding: 6px 45px 0 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.vl-multiselect .multiselect--above--active .multiselect__current,
.vl-multiselect .multiselect--above--active .multiselect__input,
.vl-multiselect .multiselect--above--active .multiselect__tags {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.vl-multiselect .multiselect--above--active .multiselect__input {
  display: inline-block;
}
.vl-multiselect .multiselect--disabled {
  pointer-events: none;
}
.vl-multiselect .multiselect--disabled .multiselect__tags {
  border-color: #8695a8;
  background-color: #f3f5f6;
}
.vl-multiselect .multiselect__input {
  margin: 10px 5px 15px 2px;
  display: inline-block;
  background: #fff;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  color: #333332;
  max-width: 100%;
  height: 3.5rem;
  line-height: 3.5rem;
  border-radius: 0.3rem;
  border: 0;
  padding: 0 1rem;
  transition: background-color 0.2s;
}
@media screen and (max-width: 767px) {
.vl-multiselect .multiselect__input {
    font-size: 1.6rem;
}
}
.multiselect--active .vl-multiselect .multiselect__input:hover {
  border: 0.2rem solid rgba(0, 85, 204, 0.65);
  padding: 0 0.9rem;
}
.vl-multiselect .multiselect__input:hover.vl-input-field--error, .vl-multiselect .multiselect__input:hover.invalid.validated {
  border-color: #d2373c;
}
.vl-multiselect .multiselect__input:hover.vl-input-field--success {
  border-color: #009e47;
}
.vl-multiselect .multiselect__input:hover.vl-input-field--small {
  padding: 0 0.7rem;
}
.vl-multiselect .multiselect__input:focus, .vl-multiselect .multiselect__input--focus {
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65);
  outline: transparent solid 0.2rem;
}
@supports (outline-offset: 2px) {
.vl-multiselect .multiselect__input:focus, .vl-multiselect .multiselect__input--focus {
    box-shadow: none;
    outline: 3px solid rgba(0, 85, 204, 0.65);
    outline-offset: 2px;
}
}
.vl-multiselect .multiselect__input:focus, .vl-multiselect .multiselect__input--focus {
  border: 0.1rem solid #8695a8;
  padding: 0 1rem;
}
.vl-multiselect .multiselect__input:focus.vl-input-field--error, .vl-multiselect .multiselect__input:focus.invalid.validated, .vl-multiselect .multiselect__input--focus.vl-input-field--error, .vl-multiselect .multiselect__input--focus.invalid.validated {
  border-color: #d2373c;
}
.vl-multiselect .multiselect__input:focus.vl-input-field--success, .vl-multiselect .multiselect__input--focus.vl-input-field--success {
  border-color: #009e47;
}
.vl-multiselect .multiselect__input:focus:hover, .vl-multiselect .multiselect__input--focus:hover {
  padding: 0 1rem;
}
.vl-multiselect .multiselect__input:focus.vl-input-field--small, .vl-multiselect .multiselect__input--focus.vl-input-field--small {
  padding: 0 0.8rem;
}
.vl-multiselect .multiselect__input::-moz-placeholder {
  color: #687483;
}
.vl-multiselect .multiselect__input::placeholder {
  color: #687483;
}
.vl-multiselect .multiselect__input::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.vl-multiselect .multiselect__single {
  position: relative;
  display: inline-block;
  min-height: 20px;
  line-height: 20px;
  border: 0;
  border-radius: 5px;
  padding: 0 0 0 5px;
  margin-bottom: 8px;
  width: 100%;
  transition: border 0.1s ease;
  box-sizing: border-box;
  vertical-align: top;
  color: #687483;
}
.multiselect__tag ~ .vl-multiselect .multiselect__single {
  width: auto;
}
.vl-multiselect .multiselect__single:focus {
  outline: 0;
}
.vl-multiselect--single .multiselect__single {
  padding-top: 3px;
  min-height: 17px;
  line-height: 17px;
  color: #333332;
}
.vl-multiselect .multiselect__tags-wrap {
  display: inline;
}
.vl-multiselect .multiselect--active .multiselect__tags-wrap {
  margin: 0 -4px;
}
.vl-multiselect .multiselect__tags {
  min-height: 35px;
  display: block;
  padding: 6px 45px 0 6px;
  border: 1px solid #8695a8;
  background-color: #fff;
  font-size: 14px;
  border-radius: 3px;
}
.vl-multiselect .multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 4px 30px 4px 10px;
  border-radius: 0.3rem;
  margin-right: 6px;
  line-height: 1;
  background: #fff;
  margin-bottom: 5px;
  white-space: nowrap;
  max-width: 100%;
  text-overflow: ellipsis;
  color: #333332;
  font-family: "Flanders Art Sans", sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  vertical-align: middle;
  border: 1px solid #8695a8;
  transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
}
.vl-multiselect .multiselect__tag-icon::before, .vl-multiselect .multiselect__tag-icon::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
}
.vl-multiselect .multiselect__tag-icon::before {
  content: "\\f17f";
}
.vl-multiselect .multiselect__tag-icon {
  cursor: pointer;
  margin-left: 1.4rem;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  font-weight: 700;
  font-style: normal;
  width: 22px;
  text-align: center;
  line-height: 22px;
  transition: background-color 0.2s ease;
  border-left: 1px solid #8695a8;
  color: #05c;
  font-size: 0.8rem;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.vl-multiselect .multiselect__tag-icon:hover {
  color: #003bb0;
  box-shadow: inset 0 0 0 0.1rem #05c;
  border: #05c 0.1rem solid;
  background-color: rgb(90%, 93.3333333333%, 98%);
  top: -0.1rem;
  right: -0.1rem;
  bottom: -0.1rem;
  width: 22px;
  margin-left: 1.2rem;
}
.vl-multiselect .multiselect__tag-icon:focus {
  outline: transparent solid 0.2rem;
  border: #05c 0.1rem solid;
  box-shadow: 0 0 0 2px #fff, 0 0 0 5px rgba(0, 85, 204, 0.65), inset 0 0 0 0.1rem #05c;
  top: -0.1rem;
  right: -0.1rem;
  bottom: -0.1rem;
  width: 22px;
  margin-left: 1.3rem;
}
.vl-multiselect .multiselect__current {
  min-height: 40px;
  overflow: hidden;
  padding: 8px 12px 0;
  padding-right: 30px;
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid #e8ebee;
}
.vl-multiselect .multiselect__current,
.vl-multiselect .multiselect__select {
  line-height: 16px;
  box-sizing: border-box;
  display: block;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
}
.vl-multiselect .multiselect__select {
  position: absolute;
  width: 40px;
  right: 0;
  top: 0;
  height: 100%;
  padding: 4px 8px;
  text-align: center;
  transition: transform 0.2s ease;
}
.vl-multiselect .multiselect__select::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 9px 5px;
  background-position: calc(100% - 1.5rem) center;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  position: absolute;
  display: block;
  right: 0;
  top: 0;
  bottom: 0;
  content: "";
  width: 100%;
}
.vl-multiselect .multiselect__placeholder {
  display: inline-block;
  padding: 0 0 0 5px;
  color: #687483;
  font-family: "Flanders Art Sans", sans-serif;
  font-size: 1.6rem;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.multiselect--active .vl-multiselect .multiselect__placeholder {
  display: none;
}
.vl-multiselect .multiselect__content-wrapper {
  position: absolute;
  display: block;
  background: #fff;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #8695a8;
  border-top: 0;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
.vl-multiselect .multiselect__content {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: -1px 0;
  min-width: 100%;
  vertical-align: top;
}
.vl-multiselect .multiselect__content::webkit-scrollbar {
  display: none;
}
.vl-multiselect .multiselect--above .multiselect__content-wrapper {
  bottom: 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: none;
  border-top: 1px solid #f7f9fc;
}
.vl-multiselect .multiselect__element {
  display: block;
}
.vl-multiselect .multiselect__element:hover .multiselect__option {
  position: relative;
  border-top: 1px solid rgba(179, 207, 245, 0.3);
  border-bottom: 1px solid rgba(179, 207, 245, 0.3);
  box-shadow: 0 2px 0 #a1beec, 0px -2px 0 #a1beec;
  z-index: 2;
}
.vl-multiselect .multiselect__element:hover .multiselect__option--disabled {
  box-shadow: none;
}
.vl-multiselect .multiselect__option::before {
  content: "\\f15a";
}
.vl-multiselect .multiselect__option {
  display: block;
  position: relative;
  padding: 12px;
  padding-left: 40px;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  cursor: pointer;
  white-space: nowrap;
  border-top: 1px solid transparent;
  border-bottom: 1px solid #f7f9fc;
}
.vl-multiselect .multiselect__option::before {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: none;
  position: absolute;
  font-size: 12px;
  left: 0;
  width: 40px;
  text-align: center;
}
.vl-multiselect .multiselect__option::after {
  display: none;
  top: 0;
  right: 0;
  position: absolute;
  line-height: 40px;
  padding-right: 12px;
  padding-left: 20px;
  font-size: 13px;
}
.vl-multiselect .multiselect__option--highlight {
  background: rgba(179, 207, 245, 0.3);
  outline: none;
  color: #333332;
}
.vl-multiselect .multiselect__option--highlight::after {
  content: attr(data-select);
  color: #333332;
}
.vl-multiselect .multiselect__option--selected {
  background: #fff;
}
.vl-multiselect .multiselect__option--selected.multiselect__option--highlight {
  background: rgba(179, 207, 245, 0.3);
  outline: none;
  color: #333332;
}
.vl-multiselect .multiselect__option--selected::before {
  display: block;
}
.vl-multiselect .multiselect__option--selected::after {
  content: attr(data-selected);
  color: #333332;
}
.vl-multiselect .multiselect__option--disabled {
  background: #e8ebee;
  color: #b2b2b2;
  cursor: text;
  pointer-events: none;
}
.vl-multiselect .multiselect__option--disabled.multiselect__option--highlight {
  background: #d3d9e0;
}
.vl-multiselect .multiselect__option--group {
  background: #687483;
  color: #fff;
}
.vl-multiselect .multiselect__option--group.multiselect__option--highlight {
  background: rgb(36.3587818106%, 40.5540258657%, 45.7980809345%);
  color: #fff;
}
.vl-multiselect .multiselect__option--group.multiselect__option--highlight::after {
  display: block;
  content: attr(data-select);
  background: rgb(36.3587818106%, 40.5540258657%, 45.7980809345%);
  color: #fff;
}
.vl-multiselect .multiselect__option--group-selected.multiselect__option--highlight {
  background: rgb(31.9332498957%, 35.6178556529%, 40.2236128494%);
  color: #fff;
}
.vl-multiselect .multiselect__option--group-selected.multiselect__option--highlight::after {
  display: block;
  content: attr(data-deselect);
  background: rgb(31.9332498957%, 35.6178556529%, 40.2236128494%);
  color: #fff;
}
.vl-multiselect .multiselect__strong {
  margin-bottom: 8px;
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
}
.vl-multiselect [dir=rtl] .multiselect {
  text-align: right;
}
.vl-multiselect [dir=rtl] .multiselect__select {
  right: auto;
  left: 1px;
}
.vl-multiselect [dir=rtl] .multiselect__tags {
  padding: 8px 8px 0 40px;
}
.vl-multiselect [dir=rtl] .multiselect__content {
  text-align: right;
}
.vl-multiselect [dir=rtl] .multiselect__option::after {
  right: auto;
  left: 0;
}
.vl-multiselect [dir=rtl] .multiselect__clear {
  right: auto;
  left: 12px;
}
.vl-multiselect--error .multiselect__current, .vl-multiselect--error .multiselect__tags, .vl-multiselect.invalid.validated .multiselect__current, .vl-multiselect.invalid.validated .multiselect__tags {
  border-color: #d2373c;
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-multiselect--success .multiselect__current, .vl-multiselect--success .multiselect__tags, .vl-multiselect.valid.validated .multiselect__current, .vl-multiselect.valid.validated .multiselect__tags {
  border-color: #009e47;
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-u-visually-hidden {
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  margin: -1px;
  padding: 0;
  border: 0;
  left: 0;
  top: 0;
}
@media screen and (min-width: 1023px) {
.vl-u-visually-hidden--l {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@media screen and (max-width: 1023px) {
.vl-u-visually-hidden--m {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@media screen and (max-width: 767px) {
.vl-u-visually-hidden--s {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@media screen and (max-width: 500px) {
.vl-u-visually-hidden--xs {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    margin: -1px;
    padding: 0;
    border: 0;
    left: 0;
    top: 0;
}
}
@keyframes fade-transition {
0% {
    transform: translateY(20px);
    opacity: 0;
}
100% {
    transform: translateY(0);
    opacity: 1;
}
}
@keyframes bounce {
0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
}
40% {
    transform: translateY(-12px);
}
60% {
    transform: translateY(-5px);
}
90% {
    transform: translateY(-2px);
}
}
.vl-u-align-left {
  text-align: left !important;
}
.vl-u-align-center {
  text-align: center !important;
}
.vl-u-align-right {
  text-align: right !important;
}
@media screen and (min-width: 1023px) {
.vl-u-align-left--l {
    text-align: left !important;
}
.vl-u-align-center--l {
    text-align: center !important;
}
.vl-u-align-right--l {
    text-align: right !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-align-left--m {
    text-align: left !important;
}
.vl-u-align-center--m {
    text-align: center !important;
}
.vl-u-align-right--m {
    text-align: right !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-align-left--s {
    text-align: left !important;
}
.vl-u-align-center--s {
    text-align: center !important;
}
.vl-u-align-right--s {
    text-align: right !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-align-left--xs {
    text-align: left !important;
}
.vl-u-align-center--xs {
    text-align: center !important;
}
.vl-u-align-right--xs {
    text-align: right !important;
}
}
.vl-u-flex-v-left,
.vl-u-flex-v-flex-start {
  align-items: flex-start !important;
}
.vl-u-flex-v-center {
  align-items: center !important;
}
.vl-u-flex-v-right,
.vl-u-flex-v-flex-end {
  align-items: flex-end !important;
}
.vl-u-flex-v-baseline {
  align-items: baseline !important;
}
.vl-u-flex-v-stretch {
  align-items: stretch !important;
}
.vl-u-flex-align-top,
.vl-u-flex-align-flex-start {
  justify-content: flex-start !important;
}
.vl-u-flex-align-center {
  justify-content: center !important;
}
.vl-u-flex-align-bottom,
.vl-u-flex-align-flex-end {
  justify-content: flex-end !important;
}
.vl-u-flex-align-space-between {
  justify-content: space-between !important;
}
.vl-u-flex-align-space-around {
  justify-content: space-around !important;
}
.vl-u-flex-direction-row {
  flex-direction: row !important;
}
.vl-u-flex-direction-column {
  flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse {
  flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse {
  flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap {
  flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap {
  flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
@media screen and (min-width: 1023px) {
.vl-u-flex-align-left--l {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--l,
  .vl-u-flex-align-flex-start--l {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--l {
    align-items: center !important;
}
.vl-u-flex-align-right--l,
  .vl-u-flex-align-flex-end--l {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--l {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--l {
    align-items: stretch !important;
}
.vl-u-flex-v-top--l,
  .vl-u-flex-v-flex-start--l {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--l {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--l,
  .vl-u-flex-v-flex-end--l {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--l {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--l {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--l {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--l {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--l {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--l {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--l {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--l {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--l {
    flex-wrap: wrap-reverse !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-flex-align-left--m {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--m,
  .vl-u-flex-align-flex-start--m {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--m {
    align-items: center !important;
}
.vl-u-flex-align-right--m,
  .vl-u-flex-align-flex-end--m {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--m {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--m {
    align-items: stretch !important;
}
.vl-u-flex-v-top--m,
  .vl-u-flex-v-flex-start--m {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--m {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--m,
  .vl-u-flex-v-flex-end--m {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--m {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--m {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--m {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--m {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--m {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--m {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--m {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--m {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--m {
    flex-wrap: wrap-reverse !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-flex-align-left--s {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--s,
  .vl-u-flex-align-flex-start--s {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--s {
    align-items: center !important;
}
.vl-u-flex-align-right--s,
  .vl-u-flex-align-flex-end--s {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--s {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--s {
    align-items: stretch !important;
}
.vl-u-flex-v-top--s,
  .vl-u-flex-v-flex-start--s {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--s {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--s,
  .vl-u-flex-v-flex-end--s {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--s {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--s {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--s {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--s {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--s {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--s {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--s {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--s {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--s {
    flex-wrap: wrap-reverse !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-flex-align-left--xs {
    align-items: flex-start !important;
}
.vl-u-flex-align-left--xs,
  .vl-u-flex-align-flex-start--xs {
    align-items: flex-start !important;
}
.vl-u-flex-align-center--xs {
    align-items: center !important;
}
.vl-u-flex-align-right--xs,
  .vl-u-flex-align-flex-end--xs {
    align-items: flex-end !important;
}
.vl-u-flex-align-baseline--xs {
    align-items: baseline !important;
}
.vl-u-flex-align-stretch--xs {
    align-items: stretch !important;
}
.vl-u-flex-v-top--xs,
  .vl-u-flex-v-flex-start--xs {
    justify-content: flex-start !important;
}
.vl-u-flex-v-center--xs {
    justify-content: center !important;
}
.vl-u-flex-v-bottom--xs,
  .vl-u-flex-v-flex-end--xs {
    justify-content: flex-end !important;
}
.vl-u-flex-v-space-between--xs {
    justify-content: space-between !important;
}
.vl-u-flex-v-space-around--xs {
    justify-content: space-around !important;
}
.vl-u-flex-direction-row--xs {
    flex-direction: row !important;
}
.vl-u-flex-direction-column--xs {
    flex-direction: column !important;
}
.vl-u-flex-direction-row-reverse--xs {
    flex-direction: row-reverse !important;
}
.vl-u-flex-direction-column-reverse--xs {
    flex-direction: column-reverse !important;
}
.vl-u-flex-wrap-wrap--xs {
    flex-wrap: wrap !important;
}
.vl-u-flex-wrap-nowrap--xs {
    flex-wrap: nowrap !important;
}
.vl-u-flex-wrap-reverse--xs {
    flex-wrap: wrap-reverse !important;
}
}
.vl-u-bg {
  background-color: #fff;
}
.vl-u-bg-alt {
  background-color: #f7f9fc;
}
.vl-u-bg-error {
  background-color: rgb(98.2352941176%, 92.1568627451%, 92.3529411765%);
}
.vl-u-bg-warning {
  background-color: rgb(100%, 96.3137254902%, 90.3921568627%);
}
.vl-u-bg-success {
  background-color: rgb(90%, 96.1960784314%, 92.7843137255%);
}
.vl-u-border {
  padding-left: 3.5rem;
  position: relative;
}
@media screen and (max-width: 767px) {
.vl-u-border {
    padding-left: 1.75rem;
}
}
.vl-u-border:after {
  content: "";
  width: 0.5rem;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background: var(--vl-theme-primary-color);
}
.vl-u-border.vl-grid:after {
  height: 100%;
  bottom: 0;
  top: auto;
  left: 3rem;
}
@media screen and (max-width: 767px) {
.vl-u-border.vl-grid:after {
    left: 1.5rem;
}
}
.vl-u-border.vl-grid--is-stacked:after {
  height: calc(100% - 3rem);
}
@media screen and (max-width: 767px) {
.vl-u-border.vl-grid--is-stacked:after {
    height: calc(100% - 1.5rem);
}
}
.vl-u-highlight-content {
  padding: 4.1666666667%;
  border: 1px #cbd2da solid;
}
.vl-u-highlight-content--alt {
  background: #f7f9fc;
  border: none;
}
button.vl-vi {
  border: 0;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  padding: 0;
  outline: none;
}
a.vl-vi {
  text-decoration: none;
}
.vl-vi.vl-vi-u-hidden-text {
  font-size: 0;
}
.vl-vi.vl-vi-u-xs::before {
  font-size: 0.8rem;
}
.vl-vi.vl-vi-u-s::before {
  font-size: 1.3rem;
}
.vl-vi.vl-vi-u-m::before {
  font-size: 1.7rem;
}
.vl-vi.vl-vi-u-l::before {
  font-size: 2rem;
}
.vl-vi.vl-vi-u-xl::before {
  font-size: 2.2rem;
}
.vl-vi.vl-vi-u-90deg::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi.vl-vi-u-180deg::before {
  display: inline-block;
  transform: rotate(180deg);
}
.vl-vi.vl-vi-u-link::before {
  display: inline-block;
  margin-right: 1rem;
  color: #000;
  font-size: 1.3rem;
  text-decoration: none;
}
.vl-vi.vl-vi-u-color-grey {
  color: #cbd2da;
}
.vl-vi.vl-vi-u-badge {
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-badge::before {
  margin: 0;
  vertical-align: middle;
  display: block;
}
.vl-vi.vl-vi-u-badge--link {
  margin-right: 1rem;
}
.vl-vi.vl-vi-u-badge--link-after {
  margin-left: 1rem;
}
.vl-vi.vl-vi-u-badge--positive {
  background-color: #007a37;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--positive:hover, .vl-vi.vl-vi-u-badge--positive:focus, a:hover .vl-vi.vl-vi-u-badge--positive, a:focus .vl-vi.vl-vi-u-badge--positive {
  background-color: #009e47;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--action {
  background-color: #05c;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--action:hover, .vl-vi.vl-vi-u-badge--action:focus, a:hover .vl-vi.vl-vi-u-badge--action, a:focus .vl-vi.vl-vi-u-badge--action {
  background-color: #003bb0;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--negative {
  background-color: #d2373c;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--negative:hover, .vl-vi.vl-vi-u-badge--negative:focus, a:hover .vl-vi.vl-vi-u-badge--negative, a:focus .vl-vi.vl-vi-u-badge--negative {
  background-color: #aa2729;
  color: #fff;
}
.vl-vi.vl-vi-u-badge--warning {
  background-color: #ffA10a;
  color: #333332;
}
.vl-vi.vl-vi-u-badge--neutral {
  background-color: #f7f9fc;
  color: #333332;
}
.vl-vi.vl-vi-u-badge--neutral:hover, .vl-vi.vl-vi-u-badge--neutral:focus, a:hover .vl-vi.vl-vi-u-badge--neutral, a:focus .vl-vi.vl-vi-u-badge--neutral {
  background-color: #05c;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--light {
  background-color: #fff;
  color: #333332;
}
.vl-vi.vl-vi-u-badge--light:hover, .vl-vi.vl-vi-u-badge--light:focus, a:hover .vl-vi.vl-vi-u-badge--light, a:focus .vl-vi.vl-vi-u-badge--light {
  background-color: #05c;
  color: rgb(90%, 93.3333333333%, 98%);
}
.vl-vi.vl-vi-u-badge--xxsmall {
  width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
}
.vl-vi.vl-vi-u-badge--xxsmall::before {
  font-size: 0.8rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--xxsmall {
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
}
.vl-vi.vl-vi-u-badge--xxsmall::before {
    font-size: 0.7rem;
}
}
.vl-vi.vl-vi-u-badge--xsmall {
  width: 1.8rem;
  height: 1.8rem;
  line-height: 1.8rem;
}
.vl-vi.vl-vi-u-badge--xsmall::before {
  font-size: 1.3rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--xsmall {
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
}
.vl-vi.vl-vi-u-badge--xsmall::before {
    font-size: 1.1rem;
}
}
.vl-vi.vl-vi-u-badge--small {
  width: 2.6rem;
  height: 2.6rem;
  line-height: 2.6rem;
}
.vl-vi.vl-vi-u-badge--small::before {
  font-size: 1.3rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--small {
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
}
.vl-vi.vl-vi-u-badge--small::before {
    font-size: 1.2rem;
}
}
.vl-vi.vl-vi-u-badge--medium {
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
}
.vl-vi.vl-vi-u-badge--medium::before {
  font-size: 2rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--medium {
    width: 3rem;
    height: 3rem;
    line-height: 3rem;
}
.vl-vi.vl-vi-u-badge--medium::before {
    font-size: 1.5rem;
}
}
.vl-vi.vl-vi-u-badge--large {
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
}
.vl-vi.vl-vi-u-badge--large::before {
  font-size: 2.5rem;
}
@media screen and (max-width: 767px) {
.vl-vi.vl-vi-u-badge--large {
    width: 4rem;
    height: 4rem;
    line-height: 4rem;
}
.vl-vi.vl-vi-u-badge--large::before {
    font-size: 2rem;
}
}
.vl-u-mark {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(255, 197, 21, 0.3);
}
.vl-u-mark--accent {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(var(--vl-theme-primary-color-rgb, 255, 230, 21), 0.3);
}
.vl-u-mark--info {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(203, 210, 218, 0.4);
}
.vl-u-mark--success {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(0, 158, 71, 0.2);
}
.vl-u-mark--warning {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(255, 161, 10, 0.2);
}
.vl-u-mark--error {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(210, 55, 60, 0.2);
}
@media screen and (max-width: 767px) {
.vl-u-mobile-no-equal-height {
    min-height: 0 !important;
}
}
.js-vl-clamp-useless {
  display: none !important;
}
.js .js-vl-show-checked {
  display: none;
}
.js .js-vl-show-checked--open {
  display: block;
}
.js.vl-flexbox .js-vl-col-float-right {
  position: absolute;
  z-index: 1;
  padding-bottom: 3rem;
  right: 0;
}
@media screen and (max-width: 767px) {
.js.vl-flexbox .js-vl-col-float-right {
    position: static;
    padding-bottom: 0;
    margin-top: 1.5rem;
}
}
@media screen and (max-width: 767px) {
.js-vl-col-float-right--pushed {
    margin-top: 0 !important;
}
}
[data-vl-show-on-select-content] {
  display: none;
}
[data-vl-show-on-select-content][data-vl-show=true] {
  display: block;
}
.vl-u-offset--spacing {
  padding: 0 4.1666666667% 1rem;
}
.vl-u-offset--left {
  margin-left: 3rem;
}
@media screen and (min-width: 1600px) {
.vl-u-offset--left {
    margin-left: -4.1666666667%;
}
}
@media screen and (max-width: 1023px) {
.vl-u-offset--left {
    margin-left: 0;
    margin-right: 0;
}
}
.vl-u-offset--left.vl-u-offset--spacing {
  padding-left: 0;
}
.vl-u-offset--right {
  margin-right: 3rem;
}
@media screen and (min-width: 1600px) {
.vl-u-offset--right {
    margin-right: -4.1666666667%;
}
}
@media screen and (max-width: 1023px) {
.vl-u-offset--right {
    margin-left: 0;
    margin-right: 0;
}
}
.vl-u-offset--right.vl-u-offset--spacing {
  padding-right: 0;
}
.vl-u-float-right {
  float: right !important;
}
.vl-u-float-left {
  float: left !important;
}
.vl-u-float-none {
  float: none !important;
}
.vl-u-display-block {
  display: block !important;
}
.vl-u-display-inline-block {
  display: inline-block !important;
}
.vl-u-display-flex,
.vl-u-flex {
  display: flex !important;
}
.vl-u-display-inline-flex {
  display: inline-flex !important;
}
.vl-u-clearfix::before, .vl-u-clearfix::after {
  content: "";
  display: table;
}
.vl-u-clearfix::after {
  clear: both;
}
.vl-u-no-overflow {
  overflow: hidden;
}
.vl-u-position-relative {
  position: relative;
}
.vl-u-named-target::before,
.vl-u-offset::before {
  content: "";
  display: block;
  height: -90px;
  margin: 90px 0 0;
  z-index: -1;
  position: relative;
}
.vl-u-named-target-wrapper {
  position: relative;
}
.vl-u-named-target-dummy:empty,
.vl-u-offset-dummy:empty {
  display: block;
  position: absolute;
  top: 0;
  margin-top: 90px;
  height: 1px;
  width: 1px;
  visibility: hidden;
  opacity: 0;
}
.vl-u-inline-list {
  display: inline-block;
  vertical-align: top;
}
@media print {
.vl-u-hide-on-print {
    display: none;
}
.vl-u-show-on-print {
    display: block;
}
header,
  footer {
    display: none;
}
.vl-main-content header, [role=main] header, main header,
  .vl-main-content footer,
  [role=main] footer,
  main footer {
    display: block;
}
.iwgh3,
  .iwgh2,
  .iwgf3,
  .iwgf2 {
    display: none;
}
}
.vl-u-hr {
  border: 0;
  border-bottom: 1px solid #cbd2da;
  margin-top: 0;
  margin-bottom: 0;
}
.vl-u-hr--wave {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) repeat-x;
  background-size: 20px 4px;
  height: 4px;
  border-bottom: 0;
}
.vl-u-hr--dashed {
  min-height: 6px;
  border: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
  background-size: 6px 6px;
}
::-moz-selection {
  background-color: var(--vl-theme-primary-color-rgba-30);
}
::selection {
  background-color: var(--vl-theme-primary-color-rgba-30);
}
::-moz-selection {
  background-color: var(--vl-theme-primary-color-rgba-30);
}
.vl-u-spacer {
  margin-bottom: 2rem;
}
.vl-u-spacer--xsmall {
  margin-bottom: 1rem;
}
.vl-u-spacer--small {
  margin-bottom: 1.5rem;
}
.vl-u-spacer--medium {
  margin-bottom: 3rem;
}
.vl-u-spacer--large {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer--large {
    margin-bottom: 3rem;
}
}
.vl-u-spacer--none {
  margin-bottom: 0;
}
.vl-u-spacer-top {
  margin-top: 2rem;
}
.vl-u-spacer-top--xsmall {
  margin-top: 1rem;
}
.vl-u-spacer-top--small {
  margin-top: 1.5rem;
}
.vl-u-spacer-top--medium {
  margin-top: 3rem;
}
.vl-u-spacer-top--large {
  margin-top: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-top--large {
    margin-top: 3rem;
}
}
.vl-u-spacer-top--none {
  margin-top: 0;
}
.vl-u-spacer-right {
  margin-right: 2rem;
}
.vl-u-spacer-right--xsmall {
  margin-right: 1rem;
}
.vl-u-spacer-right--small {
  margin-right: 1.5rem;
}
.vl-u-spacer-right--medium {
  margin-right: 3rem;
}
.vl-u-spacer-right--large {
  margin-right: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-right--large {
    margin-right: 3rem;
}
}
.vl-u-spacer-right--none {
  margin-right: 0;
}
.vl-u-spacer-bottom {
  margin-bottom: 2rem;
}
.vl-u-spacer-bottom--xsmall {
  margin-bottom: 1rem;
}
.vl-u-spacer-bottom--small {
  margin-bottom: 1.5rem;
}
.vl-u-spacer-bottom--medium {
  margin-bottom: 3rem;
}
.vl-u-spacer-bottom--large {
  margin-bottom: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-bottom--large {
    margin-bottom: 3rem;
}
}
.vl-u-spacer-bottom--none {
  margin-bottom: 0;
}
.vl-u-spacer-left {
  margin-left: 2rem;
}
.vl-u-spacer-left--xsmall {
  margin-left: 1rem;
}
.vl-u-spacer-left--small {
  margin-left: 1.5rem;
}
.vl-u-spacer-left--medium {
  margin-left: 3rem;
}
.vl-u-spacer-left--large {
  margin-left: 6rem;
}
@media screen and (max-width: 767px) {
.vl-u-spacer-left--large {
    margin-left: 3rem;
}
}
.vl-u-spacer-left--none {
  margin-left: 0;
}
.vl-u-scroll-offset__parent {
  position: relative;
  height: 0;
  width: 0;
  overflow: hidden;
  opacity: 0;
}
.vl-u-scroll-offset {
  position: absolute;
  left: 0;
  top: 0;
  margin-top: -90px;
  width: 1px;
  height: 1px;
}
.js-vl-sticky-placeholder {
  position: relative;
}
@media screen and (max-width: 767px) {
.js-vl-sticky-placeholder {
    height: auto !important;
}
}
.js-vl-sticky--absolute {
  position: absolute;
}
.js-vl-sticky--fixed {
  position: fixed;
}
.vl-u-sticky {
  top: 0;
  position: sticky;
}
.vl-u-sticky-gf {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
.vl-u-sticky-gf {
    display: block;
}
}
.vl-u-sticky-gf .vl-page {
  flex: 1;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
.vl-u-sticky-gf .vl-page {
    overflow: hidden;
}
}
.vl-u-text--ellipse {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vl-u-text--uppercase {
  text-transform: uppercase;
}
.vl-u-text--lowercase {
  text-transform: lowercase;
}
.vl-u-text--capitalize::first-letter {
  text-transform: uppercase;
}
.vl-u-text--success {
  color: #007a37;
}
.vl-u-text--warning {
  color: #9f5804;
}
.vl-u-text--error {
  color: #d2373c;
}
.vl-u-text--bold, .vl-progress-bar__step--active .vl-progress-bar__bullet__text {
  font-weight: 500;
}
.vl-u-text--italic {
  font-style: italic;
}
.vl-u-text--small {
  font-size: 1.4rem !important;
}
.vl-u-text--medium {
  font-size: 1.6rem !important;
}
.vl-u-text--xsmall {
  font-size: 1.2rem !important;
}
.vl-u-text--xxsmall {
  font-size: 1rem !important;
}
mark,
.vl-u-text--marked {
  background-color: transparent;
  box-shadow: inset 0 -10px 0 0 rgba(255, 197, 21, 0.3);
}
@media screen and (min-width: 1023px) {
.vl-u-visible--l {
    display: block !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-visible--m {
    display: block !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-visible--s {
    display: block !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-visible--xs {
    display: block !important;
}
}
.vl-u-hidden {
  display: none;
}
@media screen and (min-width: 1023px) {
.vl-u-hidden--l {
    display: none !important;
}
}
@media screen and (max-width: 1023px) {
.vl-u-hidden--m {
    display: none !important;
}
}
@media screen and (max-width: 767px) {
.vl-u-hidden--s {
    display: none !important;
}
}
@media screen and (max-width: 500px) {
.vl-u-hidden--xs {
    display: none !important;
}
}
.vl-u-whitespace {
  white-space: normal;
}
.vl-u-whitespace--nowrap {
  white-space: nowrap;
}
.vl-u-whitespace--pre {
  white-space: pre;
}
.vl-u-whitespace--pre-line {
  white-space: pre-line;
}
.vl-u-whitespace--pre-wrap {
  white-space: prewrap;
}
.vl-u-whitespace--unset {
  white-space: unset;
}
.vl-u-whitespace--break-spaces {
  white-space: break-spaces;
}
body a:visited {
  color: #05c;
}
body {
  font-size: 1.6rem !important;
}
a.ippro-datatable__cell:visited {
  color: #333332;
}
.vl-title {
  word-break: break-word;
  word-wrap: break-word;
}
.vl-ol-map-search .vl-input-field {
  width: 335px !important;
}
.vl-tooltip {
  pointer-events: none;
}
.vl-button:not(:disabled):not(.vl-button--disabled) {
  cursor: pointer;
}
.vl-button.vl-button--text {
  border: 0;
  background-color: transparent;
}
.vl-button.vl-button--text:hover {
  border: 0;
  box-shadow: none;
  text-decoration: underline;
}
button.vl-vi {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 3.5rem;
  height: 3.5rem;
  line-height: 3.5rem;
}
.vl-accordion__panel {
  padding: 0 0 0 2.1rem;
  margin: 1rem 0 2rem 0;
}
.vl-accordion-list__item {
  margin-bottom: 1rem;
}
.vl-accordion-list__item:last-child {
  margin-bottom: 0;
}
.vl-toggle.vl-link, .vl-toggle.vl-sidebar-header__toggle, .vl-sidebar-panel-list-item__button .vl-toggle.vl-icon {
  text-decoration: none;
}
.vl-toggle.vl-link:hover, .vl-toggle.vl-sidebar-header__toggle:hover, .vl-sidebar-panel-list-item__button .vl-toggle.vl-icon:hover {
  text-decoration: underline;
}
.vl-tab__pane {
  outline: none;
}
.vl-progress-bar__step--disabled .vl-progress-bar__bullet {
  cursor: default;
}
.vl-progress-bar__step--disabled .vl-progress-bar__bullet:focus {
  outline: none;
}
.vl-tab__pane {
  outline: none;
}
.vl-upload__files__close {
  display: none;
}
.vl-modal--fullscreen .vl-modal-dialog[open] {
  width: calc(100vw - 40px);
  max-width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  max-height: calc(100vh - 40px);
  overflow: visible;
}
.vl-modal--fullscreen .vl-modal-dialog[open] .ippro-map .vl-ol-map--boxed {
  height: calc(100vh - 22rem);
}
.js-vl-select .vl-input-field {
  height: 24px;
  line-height: 2.3rem;
}
.js-vl-select {
  position: inherit;
}
.js-vl-select.is-open.is-focused {
  z-index: 2000 !important;
  position: relative;
}
.vl-text--alt {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  display: block;
}
.ippro-datatable th button span.vl-icon {
  margin-top: -0.8em !important;
}
.vl-sidebar__btn-close {
  display: flex;
  position: absolute;
  right: 0.5rem;
  top: 0;
  z-index: 9999;
}
.vl-sidebar__close-btn {
  display: none;
}
.vl-input-field::-moz-placeholder {
  color: #d3d9e0;
}
.vl-input-field::placeholder {
  color: #d3d9e0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
